import { __decorate, __metadata, __param } from 'tslib';
import { Renderer2, ElementRef, Input, Component, Directive, NgModule, Injectable, ViewContainerRef, ViewChild, TemplateRef, EventEmitter, Output, forwardRef, ɵɵdefineInjectable, ViewChildren, QueryList, ContentChildren, Optional, Self, HostListener, ChangeDetectorRef, ChangeDetectionStrategy, ContentChild, ɵɵinject, NgZone, Pipe, HostBinding, ComponentFactoryResolver, ApplicationRef, Injector, INJECTOR } from '@angular/core';
import { Subject, BehaviorSubject, merge, fromEvent, EMPTY, combineLatest, Subscription } from 'rxjs';
import { ESCAPE, hasModifierKey, TAB, SPACE, ENTER, DOWN_ARROW, UP_ARROW } from '@angular/cdk/keycodes';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { Platform, PlatformModule } from '@angular/cdk/platform';
import { TemplatePortal } from '@angular/cdk/portal';
import { mapTo, switchMap, filter, map, auditTime, distinctUntilChanged, takeUntil, throttleTime, startWith, takeWhile, tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, NgControl, AbstractControl, NgModel, FormControlName, FormControlDirective, FormsModule, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/cdk/overlay';
import * as ɵngcc3 from '@angular/cdk/platform';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@angular/router';

const _c0 = ["nm-button", ""];
const _c1 = ["*"];
const _c2 = ["nm-button-back", ""];
function NmDropDownMenu_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵlistener("mouseenter", function NmDropDownMenu_ng_template_0_Template_div_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r1.setMouseState(true)); })("mouseleave", function NmDropDownMenu_ng_template_0_Template_div_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.setMouseState(false)); });
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("ngClass", "full-width");
} }
const _c3 = ["switchElement"];
function NmTabItem_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
const _c4 = ["slideTab"];
const _c5 = ["tabElement"];
function NmTabsGroup_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 5, 6);
    ɵngcc0.ɵɵlistener("click", function NmTabsGroup_li_2_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const tab_r2 = restoredCtx.$implicit; const _r3 = ɵngcc0.ɵɵreference(1); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.selectTab(tab_r2, _r3)); });
    ɵngcc0.ɵɵelementStart(2, "a");
    ɵngcc0.ɵɵelementContainer(3, 7);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const tab_r2 = ctx.$implicit;
    ɵngcc0.ɵɵclassProp("active", tab_r2._active);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", tab_r2.templateRef);
} }
const _c6 = ["swipezone"];
function NmOptionComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
const _c7 = ["inputElement"];
function NmOptionWrap_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("table-select__option-wrap", ctx_r0.tableSelect);
} }
const _c8 = ["hiddenInput"];
function NmSelectComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.placeholder, " ");
} }
function NmSelectComponent_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.selectedOption == null ? null : ctx_r7.selectedOption.label, " ");
} }
function NmSelectComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, NmSelectComponent_div_5_div_1_Template, 2, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("opacity", ctx_r2.isSearch && ctx_r2.isOpen ? 0.4 : 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.selectedOption == null ? null : ctx_r2.selectedOption.value);
} }
function NmSelectComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 13);
} }
function NmSelectComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13)(1, "nm-select-search", 14);
    ɵngcc0.ɵɵlistener("valueChange", function NmSelectComponent_div_7_Template_nm_select_search_valueChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r8.onInputValueChange($event)); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.disabled)("value", ctx_r4.selectedOption == null ? null : ctx_r4.selectedOption.label)("showInput", ctx_r4.isOpen && ctx_r4.isSearch)("focusTrigger", ctx_r4.isOpen);
} }
function NmSelectComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15)(1, "i");
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 16);
    ɵngcc0.ɵɵelement(3, "path", 17);
    ɵngcc0.ɵɵelementEnd()()();
} }
function NmSelectComponent_div_10_ng_template_1_Template(rf, ctx) { }
function NmSelectComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵlistener("click", function NmSelectComponent_div_10_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const item_r10 = restoredCtx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r12.onItemClick(item_r10)); });
    ɵngcc0.ɵɵtemplate(1, NmSelectComponent_div_10_ng_template_1_Template, 0, 0, "ng-template", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("option__active", (ctx_r6.selectedOption == null ? null : ctx_r6.selectedOption.value) === item_r10.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r10.template);
} }
function NmFormItemComponent_div_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵtext(1, "*");
    ɵngcc0.ɵɵelementEnd();
} }
function NmFormItemComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5)(1, "label");
    ɵngcc0.ɵɵtemplate(2, NmFormItemComponent_div_0_span_2_Template, 2, 0, "span", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.required);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.label, "");
} }
function NmFormItemComponent_span_2_ng_template_1_Template(rf, ctx) { }
function NmFormItemComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtemplate(1, NmFormItemComponent_span_2_ng_template_1_Template, 0, 0, "ng-template", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.prefix);
} }
function NmFormItemComponent_span_4_ng_template_1_Template(rf, ctx) { }
function NmFormItemComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtemplate(1, NmFormItemComponent_span_4_ng_template_1_Template, 0, 0, "ng-template", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.suffix);
} }
function NmFormItemComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 11);
    ɵngcc0.ɵɵelement(2, "path", 12);
    ɵngcc0.ɵɵelementEnd()();
} }
function NmFormItemComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 13);
    ɵngcc0.ɵɵelement(2, "path", 14)(3, "path", 15)(4, "path", 16);
    ɵngcc0.ɵɵelementEnd()();
} }
function NmFormItemComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.alertTip);
} }
function NmInputGroupComponent_ng_template_0_ng_template_0_Template(rf, ctx) { }
function NmInputGroupComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NmInputGroupComponent_ng_template_0_ng_template_0_Template, 0, 0, "ng-template", 3);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function NmInputGroupComponent_ng_template_1_ng_template_0_Template(rf, ctx) { }
function NmInputGroupComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NmInputGroupComponent_ng_template_1_ng_template_0_Template, 0, 0, "ng-template", 3);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function NmInputGroupComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
const _c9 = ["counterField"];
const _c10 = ["pinpadSection"];
function NmPinCodeComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const index_r4 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("pin__dot_filled", index_r4 + 1 <= ctx_r1.pinValue.length);
} }
function NmPinCodeComponent_ng_container_8_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function NmPinCodeComponent_ng_container_8_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const padValue_r5 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r8.editPinValue(padValue_r5)); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const padValue_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("color", ctx_r6.buttonColor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", padValue_r5, " ");
} }
function NmPinCodeComponent_ng_container_8_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function NmPinCodeComponent_ng_container_8_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const padValue_r5 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r12.editPinValue(padValue_r5)); });
    ɵngcc0.ɵɵelement(1, "nm-svg-loader", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("iconName", ctx_r7.icons.eraseMiddleDarkGray);
} }
function NmPinCodeComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NmPinCodeComponent_ng_container_8_button_1_Template, 2, 2, "button", 8);
    ɵngcc0.ɵɵtemplate(2, NmPinCodeComponent_ng_container_8_button_2_Template, 2, 1, "button", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const padValue_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", padValue_r5 !== undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", padValue_r5 === undefined);
} }
const _c11 = ["nm-table-content", ""];
function NmTableContentComponent_thead_0_ng_template_1_Template(rf, ctx) { }
function NmTableContentComponent_thead_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "thead", 2);
    ɵngcc0.ɵɵtemplate(1, NmTableContentComponent_thead_0_ng_template_1_Template, 0, 0, "ng-template", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.theadTemplate);
} }
function NmTableContentComponent_ng_template_1_Template(rf, ctx) { }
const _c12 = ["tableBodyElement"];
function NmTableInnerScrollComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4, 5);
    ɵngcc0.ɵɵelement(2, "table", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("listOfColWidth", ctx_r0.listOfColWidth)("theadTemplate", ctx_r0.theadTemplate);
} }
function NmTableInnerScrollComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7, 8);
    ɵngcc0.ɵɵelement(2, "table", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("listOfColWidth", ctx_r1.listOfColWidth)("theadTemplate", ctx_r1.scrollY ? null : ctx_r1.theadTemplate)("contentTemplate", ctx_r1.contentTemplate);
} }
function NmTableInnerScrollComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10, 8);
    ɵngcc0.ɵɵelement(2, "table", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("height", ctx_r2.scrollY);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("listOfColWidth", ctx_r2.listOfColWidth)("contentTemplate", ctx_r2.contentTemplate);
} }
function NmTableComponent_nm_table_inner_scroll_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nm-table-inner-scroll", 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("scrollY", ctx_r1.scrollY)("theadTemplate", ctx_r1.theadTemplate)("listOfColWidth", ctx_r1.listOfAutoColWidth)("contentTemplate", _r4)("virtualTemplate", true);
} }
function NmTableComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nm-table-inner", 6);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("theadTemplate", ctx_r3.theadTemplate)("contentTemplate", _r4);
} }
function NmTableComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function NmThItemComponent_ng_template_0_Template(rf, ctx) { }
function NmThItemComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nm-table-sorters", 3);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("sortOrder", ctx_r2.sortOrder)("sortDirections", ctx_r2.sortDirections)("contentTemplate", _r3);
} }
function NmThItemComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
const _c13 = ["contentTemplate"];
function NmTheadComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function NmTableSortersComponent_ng_template_1_Template(rf, ctx) { }
function NmTableSortersComponent_nm_svg_loader_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nm-svg-loader", 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r1.sortOrder == "asc");
    ɵngcc0.ɵɵproperty("iconName", ctx_r1.icons.arrowDownMiddleDarkGray);
} }
function NmTableSortersComponent_nm_svg_loader_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nm-svg-loader", 6);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("active", ctx_r2.sortOrder == "desc");
    ɵngcc0.ɵɵproperty("iconName", ctx_r2.icons.arrowDownMiddleDarkGray);
} }
function NmCellEditorComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NmCellEditorComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NmCellEditorComponent_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.inputTemplate);
} }
function NmCellEditorComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NmCellEditorComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NmCellEditorComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.outPutTemplate);
} }
const _c14 = ["tdEditable", ""];
function NmWrapperComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.cardSubtitle);
} }
function NmWrapperComponent_ng_content_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngIf", "!miniCard"]);
} }
function NmWrapperComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.optionalValue);
} }
function NmWrapperComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵelementEnd();
} }
function NmWrapperComponent_ng_content_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 2, ["*ngIf", "empty !== true; else stub"]);
} }
function NmWrapperComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nm-no-data-stub", 13);
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("media", true);
} }
const _c15 = [[["", "dashboard-card-header", ""]], [["", "dashboard-card-header-icon", ""]], [["", "dashboard-card-body", ""]]];
const _c16 = ["[dashboard-card-header]", "[dashboard-card-header-icon]", "[dashboard-card-body]"];
function NmNoDataStubComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "nm-svg-loader", 3);
    ɵngcc0.ɵɵelementStart(2, "span", 4);
    ɵngcc0.ɵɵtext(3, "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("iconName", ctx_r0.icons.historyBigGray);
} }
function NmNoDataStubComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 5);
} }
const _c17 = [[["", "modal-body", ""]], [["", "modal-footer", ""]]];
const _c18 = ["[modal-body]", "[modal-footer]"];
function OverlayComponent_ng_template_1_Template(rf, ctx) { }
function NmExtendedCalendarComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const weekday_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", weekday_r4, " ");
} }
function NmExtendedCalendarComponent_ng_template_8_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    ɵngcc0.ɵɵlistener("click", function NmExtendedCalendarComponent_ng_template_8_div_0_Template_span_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const item_r6 = restoredCtx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r7.selectDay(item_r6.fullDate)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active", item_r6 && ctx_r5.isSame(item_r6 == null ? null : item_r6.fullDate, ctx_r5.currentDay));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r6.date, " ");
} }
function NmExtendedCalendarComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NmExtendedCalendarComponent_ng_template_8_div_0_Template, 3, 3, "div", 11);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.days);
} }
function NmExtendedCalendarComponent_ng_template_9_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    ɵngcc0.ɵɵlistener("click", function NmExtendedCalendarComponent_ng_template_9_div_0_Template_span_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); const item_r10 = restoredCtx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r11.selectDayRange(item_r10.fullDate)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("selected", item_r10.selected && ctx_r9.state.startDate && ctx_r9.state.endDate)("day--first", item_r10 && ctx_r9.isSame(item_r10 == null ? null : item_r10.fullDate, ctx_r9.state.startDate) && ctx_r9.state.endDate)("day--last", item_r10 && ctx_r9.isSame(item_r10 == null ? null : item_r10.fullDate, ctx_r9.state.endDate) && ctx_r9.state.startDate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active", item_r10 && (ctx_r9.isSame(item_r10 == null ? null : item_r10.fullDate, ctx_r9.state.startDate) || ctx_r9.isSame(item_r10 == null ? null : item_r10.fullDate, ctx_r9.state.endDate)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r10.date, " ");
} }
function NmExtendedCalendarComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NmExtendedCalendarComponent_ng_template_9_div_0_Template, 3, 9, "div", 14);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.days);
} }
function NmExtendedCalendarComponent_div_10_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const weekday_r16 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", weekday_r16, " ");
} }
function NmExtendedCalendarComponent_div_10_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    ɵngcc0.ɵɵlistener("click", function NmExtendedCalendarComponent_div_10_ng_template_6_div_0_Template_span_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r20); const item_r18 = restoredCtx.$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r19.selectDay(item_r18.fullDate)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r18 = ctx.$implicit;
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active", item_r18 && ctx_r17.isSame(item_r18 == null ? null : item_r18.fullDate, ctx_r17.currentDay));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r18.date, " ");
} }
function NmExtendedCalendarComponent_div_10_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NmExtendedCalendarComponent_div_10_ng_template_6_div_0_Template, 3, 3, "div", 11);
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r14.daysNext);
} }
function NmExtendedCalendarComponent_div_10_ng_template_7_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12)(1, "span", 13);
    ɵngcc0.ɵɵlistener("click", function NmExtendedCalendarComponent_div_10_ng_template_7_div_0_Template_span_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r24); const item_r22 = restoredCtx.$implicit; const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ɵngcc0.ɵɵresetView(ctx_r23.selectDayRange(item_r22.fullDate)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r22 = ctx.$implicit;
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("selected", item_r22.selected && ctx_r21.state.startDate && ctx_r21.state.endDate)("day--first", item_r22 && ctx_r21.isSame(item_r22 == null ? null : item_r22.fullDate, ctx_r21.state.startDate) && ctx_r21.state.endDate)("day--last", item_r22 && ctx_r21.isSame(item_r22 == null ? null : item_r22.fullDate, ctx_r21.state.endDate) && ctx_r21.state.startDate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active", item_r22 && (ctx_r21.isSame(item_r22 == null ? null : item_r22.fullDate, ctx_r21.state.startDate) || ctx_r21.isSame(item_r22 == null ? null : item_r22.fullDate, ctx_r21.state.endDate)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r22.date, " ");
} }
function NmExtendedCalendarComponent_div_10_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NmExtendedCalendarComponent_div_10_ng_template_7_div_0_Template, 3, 9, "div", 14);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r15.daysNext);
} }
function NmExtendedCalendarComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15)(1, "div", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtemplate(4, NmExtendedCalendarComponent_div_10_div_4_Template, 2, 1, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 6);
    ɵngcc0.ɵɵtemplate(6, NmExtendedCalendarComponent_div_10_ng_template_6_Template, 1, 1, "ng-template", 7);
    ɵngcc0.ɵɵtemplate(7, NmExtendedCalendarComponent_div_10_ng_template_7_Template, 1, 1, "ng-template", 7);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r3.months[ctx_r3.currentMonthNext], ", ", ctx_r3.currentYearNext, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.weekdays);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.localSelection === "single");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.localSelection === "range");
} }
const _c19 = ["singleCalendar"];
function NmCalendarComponent_nm_extended_calendar_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nm-extended-calendar", 3, 4);
    ɵngcc0.ɵɵlistener("changeDate", function NmCalendarComponent_nm_extended_calendar_1_Template_nm_extended_calendar_changeDate_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.onChangeDate($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disabled)("extended", ctx_r0.extended)("selection", ctx_r0.selection)("dateValue", ctx_r0.currentDay)("startDateValue", ctx_r0.startDate)("endDateValue", ctx_r0.endDate)("size", ctx_r0.size);
} }
function NmCalendarComponent_nm_single_calendar_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nm-single-calendar", 5, 4);
    ɵngcc0.ɵɵlistener("changeDate", function NmCalendarComponent_nm_single_calendar_2_Template_nm_single_calendar_changeDate_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.onChangeDate($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.disabled)("selection", ctx_r1.selection)("dateValue", ctx_r1.currentDay)("startDateValue", ctx_r1.startDate)("endDateValue", ctx_r1.endDate)("size", ctx_r1.size);
} }
function NmSingleCalendarComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const weekday_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", weekday_r3, " ");
} }
function NmSingleCalendarComponent_ng_template_8_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11)(1, "span", 12);
    ɵngcc0.ɵɵlistener("click", function NmSingleCalendarComponent_ng_template_8_div_0_Template_span_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const item_r5 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r6.selectDay(item_r5.fullDate)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active", item_r5 && ctx_r4.isSame(item_r5 == null ? null : item_r5.fullDate, ctx_r4.currentDay));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r5.date, " ");
} }
function NmSingleCalendarComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NmSingleCalendarComponent_ng_template_8_div_0_Template, 3, 3, "div", 10);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.days);
} }
function NmSingleCalendarComponent_ng_template_9_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11)(1, "span", 12);
    ɵngcc0.ɵɵlistener("click", function NmSingleCalendarComponent_ng_template_9_div_0_Template_span_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r11); const item_r9 = restoredCtx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r10.selectDayRange(item_r9.fullDate)); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("selected", item_r9.selected && ctx_r8.state.startDate && ctx_r8.state.endDate)("day--first", item_r9 && ctx_r8.isSame(item_r9 == null ? null : item_r9.fullDate, ctx_r8.state.startDate) && ctx_r8.state.endDate)("day--last", item_r9 && ctx_r8.isSame(item_r9 == null ? null : item_r9.fullDate, ctx_r8.state.endDate) && ctx_r8.state.startDate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active", item_r9 && (ctx_r8.isSame(item_r9 == null ? null : item_r9.fullDate, ctx_r8.state.startDate) || ctx_r8.isSame(item_r9 == null ? null : item_r9.fullDate, ctx_r8.state.endDate)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r9.date, " ");
} }
function NmSingleCalendarComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NmSingleCalendarComponent_ng_template_9_div_0_Template, 3, 9, "div", 13);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.days);
} }
const _c20 = ["nmCalendar"];
function TreeCheckboxComponent_nm_node_checkbox_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nm-node-checkbox", 2);
    ɵngcc0.ɵɵlistener("checkedNode", function TreeCheckboxComponent_nm_node_checkbox_1_Template_nm_node_checkbox_checkedNode_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.onCheckedNode($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("node", node_r1);
} }
function TreeNodeCheckboxComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵlistener("click", function TreeNodeCheckboxComponent_button_4_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.toggleChild($event)); });
    ɵngcc0.ɵɵelement(1, "nm-svg-loader", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("node-item-checkbox__button--active", ctx_r0.node == null ? null : ctx_r0.node.isExpanded);
    ɵngcc0.ɵɵproperty("iconName", ctx_r0.icons.arrowRightMediumDarkGray);
} }
function TreeNodeCheckboxComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7)(1, "nm-tree-checkbox", 8);
    ɵngcc0.ɵɵlistener("checkedNode", function TreeNodeCheckboxComponent_ng_template_5_Template_nm_tree_checkbox_checkedNode_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.onCheckedNode($event)); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tree", ctx_r1.node.children);
} }
function TreeNodeItemComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function TreeNodeItemComponent_button_1_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.toggleChild($event)); });
    ɵngcc0.ɵɵelement(1, "nm-svg-loader", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("node-item-checkbox__button--active", ctx_r0.node == null ? null : ctx_r0.node.isExpanded);
    ɵngcc0.ɵɵproperty("iconName", ctx_r0.icons.arrowRightMediumDarkGray);
} }
function TreeNodeItemComponent_ng_template_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelement(1, "nm-item-tree", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tree", ctx_r1.node.children)("dropDownMenu", ctx_r1.dropDownMenu);
} }
function TreeNodeComponent_nm_node_item_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nm-node-item", 2);
} if (rf & 2) {
    const node_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("node", node_r1)("dropDownMenu", ctx_r0.dropDownMenu);
} }
const _c21 = [[["", "nm-card-item-top-left", ""]], [["", "nm-card-item-top-right", ""]], [["", "nm-card-item-bottom-left", ""]], [["", "nm-card-item-bottom-right", ""]]];
const _c22 = ["[nm-card-item-top-left]", "[nm-card-item-top-right]", "[nm-card-item-bottom-left]", "[nm-card-item-bottom-right]"];
function NmTagComponent_ng_template_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function NmTagComponent_ng_template_0_div_1_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r3.tagDeleteEvent($event)); });
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(1, "svg", 3)(2, "g", 4);
    ɵngcc0.ɵɵelement(3, "path", 5)(4, "path", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "defs")(6, "clipPath", 7);
    ɵngcc0.ɵɵelement(7, "rect", 8);
    ɵngcc0.ɵɵelementEnd()()()();
} }
function NmTagComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
    ɵngcc0.ɵɵtemplate(1, NmTagComponent_ng_template_0_div_1_Template, 8, 0, "div", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.hideDeleteButton);
} }
function NmTagComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 3)(1, "g", 4);
    ɵngcc0.ɵɵelement(2, "path", 9)(3, "path", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "defs")(5, "clipPath", 7);
    ɵngcc0.ɵɵelement(6, "rect", 8);
    ɵngcc0.ɵɵelementEnd()()();
} }
const _c23 = ["sidebar"];
const _c24 = function () { return { standalone: true }; };
function NmGoalsComponent_div_12_nm_goal_item_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "nm-goal-item", 13);
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("goal", item_r2)("index", i_r3 + 1)("disabled", ctx_r1.disabledAllGoals)("hideIndex", ctx_r1.goal == null ? null : ctx_r1.goal.hideIndex);
} }
function NmGoalsComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, NmGoalsComponent_div_12_nm_goal_item_1_Template, 1, 4, "nm-goal-item", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.goal.goals);
} }
const _c25 = [[["", "nm-goal-title", ""]], [["", "nm-goal-date-title", ""]]];
const _c26 = ["[nm-goal-title]", "[nm-goal-date-title]"];
const _c27 = ["canvas"];
const _c28 = ["scrollElement"];
const _c29 = ["scrollInner"];
const _c30 = ["scrollStick"];
const _c31 = ["scrollProgress"];
const _c32 = ["scrollLine"];
const _c33 = [[["", "nm-advice-body", ""]], [["", "nm-advice-bottom", ""]]];
const _c34 = ["[nm-advice-body]", "[nm-advice-bottom]"];
const _c35 = ["file"];
function NmUploadImageMenuPositionComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelement(1, "img", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "button", 6);
    ɵngcc0.ɵɵlistener("click", function NmUploadImageMenuPositionComponent_ng_template_2_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.deleteFileEvent()); });
    ɵngcc0.ɵɵelementStart(3, "div", 7)(4, "div", 8);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(5, "svg", 9);
    ɵngcc0.ɵɵelement(6, "path", 10);
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r1.previewSrc, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("color", ctx_r1.buttonColor)("shape", ctx_r1.buttonShape);
} }
function NmUploadImageMenuPositionComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵlistener("click", function NmUploadImageMenuPositionComponent_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.addFiles()); });
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(2, "svg", 13);
    ɵngcc0.ɵɵelement(3, "path", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(4, "span", 15);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.placeHolder);
} }
let NmButton = class NmButton {
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.color = 'default';
        this.size = 'large';
        this.shape = 'default';
        this.disabled = false;
    }
    ngAfterViewInit() {
        this.assertIconOnly(this.elementRef.nativeElement, this.renderer);
        this.insertSpan(this.elementRef.nativeElement.childNodes, this.renderer);
    }
    insertSpan(nodes, renderer) {
        nodes.forEach(node => {
            if (node.nodeName === '#text') {
                const span = renderer.createElement('span');
                const parent = renderer.parentNode(node);
                renderer.insertBefore(parent, span, node);
                renderer.appendChild(span, node);
                renderer.addClass(span, 'button__content');
            }
        });
    }
    assertIconOnly(element, renderer) {
        const listOfNode = Array.from(element.childNodes);
        const iconCount = listOfNode.filter(node => node.nodeName === 'I').length;
        const noText = listOfNode.every(node => node.nodeName !== '#text');
        const noSpan = listOfNode.every(node => node.nodeName !== 'SPAN');
        const isIconOnly = noSpan && noText && iconCount >= 1;
        if (isIconOnly) {
            renderer.addClass(element, 'button-icon-only');
        }
    }
};
NmButton.ɵfac = function NmButton_Factory(t) { return new (t || NmButton)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NmButton.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmButton, selectors: [["button", "nm-button", ""]], hostAttrs: [1, "button"], hostVars: 19, hostBindings: function NmButton_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("button_primary", ctx.color === "primary")("button_secondary", ctx.color === "secondary")("button_peach", ctx.color === "peach")("button_filled", ctx.color === "filled")("button-round", ctx.shape === "round")("button-square", ctx.shape === "square")("button-triangle", ctx.shape === "triangle")("button-large", ctx.size === "large")("button-medium", ctx.size === "medium");
    } }, inputs: { disabled: "disabled", color: "color", size: "size", shape: "shape" }, attrs: _c0, ngContentSelectors: _c1, decls: 1, vars: 0, template: function NmButton_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
NmButton.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    Input(),
    __metadata("design:type", String)
], NmButton.prototype, "color", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmButton.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmButton.prototype, "shape", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmButton.prototype, "disabled", void 0);
NmButton = __decorate([ __metadata("design:paramtypes", [Renderer2,
        ElementRef])
], NmButton);

let NmButtonBack = class NmButtonBack {
    constructor() {
        this.size = 'medium';
        this.isMini = false;
        this.disabled = false;
    }
};
NmButtonBack.ɵfac = function NmButtonBack_Factory(t) { return new (t || NmButtonBack)(); };
NmButtonBack.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmButtonBack, selectors: [["button", "nm-button-back", ""]], hostAttrs: [1, "button-back"], hostVars: 7, hostBindings: function NmButtonBack_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("button-back-mini", ctx.isMini)("button-large", ctx.size === "large")("button-medium", ctx.size === "medium");
    } }, inputs: { disabled: "disabled", size: "size", isMini: "isMini" }, attrs: _c2, ngContentSelectors: _c1, decls: 14, vars: 0, consts: [["type", "button", 1, "button-back"], [1, "button-back__corner"], ["width", "14", "height", "36", "viewBox", "0 0 14 36", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M9.39929 2.20794C10.0306 1.1488 11.1727 0.5 12.4057 0.5H32C33.933 0.5 35.5 2.067 35.5 4V32C35.5 33.933 33.933 35.5 32 35.5H12.5333C11.2407 35.5 10.0533 34.7876 9.44507 33.6471L1.50335 18.7563C0.926502 17.6747 0.95754 16.3701 1.58518 15.3172L9.39929 2.20794Z", "stroke", "#C3CEE0"], [1, "button-back__content"], [1, "button-back__arrow"], ["width", "10", "height", "7", "viewBox", "0 0 10 7", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["clip-path", "url(#clip0)"], ["d", "M0 3.5L2.91549 7L3.60563 6.18841L2.38028 4.7343L1.67606 4.02415L1.69014 3.97343L3.05634 4.07488H10V2.92512H3.05634L1.69014 3.02657L1.67606 2.97585L2.38028 2.2657L3.60563 0.811595L2.91549 0L0 3.5Z", "fill", "#22242C"], ["id", "clip0"], ["width", "10", "height", "7", "fill", "white"], [1, "button-back__title"]], template: function NmButtonBack_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0)(1, "span", 1);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(2, "svg", 2);
        ɵngcc0.ɵɵelement(3, "path", 3);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(4, "div", 4)(5, "span", 5);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(6, "svg", 6)(7, "g", 7);
        ɵngcc0.ɵɵelement(8, "path", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "defs")(10, "clipPath", 9);
        ɵngcc0.ɵɵelement(11, "rect", 10);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(12, "span", 11);
        ɵngcc0.ɵɵprojection(13);
        ɵngcc0.ɵɵelementEnd()()();
    } }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", String)
], NmButtonBack.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmButtonBack.prototype, "isMini", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmButtonBack.prototype, "disabled", void 0);
NmButtonBack = __decorate([ __metadata("design:paramtypes", [])
], NmButtonBack);

let NmButtonTransparentDirective = class NmButtonTransparentDirective {
    constructor() {
        this.size = 'large';
        this.disabled = false;
    }
};
NmButtonTransparentDirective.ɵfac = function NmButtonTransparentDirective_Factory(t) { return new (t || NmButtonTransparentDirective)(); };
NmButtonTransparentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmButtonTransparentDirective, selectors: [["", "nm-button-transparent", ""]], hostAttrs: [1, "button-transparent"], hostVars: 5, hostBindings: function NmButtonTransparentDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("button-large", ctx.size === "large")("button-medium", ctx.size === "medium");
    } }, inputs: { disabled: "disabled", color: "color", size: "size" } });
__decorate([
    Input(),
    __metadata("design:type", String)
], NmButtonTransparentDirective.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmButtonTransparentDirective.prototype, "disabled", void 0);
NmButtonTransparentDirective = __decorate([ __metadata("design:paramtypes", [])
], NmButtonTransparentDirective);

let NomiaUiButtonModule = class NomiaUiButtonModule {
};
NomiaUiButtonModule.ɵfac = function NomiaUiButtonModule_Factory(t) { return new (t || NomiaUiButtonModule)(); };
NomiaUiButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiButtonModule });
NomiaUiButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

let DropdownService = class DropdownService {
    constructor() {
        this.descendDropDownItemClick$ = new Subject();
    }
    onDescendDropDownItemClick(item) {
        this.descendDropDownItemClick$.next(item);
    }
};
DropdownService.ɵfac = function DropdownService_Factory(t) { return new (t || DropdownService)(); };
DropdownService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DropdownService, factory: function (t) { return DropdownService.ɵfac(t); } });

let NmDropDownMenu = class NmDropDownMenu {
    constructor(elementRef, renderer, dropDownService, viewContainerRef) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.dropDownService = dropDownService;
        this.viewContainerRef = viewContainerRef;
        this.mouseState$ = new BehaviorSubject(false);
        this.descendDropDownItemClick$ = this.dropDownService.descendDropDownItemClick$;
    }
    setMouseState(visible) {
        this.mouseState$.next(visible);
    }
    ngAfterContentInit() {
        this.renderer.removeChild(this.renderer.parentNode(this.elementRef.nativeElement), this.elementRef.nativeElement);
    }
};
NmDropDownMenu.ɵfac = function NmDropDownMenu_Factory(t) { return new (t || NmDropDownMenu)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DropdownService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
NmDropDownMenu.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmDropDownMenu, selectors: [["nm-dropdown-menu"]], viewQuery: function NmDropDownMenu_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, exportAs: ["nmDropdownMenu"], ngContentSelectors: _c1, decls: 1, vars: 0, consts: [[3, "ngClass", "mouseenter", "mouseleave"]], template: function NmDropDownMenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NmDropDownMenu_ng_template_0_Template, 2, 1, "ng-template");
    } }, dependencies: [ɵngcc1.NgClass], encapsulation: 2 });
NmDropDownMenu.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: DropdownService },
    { type: ViewContainerRef }
];
__decorate([
    ViewChild(TemplateRef, { static: true }),
    __metadata("design:type", TemplateRef)
], NmDropDownMenu.prototype, "templateRef", void 0);
NmDropDownMenu = __decorate([ __metadata("design:paramtypes", [ElementRef,
        Renderer2,
        DropdownService,
        ViewContainerRef])
], NmDropDownMenu);

let NmDropDownDirective = class NmDropDownDirective {
    constructor(elementRef, renderer, overlay, viewContainerRef, platform) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.overlay = overlay;
        this.viewContainerRef = viewContainerRef;
        this.platform = platform;
        this.nmDropdownMenu = null;
        this.overlayRef = null;
        this.onDestroy = new Subject();
        this.positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.elementRef.nativeElement)
            .withLockedPosition()
            .withTransformOriginOn('.button-dropdown-trigger');
        this.inputVisible$ = new BehaviorSubject(false);
        this.triggerEvent$ = new BehaviorSubject('hover');
        this.overlayClose$ = new Subject();
        this.triggerEvent = 'hover';
        this.dDisabled = false;
        this.dVisible = false;
        this.dropdownOpen = new EventEmitter();
    }
    ngAfterViewInit() {
        if (this.nmDropdownMenu) {
            const nativeElement = this.elementRef.nativeElement;
            const hostMouseState$ = merge(fromEvent(nativeElement, 'mouseenter').pipe(mapTo(true)), fromEvent(nativeElement, 'mouseleave').pipe(mapTo(false)));
            const menuMouseState$ = this.nmDropdownMenu.mouseState$;
            const mergedMouseState$ = merge(menuMouseState$, hostMouseState$);
            const hostClickState$ = fromEvent(nativeElement, 'click').pipe(mapTo(true));
            const visibleStateByTrigger$ = this.triggerEvent$.pipe(switchMap(trigger => {
                if (trigger === 'hover') {
                    return mergedMouseState$;
                }
                else if (trigger === 'click') {
                    return hostClickState$;
                }
                else {
                    return EMPTY;
                }
            }));
            const descendDropDownItemClick$ = this.nmDropdownMenu.descendDropDownItemClick$.pipe(mapTo(false));
            const domTriggerVisible$ = merge(visibleStateByTrigger$, descendDropDownItemClick$, this.overlayClose$).pipe(filter(() => !this.dDisabled));
            const visible$ = merge(this.inputVisible$, domTriggerVisible$);
            combineLatest([visible$])
                .pipe(map(([visible]) => visible), auditTime(150), distinctUntilChanged(), filter(() => this.platform.isBrowser), takeUntil(this.onDestroy))
                .subscribe((visible) => {
                const element = nativeElement;
                const triggerWidth = element.getBoundingClientRect().width;
                if (this.dVisible !== visible) {
                    this.dropdownOpen.emit(visible);
                }
                this.dVisible = visible;
                if (visible) {
                    if (!this.overlayRef) {
                        this.overlayRef = this.overlay.create({
                            positionStrategy: this.positionStrategy,
                            minWidth: triggerWidth,
                            disposeOnNavigation: true,
                            hasBackdrop: this.triggerEvent === 'click',
                            backdropClass: 'cdk-overlay-transparent-backdrop',
                            scrollStrategy: this.overlay.scrollStrategies.reposition()
                        });
                        merge(this.overlayRef.backdropClick(), this.overlayRef.detachments(), this.overlayRef.keydownEvents().pipe(filter(e => e.keyCode === ESCAPE && !hasModifierKey(e))))
                            .pipe(mapTo(false), takeUntil(this.onDestroy))
                            .subscribe(this.overlayClose$);
                    }
                    else {
                        const overlayConfig = this.overlayRef.getConfig();
                        overlayConfig.minWidth = triggerWidth;
                        overlayConfig.hasBackdrop = this.triggerEvent === 'click';
                    }
                    this.positionStrategy.withPositions([
                        {
                            originX: 'start',
                            originY: 'bottom',
                            overlayX: 'start',
                            overlayY: 'top'
                        },
                        {
                            originX: 'start',
                            originY: 'top',
                            overlayX: 'start',
                            overlayY: 'bottom'
                        },
                        {
                            originX: 'end',
                            originY: 'bottom',
                            overlayX: 'end',
                            overlayY: 'top'
                        },
                        {
                            originX: 'end',
                            originY: 'top',
                            overlayX: 'end',
                            overlayY: 'bottom'
                        }
                    ]);
                    if (!this.portal || this.portal.templateRef !== this.nmDropdownMenu.templateRef) {
                        this.portal = new TemplatePortal(this.nmDropdownMenu.templateRef, this.viewContainerRef);
                    }
                    this.overlayRef.attach(this.portal);
                }
                else {
                    if (this.overlayRef) {
                        this.overlayRef.detach();
                    }
                }
            });
        }
    }
    ngOnDestroy() {
        this.onDestroy.next();
        this.onDestroy.complete();
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }
    ngOnChanges(changes) {
        const { dVisible, dDisabled, triggerEvent } = changes;
        if (triggerEvent) {
            this.triggerEvent$.next(this.triggerEvent);
        }
        if (dVisible) {
            this.inputVisible$.next(this.dVisible);
        }
        if (dDisabled) {
            const nativeElement = this.elementRef.nativeElement;
            if (this.dDisabled) {
                this.renderer.setAttribute(nativeElement, 'disabled', '');
                this.inputVisible$.next(false);
            }
            else {
                this.renderer.removeAttribute(nativeElement, 'disabled');
            }
        }
    }
};
NmDropDownDirective.ɵfac = function NmDropDownDirective_Factory(t) { return new (t || NmDropDownDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Platform)); };
NmDropDownDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmDropDownDirective, selectors: [["", "nm-dropdown", ""]], hostVars: 4, hostBindings: function NmDropDownDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("button-dropdown-trigger", true)("dropdown-visible", ctx.dVisible);
    } }, inputs: { nmDropdownMenu: "nmDropdownMenu", triggerEvent: "triggerEvent", dDisabled: "dDisabled", dVisible: "dVisible" }, outputs: { dropdownOpen: "dropdownOpen" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
NmDropDownDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: Overlay },
    { type: ViewContainerRef },
    { type: Platform }
];
__decorate([
    Input(),
    __metadata("design:type", NmDropDownMenu)
], NmDropDownDirective.prototype, "nmDropdownMenu", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmDropDownDirective.prototype, "triggerEvent", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmDropDownDirective.prototype, "dDisabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmDropDownDirective.prototype, "dVisible", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmDropDownDirective.prototype, "dropdownOpen", void 0);
NmDropDownDirective = __decorate([ __metadata("design:paramtypes", [ElementRef,
        Renderer2,
        Overlay,
        ViewContainerRef,
        Platform])
], NmDropDownDirective);

let NmDropDownItemDirective = class NmDropDownItemDirective {
    constructor(dropDownService) {
        this.dropDownService = dropDownService;
        this.disabled = false;
    }
    clickItem(e) {
        if (this.disabled) {
            e.preventDefault();
            e.stopPropagation();
        }
        else {
            this.dropDownService.onDescendDropDownItemClick(this);
        }
    }
};
NmDropDownItemDirective.ɵfac = function NmDropDownItemDirective_Factory(t) { return new (t || NmDropDownItemDirective)(ɵngcc0.ɵɵdirectiveInject(DropdownService)); };
NmDropDownItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmDropDownItemDirective, selectors: [["", "dropdown-item", ""]], hostVars: 2, hostBindings: function NmDropDownItemDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NmDropDownItemDirective_click_HostBindingHandler($event) { return ctx.clickItem($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dropdown-item", true);
    } }, inputs: { disabled: "disabled" } });
NmDropDownItemDirective.ctorParameters = () => [
    { type: DropdownService }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmDropDownItemDirective.prototype, "disabled", void 0);
NmDropDownItemDirective = __decorate([ __metadata("design:paramtypes", [DropdownService])
], NmDropDownItemDirective);

let NmDropDownWrapDirective = class NmDropDownWrapDirective {
};
NmDropDownWrapDirective.ɵfac = function NmDropDownWrapDirective_Factory(t) { return new (t || NmDropDownWrapDirective)(); };
NmDropDownWrapDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmDropDownWrapDirective, selectors: [["", "dropdown-wrap", ""]], hostVars: 2, hostBindings: function NmDropDownWrapDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("dropdown-wrap", true);
    } } });

let NomiaUiDropDownModule = class NomiaUiDropDownModule {
};
NomiaUiDropDownModule.ɵfac = function NomiaUiDropDownModule_Factory(t) { return new (t || NomiaUiDropDownModule)(); };
NomiaUiDropDownModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiDropDownModule });
NomiaUiDropDownModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        DropdownService
    ], imports: [CommonModule,
        OverlayModule,
        PlatformModule, OverlayModule,
        PlatformModule] });

var NmSwitch_1;
let NmSwitch = NmSwitch_1 = class NmSwitch {
    constructor() {
        this.disabled = false;
        this.control = false;
        this.isDark = false;
        this.type = 'default';
        this.checkedChildren = null;
        this.unCheckedChildren = null;
        this.isChecked = false;
        this.onChange = () => {
        };
        this.onTouched = () => {
        };
    }
    onHostClick(e) {
        e.preventDefault();
        if (!this.disabled && !this.control) {
            this.updateValue(!this.isChecked);
        }
    }
    updateValue(value) {
        if (this.isChecked !== value) {
            this.isChecked = value;
            this.onChange(this.isChecked);
        }
    }
    blur() {
        var _a;
        (_a = this.switchElement) === null || _a === void 0 ? void 0 : _a.nativeElement.blur();
    }
    writeValue(value) {
        this.isChecked = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
};
NmSwitch.ɵfac = function NmSwitch_Factory(t) { return new (t || NmSwitch)(); };
NmSwitch.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmSwitch, selectors: [["nm-switch"]], viewQuery: function NmSwitch_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.switchElement = _t.first);
    } }, hostBindings: function NmSwitch_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NmSwitch_click_HostBindingHandler($event) { return ctx.onHostClick($event); });
    } }, inputs: { disabled: "disabled", control: "control", isDark: "isDark", type: "type", checkedChildren: "checkedChildren", unCheckedChildren: "unCheckedChildren" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NmSwitch_1),
                multi: true
            }
        ])], decls: 15, vars: 11, consts: [["type", "button", 1, "switch", 3, "disabled"], ["switchElement", ""], [1, "switch-inner"], [1, "left-item"], [1, "switcher"], ["width", "13", "height", "9", "viewBox", "0 0 13 9", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "switcher-icon", "icon__success"], ["d", "M1.04102 4.76471L1.96744 5.77677C3.34735 7.28423 4.0373 8.03796 4.91794 8.03796C5.79857 8.03796 6.48853 7.28423 7.86844 5.77677L12.241 1", "stroke", "#40DA9D", "stroke-linecap", "round", "stroke-linejoin", "round"], ["width", "16", "height", "16", "viewBox", "0 0 16 16", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "switcher-icon", "icon__false"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M12.6549 3.34483C12.8453 3.53527 12.8453 3.84404 12.6549 4.03448L4.03426 12.6551C3.84382 12.8456 3.53505 12.8456 3.34461 12.6551C3.15417 12.4647 3.15417 12.1559 3.34461 11.9655L11.9652 3.34483C12.1557 3.15438 12.4644 3.15438 12.6549 3.34483Z", "fill", "#FF4E4E"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M12.6549 12.6554C12.4645 12.8458 12.1557 12.8458 11.9653 12.6554L3.34466 4.03472C3.15421 3.84428 3.15421 3.53551 3.34466 3.34507C3.5351 3.15463 3.84386 3.15463 4.03431 3.34507L12.6549 11.9657C12.8454 12.1562 12.8454 12.4649 12.6549 12.6554Z", "fill", "#FF4E4E"], [1, "right-item"]], template: function NmSwitch_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0, 1)(2, "span", 2)(3, "span", 3);
        ɵngcc0.ɵɵelementContainerStart(4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(7, "svg", 5);
        ɵngcc0.ɵɵelement(8, "path", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "svg", 7);
        ɵngcc0.ɵɵelement(10, "path", 8)(11, "path", 9);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(12, "span", 10);
        ɵngcc0.ɵɵelementContainerStart(13);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("switch-checked", ctx.isChecked)("brightness-less", ctx.isDark)("switch-type__success", ctx.type === "success")("switch-disabled", ctx.disabled);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.checkedChildren);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵtextInterpolate(ctx.unCheckedChildren);
    } }, encapsulation: 2 });
__decorate([
    ViewChild('switchElement', { static: true }),
    __metadata("design:type", ElementRef)
], NmSwitch.prototype, "switchElement", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmSwitch.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmSwitch.prototype, "control", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmSwitch.prototype, "isDark", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmSwitch.prototype, "type", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmSwitch.prototype, "checkedChildren", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmSwitch.prototype, "unCheckedChildren", void 0);
NmSwitch = NmSwitch_1 = __decorate([ __metadata("design:paramtypes", [])
], NmSwitch);

let NomiaUiSwitchModule = class NomiaUiSwitchModule {
};
NomiaUiSwitchModule.ɵfac = function NomiaUiSwitchModule_Factory(t) { return new (t || NomiaUiSwitchModule)(); };
NomiaUiSwitchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiSwitchModule });
NomiaUiSwitchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let TabActiveService = class TabActiveService {
    constructor() {
        this.descendTabItemActive$ = new Subject();
    }
    onDescendTabItemActive(item) {
        this.descendTabItemActive$.next(item);
    }
};
TabActiveService.ɵfac = function TabActiveService_Factory(t) { return new (t || TabActiveService)(); };
TabActiveService.ɵprov = ɵɵdefineInjectable({ factory: function TabActiveService_Factory() { return new TabActiveService(); }, token: TabActiveService, providedIn: "root" });

let NmTabItem = class NmTabItem {
    constructor(elementRef, tabActiveService) {
        this.elementRef = elementRef;
        this.tabActiveService = tabActiveService;
        this.isCloseable = false;
        this.action = new EventEmitter();
        this._active = false;
    }
    set active(value) {
        this._active = value;
        this.tabActiveService.onDescendTabItemActive(this._active);
    }
};
NmTabItem.ɵfac = function NmTabItem_Factory(t) { return new (t || NmTabItem)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(TabActiveService)); };
NmTabItem.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTabItem, selectors: [["nm-tab-item"]], viewQuery: function NmTabItem_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, inputs: { isCloseable: "isCloseable", active: "active", title: ["tabTitle", "title"], dataContext: "dataContext" }, outputs: { action: "action" }, ngContentSelectors: _c1, decls: 2, vars: 1, consts: [[1, "tab__content", 3, "hidden"]], template: function NmTabItem_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NmTabItem_ng_template_1_Template, 1, 0, "ng-template");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx._active);
    } }, encapsulation: 2 });
NmTabItem.ctorParameters = () => [
    { type: ElementRef },
    { type: TabActiveService }
];
__decorate([
    ViewChild(TemplateRef, { static: true }),
    __metadata("design:type", TemplateRef)
], NmTabItem.prototype, "templateRef", void 0);
__decorate([
    Input('tabTitle'),
    __metadata("design:type", String)
], NmTabItem.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], NmTabItem.prototype, "active", null);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmTabItem.prototype, "isCloseable", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmTabItem.prototype, "dataContext", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmTabItem.prototype, "action", void 0);
NmTabItem = __decorate([ __metadata("design:paramtypes", [ElementRef, TabActiveService])
], NmTabItem);

let NmTabActiveItemDirective = class NmTabActiveItemDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    alignToElement(element) {
        this.setStyles(element);
    }
    setStyles(element) {
        const item = this.elementRef.nativeElement;
        item.style.left = this.getLeftPosition(element);
        item.style.width = this.getElementWidth(element);
        item.style.height = this.getElementHeight(element);
    }
    getLeftPosition(element) {
        return element ? (element.offsetLeft || 0) + 'px' : '0';
    }
    getElementWidth(element) {
        return element ? (element.offsetWidth || 0) + 'px' : '0';
    }
    getTopPosition(element) {
        return element ? (element.offsetTop || 0) + 'px' : '0';
    }
    getElementHeight(element) {
        return element ? (element.offsetHeight - 5 || 0) + 'px' : '0';
    }
};
NmTabActiveItemDirective.ɵfac = function NmTabActiveItemDirective_Factory(t) { return new (t || NmTabActiveItemDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NmTabActiveItemDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmTabActiveItemDirective, selectors: [["nm-tabs-active-bar"], ["", "nm-tabs-active-bar", ""]], hostAttrs: [1, "tabs-active-bar"] });
NmTabActiveItemDirective.ctorParameters = () => [
    { type: ElementRef }
];
NmTabActiveItemDirective = __decorate([ __metadata("design:paramtypes", [ElementRef])
], NmTabActiveItemDirective);

let NmTabsGroup = class NmTabsGroup {
    constructor(tabActiveService) {
        this.tabActiveService = tabActiveService;
        this.tabChange = new EventEmitter();
        this.onDestroy = new Subject();
        this.transitionendChange = () => {
            this.tabChange.emit();
        };
    }
    ngAfterContentInit() {
        this.tabs.changes.pipe(takeUntil(this.onDestroy)).subscribe((data) => {
            requestAnimationFrame(() => {
                this.renderActiveTab();
            });
        });
        this.tabActiveService.descendTabItemActive$.asObservable()
            .pipe(distinctUntilChanged(), throttleTime(500), takeUntil(this.onDestroy))
            .subscribe((data) => {
            this.renderActiveTab();
        });
        requestAnimationFrame(() => {
            const activeTabs = this.tabs.filter(tab => tab._active);
            const tabElements = this.tabElements.toArray();
            if (tabElements.length) {
                if (activeTabs.length === 0) {
                    this.selectTab(this.tabs.first, tabElements[0].nativeElement);
                }
                else {
                    this.renderActiveTab();
                }
            }
            this.slideTab.nativeElement.addEventListener('transitionend', this.transitionendChange, false);
        });
        fromEvent(window, 'resize').pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
            this.renderActiveTab();
        });
    }
    ngOnDestroy() {
        this.onDestroy.next();
        this.onDestroy.complete();
        this.slideTab.nativeElement.removeEventListener('transitionend', this.transitionendChange);
    }
    renderActiveTab() {
        this.tabElements.toArray().forEach((item) => {
            requestAnimationFrame(() => {
                if (item.nativeElement.classList.contains('active')) {
                    this.alignInkBarToSelectedTab(item.nativeElement);
                }
            });
        });
    }
    selectTab(tab, element) {
        this.tabs.toArray().forEach(tabItem => (tabItem.active = false));
        tab.active = true;
        if (tab.action) {
            tab.action.emit();
        }
        this.alignInkBarToSelectedTab(element);
    }
    alignInkBarToSelectedTab(selectedItem) {
        this.tabActive.alignToElement(selectedItem);
    }
};
NmTabsGroup.ɵfac = function NmTabsGroup_Factory(t) { return new (t || NmTabsGroup)(ɵngcc0.ɵɵdirectiveInject(TabActiveService)); };
NmTabsGroup.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTabsGroup, selectors: [["nm-tabs-group"]], contentQueries: function NmTabsGroup_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NmTabItem, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabs = _t);
    } }, viewQuery: function NmTabsGroup_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NmTabActiveItemDirective, 5);
        ɵngcc0.ɵɵviewQuery(_c4, 5);
        ɵngcc0.ɵɵviewQuery(_c5, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabActive = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.slideTab = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabElements = _t);
    } }, outputs: { tabChange: "tabChange" }, ngContentSelectors: _c1, decls: 6, vars: 1, consts: [[1, "tabs__wrapper"], [1, "tabs__panel"], ["class", "tab__item", 3, "active", "click", 4, "ngFor", "ngForOf"], ["nm-tabs-active-bar", ""], ["slideTab", ""], [1, "tab__item", 3, "click"], ["tabElement", ""], [3, "ngTemplateOutlet"]], template: function NmTabsGroup_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "ul", 1);
        ɵngcc0.ɵɵtemplate(2, NmTabsGroup_li_2_Template, 4, 3, "li", 2);
        ɵngcc0.ɵɵelement(3, "div", 3, 4);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵprojection(5);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabs);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet, NmTabActiveItemDirective], encapsulation: 2 });
NmTabsGroup.ctorParameters = () => [
    { type: TabActiveService }
];
__decorate([
    ViewChild(NmTabActiveItemDirective),
    __metadata("design:type", NmTabActiveItemDirective)
], NmTabsGroup.prototype, "tabActive", void 0);
__decorate([
    ViewChild('slideTab'),
    __metadata("design:type", ElementRef)
], NmTabsGroup.prototype, "slideTab", void 0);
__decorate([
    ViewChildren('tabElement'),
    __metadata("design:type", QueryList)
], NmTabsGroup.prototype, "tabElements", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], NmTabsGroup.prototype, "tabChange", void 0);
__decorate([
    ContentChildren(NmTabItem),
    __metadata("design:type", QueryList)
], NmTabsGroup.prototype, "tabs", void 0);
NmTabsGroup = __decorate([ __metadata("design:paramtypes", [TabActiveService])
], NmTabsGroup);

let NmTabsContent = class NmTabsContent {
    constructor() {
        this.changeSwipe = new EventEmitter();
    }
    ngAfterContentInit() {
        requestAnimationFrame(() => {
            this.tabs = this.tabGroup.tabs;
            let step = 0;
            let el = this.swipezone.nativeElement;
            this.swipedetect(el, (swipedir) => {
                this.tabs.toArray().forEach((tabItem, index) => {
                    if (tabItem._active) {
                        step = index;
                    }
                    tabItem.active = false;
                });
                if (swipedir === 'left') {
                    step++;
                    if (step > this.tabs.toArray().length - 1) {
                        step = 0;
                    }
                    this.tabs.toArray()[step].active = true;
                }
                if (swipedir === 'right') {
                    step--;
                    if (step < 0) {
                        step = this.tabs.toArray().length - 1;
                    }
                    this.tabs.toArray()[step].active = true;
                }
                if (this.tabs.toArray()[step].action) {
                    this.tabs.toArray()[step].action.emit();
                }
                requestAnimationFrame(() => {
                    this.tabGroup.renderActiveTab();
                });
                this.changeSwipe.emit(swipedir);
            });
        });
    }
    swipedetect(el, callback) {
        let touchsurface = el, swipedir, startX, startY, distX, distY, threshold = 150, restraint = 100, allowedTime = 300, elapsedTime, startTime, handleswipe = callback;
        touchsurface.addEventListener('touchstart', (e) => {
            let touchobj = e.changedTouches[0];
            swipedir = 'none';
            startX = touchobj.pageX;
            startY = touchobj.pageY;
            startTime = new Date().getTime();
            e.preventDefault();
        }, false);
        touchsurface.addEventListener('touchmove', (e) => {
            e.preventDefault();
        }, false);
        touchsurface.addEventListener('touchend', (e) => {
            let touchobj = e.changedTouches[0];
            distX = touchobj.pageX - startX;
            distY = touchobj.pageY - startY;
            elapsedTime = new Date().getTime() - startTime;
            if (elapsedTime <= allowedTime) {
                if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
                    swipedir = (distX < 0) ? 'left' : 'right';
                }
                else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
                    swipedir = (distY < 0) ? 'up' : 'down';
                }
            }
            handleswipe(swipedir);
            e.preventDefault();
        }, false);
    }
};
NmTabsContent.ɵfac = function NmTabsContent_Factory(t) { return new (t || NmTabsContent)(); };
NmTabsContent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTabsContent, selectors: [["nm-tabs-content"]], viewQuery: function NmTabsContent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c6, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.swipezone = _t.first);
    } }, inputs: { tabGroup: "tabGroup" }, outputs: { changeSwipe: "changeSwipe" }, ngContentSelectors: _c1, decls: 3, vars: 0, consts: [["swipezone", ""]], template: function NmTabsContent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
__decorate([
    ViewChild('swipezone'),
    __metadata("design:type", ElementRef)
], NmTabsContent.prototype, "swipezone", void 0);
__decorate([
    Input(),
    __metadata("design:type", NmTabsGroup)
], NmTabsContent.prototype, "tabGroup", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmTabsContent.prototype, "changeSwipe", void 0);
NmTabsContent = __decorate([ __metadata("design:paramtypes", [])
], NmTabsContent);

let NomiaUiTabsModule = class NomiaUiTabsModule {
};
NomiaUiTabsModule.ɵfac = function NomiaUiTabsModule_Factory(t) { return new (t || NomiaUiTabsModule)(); };
NomiaUiTabsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiTabsModule });
NomiaUiTabsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let NmBaseInputDirective = class NmBaseInputDirective {
    constructor(ngControl, elementRef) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.size = 'medium';
        this.autofocus = false;
        this._disabled = false;
        this.disabled$ = new Subject();
        this.destroy$ = new Subject();
        this.currentValue = null;
    }
    get disabled() {
        if (this.ngControl && this.ngControl.disabled !== null) {
            return this.ngControl.disabled;
        }
        return this._disabled;
    }
    keyDown(event) {
        this.onKeyDown(event);
    }
    set disabled(value) {
        this._disabled = value != null && `${value}` !== 'false';
    }
    ngOnInit() {
        var _a;
        if (this.ngControl) {
            (_a = this.ngControl.statusChanges) === null || _a === void 0 ? void 0 : _a.pipe(filter(() => this.ngControl.disabled !== null), takeUntil(this.destroy$)).subscribe(() => {
                this.disabled$.next(this.ngControl.disabled);
            });
            requestAnimationFrame(() => {
                this.currentValue = this.ngControl.control.value;
            });
        }
    }
    onKeyDown(e) {
        if (this.disabled) {
            return;
        }
        if (this.ngControl) {
            if (e.key === 'Escape' || e.keyCode === ESCAPE) {
                this.ngControl.control.setValue(this.currentValue);
            }
        }
    }
    ngOnChanges(changes) {
        const { disabled, autofocus } = changes;
        if (disabled) {
            this.disabled$.next(this.disabled);
        }
        if (autofocus && this.elementRef) {
            this.elementRef.nativeElement.focus();
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
};
NmBaseInputDirective.ɵfac = function NmBaseInputDirective_Factory(t) { return new (t || NmBaseInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NmBaseInputDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmBaseInputDirective, selectors: [["input", "nm-input", ""], ["textarea", "nm-input", ""]], hostVars: 11, hostBindings: function NmBaseInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function NmBaseInputDirective_keydown_HostBindingHandler($event) { return ctx.keyDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("base-input", true)("nm-input-disabled", ctx.disabled)("size-lg", ctx.size === "large")("size-md", ctx.size === "medium")("size-sm", ctx.size === "small");
    } }, inputs: { size: "size", autofocus: "autofocus", disabled: "disabled" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
NmBaseInputDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] },
    { type: ElementRef }
];
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], NmBaseInputDirective.prototype, "disabled", null);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmBaseInputDirective.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmBaseInputDirective.prototype, "autofocus", void 0);
__decorate([
    HostListener('keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], NmBaseInputDirective.prototype, "keyDown", null);
NmBaseInputDirective = __decorate([ __param(0, Optional()), __param(0, Self()),
    __metadata("design:paramtypes", [NgControl,
        ElementRef])
], NmBaseInputDirective);

let NmInputDirective = class NmInputDirective extends NmBaseInputDirective {
    constructor(ngControl) {
        super(ngControl);
        this.ngControl = ngControl;
    }
};
NmInputDirective.ɵfac = function NmInputDirective_Factory(t) { return new (t || NmInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl, 10)); };
NmInputDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmInputDirective, selectors: [["input", "nm-input", ""], ["textarea", "nm-input", ""]], hostVars: 2, hostBindings: function NmInputDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nm-input", true);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
NmInputDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
];
NmInputDirective = __decorate([ __param(0, Optional()), __param(0, Self()),
    __metadata("design:paramtypes", [NgControl])
], NmInputDirective);

let NmFilledInputDirective = class NmFilledInputDirective extends NmBaseInputDirective {
    constructor(ngControl) {
        super(ngControl);
        this.ngControl = ngControl;
    }
};
NmFilledInputDirective.ɵfac = function NmFilledInputDirective_Factory(t) { return new (t || NmFilledInputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl, 10)); };
NmFilledInputDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmFilledInputDirective, selectors: [["input", "nm-input-filled", ""], ["textarea", "nm-input-filled", ""]], hostVars: 2, hostBindings: function NmFilledInputDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nm-input-filled", true);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
NmFilledInputDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
];
NmFilledInputDirective = __decorate([ __param(0, Optional()), __param(0, Self()),
    __metadata("design:paramtypes", [NgControl])
], NmFilledInputDirective);

let NmOptionComponent = class NmOptionComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.label = null;
        this.value = null;
        this.isNotSelectable = false;
        this.action = new EventEmitter();
        this.changes = new Subject();
    }
    ngOnChanges(changes) {
        this.changes.next();
    }
};
NmOptionComponent.ɵfac = function NmOptionComponent_Factory(t) { return new (t || NmOptionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NmOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmOptionComponent, selectors: [["nm-option"]], viewQuery: function NmOptionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, hostVars: 2, hostBindings: function NmOptionComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("option__panel", true);
    } }, inputs: { label: "label", value: "value", isNotSelectable: "isNotSelectable" }, outputs: { action: "action" }, exportAs: ["posOption"], features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 1, vars: 0, template: function NmOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NmOptionComponent_ng_template_0_Template, 1, 0, "ng-template");
    } }, encapsulation: 2 });
NmOptionComponent.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input(),
    __metadata("design:type", String)
], NmOptionComponent.prototype, "label", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmOptionComponent.prototype, "value", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmOptionComponent.prototype, "isNotSelectable", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmOptionComponent.prototype, "action", void 0);
__decorate([
    ViewChild(TemplateRef, { static: true }),
    __metadata("design:type", TemplateRef)
], NmOptionComponent.prototype, "template", void 0);
NmOptionComponent = __decorate([ __metadata("design:paramtypes", [ElementRef])
], NmOptionComponent);

let NmSelectSearchComponent = class NmSelectSearchComponent {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.disabled = false;
        this.showInput = true;
        this.focusTrigger = false;
        this.value = '';
        this.autofocus = false;
        this.valueChange = new EventEmitter();
    }
    onValueChange(value) {
        const inputDOM = this.inputElement.nativeElement;
        inputDOM.value = value;
        this.value = value;
        this.valueChange.next(value);
    }
    clearInputValue() {
        this.onValueChange('');
    }
    blur() {
        this.inputElement.nativeElement.blur();
    }
    focus() {
        this.inputElement.nativeElement.blur();
    }
    ngOnChanges(changes) {
        const inputDOM = this.inputElement.nativeElement;
        const { focusTrigger, showInput } = changes;
        if (focusTrigger && focusTrigger.currentValue === true && focusTrigger.previousValue === false) {
            inputDOM.focus();
        }
        if (showInput) {
            if (this.showInput) {
                this.renderer.removeAttribute(inputDOM, 'readonly');
            }
            else {
                this.renderer.setAttribute(inputDOM, 'readonly', 'readonly');
            }
        }
    }
};
NmSelectSearchComponent.ɵfac = function NmSelectSearchComponent_Factory(t) { return new (t || NmSelectSearchComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NmSelectSearchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmSelectSearchComponent, selectors: [["nm-select-search"]], viewQuery: function NmSelectSearchComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c7, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, inputs: { disabled: "disabled", showInput: "showInput", focusTrigger: "focusTrigger", value: "value", autofocus: "autofocus" }, outputs: { valueChange: "valueChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 5, consts: [["type", "text", "autocomplete", "off", 1, "search-input", 3, "ngModel", "disabled", "ngModelChange"], ["inputElement", ""]], template: function NmSelectSearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function NmSelectSearchComponent_Template_input_ngModelChange_0_listener($event) { return ctx.onValueChange($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("opacity", ctx.showInput ? null : 0);
        ɵngcc0.ɵɵproperty("ngModel", ctx.value)("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("autofocus", ctx.autofocus ? "autofocus" : null);
    } }, dependencies: [ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel], encapsulation: 2 });
NmSelectSearchComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmSelectSearchComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmSelectSearchComponent.prototype, "showInput", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmSelectSearchComponent.prototype, "focusTrigger", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmSelectSearchComponent.prototype, "value", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmSelectSearchComponent.prototype, "autofocus", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], NmSelectSearchComponent.prototype, "valueChange", void 0);
__decorate([
    ViewChild('inputElement', { static: true }),
    __metadata("design:type", ElementRef)
], NmSelectSearchComponent.prototype, "inputElement", void 0);
NmSelectSearchComponent = __decorate([ __metadata("design:paramtypes", [ElementRef, Renderer2])
], NmSelectSearchComponent);

let NmOptionWrap = class NmOptionWrap {
    constructor(elementRef, renderer, viewContainerRef) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.viewContainerRef = viewContainerRef;
        this.tableSelect = false;
    }
    ngAfterContentInit() {
        this.renderer.removeChild(this.renderer.parentNode(this.elementRef.nativeElement), this.elementRef.nativeElement);
    }
};
NmOptionWrap.ɵfac = function NmOptionWrap_Factory(t) { return new (t || NmOptionWrap)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
NmOptionWrap.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmOptionWrap, selectors: [["nm-option-wrap"]], viewQuery: function NmOptionWrap_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, inputs: { tableSelect: "tableSelect" }, ngContentSelectors: _c1, decls: 1, vars: 0, consts: [[1, "select__body"]], template: function NmOptionWrap_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NmOptionWrap_ng_template_0_Template, 2, 2, "ng-template");
    } }, encapsulation: 2 });
NmOptionWrap.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: ViewContainerRef }
];
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmOptionWrap.prototype, "tableSelect", void 0);
__decorate([
    ViewChild(TemplateRef, { static: true }),
    __metadata("design:type", TemplateRef)
], NmOptionWrap.prototype, "templateRef", void 0);
NmOptionWrap = __decorate([ __metadata("design:paramtypes", [ElementRef,
        Renderer2,
        ViewContainerRef])
], NmOptionWrap);

var NmSelectComponent_1;
let NmSelectComponent = NmSelectComponent_1 = class NmSelectComponent {
    constructor(cdr, elementRef, renderer, overlay, viewContainerRef, platform) {
        this.cdr = cdr;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.overlay = overlay;
        this.viewContainerRef = viewContainerRef;
        this.platform = platform;
        this.isOpen = false;
        this.size = 'medium';
        this.disabled = false;
        this.isSearch = false;
        this.tableSelect = false;
        this.onOpenChange = new EventEmitter();
        this.showArrow = true;
        this.isShowPlaceholder = true;
        this.isShowLabel = false;
        this.inputValue = null;
        this.inputVisible$ = new BehaviorSubject(false);
        this.overlayClose$ = new Subject();
        this.overlayRef = null;
        this.onDestroy = new Subject();
        this.listOfItems = [];
        this.listOfItemsBuf = [];
        this.onChange = () => {
        };
        this.onTouched = () => {
        };
        this.compareWith = (o1, o2) => o1 === o2;
    }
    set validateStatus(value) {
        this.showArrow = value !== 'error';
        this.cdr.markForCheck();
    }
    keyDown(event) {
        this.onKeyDown(event);
    }
    writeValue(value) {
        this.currentValue = value;
        requestAnimationFrame(() => {
            this.renderValue();
        });
    }
    ngAfterContentInit() {
        requestAnimationFrame(() => {
            this.listNmOptionComponent.changes.subscribe((data) => {
                this.renderValue();
            });
            this.listOfItems = this.listNmOptionComponent.toArray();
            this.listOfItemsBuf = this.listNmOptionComponent.toArray();
            this.generateOverlay();
            this.positionStrategy = this.overlay
                .position()
                .flexibleConnectedTo(this.elementRef.nativeElement.parentNode)
                .withLockedPosition()
                .withTransformOriginOn('.option-wrap');
        });
    }
    renderValue() {
        this.listOfItems = this.listNmOptionComponent.toArray();
        this.listOfItemsBuf = this.listNmOptionComponent.toArray();
        const selectedEl = this.listOfItems.find((item) => item.value === this.currentValue);
        if (selectedEl) {
            this.selectedOption = selectedEl;
            this.onChange(this.selectedOption.value);
            this.onOpenChangeModel();
            this.cdr.detectChanges();
        }
    }
    ;
    updateTemplateVariable() {
        const selectedValue = (this.selectedOption && this.selectedOption.value);
        this.isShowPlaceholder = !selectedValue && !this.inputValue;
        this.isShowLabel = selectedValue && !this.inputValue;
    }
    defaultFilterOption(searchValue, item) {
        const textContent = item.label || '';
        return textContent.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
    }
    clearInput() {
        if (this.selectSearchComponent) {
            this.selectSearchComponent.clearInputValue();
        }
    }
    onInputValueChange(value) {
        this.inputValue = value;
        let listOfContainerItem = this.listOfItemsBuf.filter(item => {
            return this.defaultFilterOption(this.inputValue, item);
        });
        this.listOfItems = [...listOfContainerItem];
        this.updateTemplateVariable();
    }
    onItemClick(value) {
        if (value.isNotSelectable) {
            this.setOpenState(false);
        }
        else {
            this.selectedOption = value;
            this.currentValue = value.value;
            this.onTouched();
            this.setOpenState(false);
            this.onOpenChange.emit(this.isOpen);
        }
        if (value.action) {
            value.action.emit();
        }
    }
    setOpenState(value, $event = null) {
        if ($event) {
            $event.stopPropagation();
        }
        if (this.isOpen !== value) {
            this.isOpen = value;
            this.onOpenChangeModel();
        }
        this.inputVisible$.next(this.isOpen);
    }
    generateOverlay() {
        const visible$ = merge(this.inputVisible$, this.overlayClose$);
        combineLatest([visible$]).pipe(distinctUntilChanged(), filter(() => this.platform.isBrowser), takeUntil(this.onDestroy)).subscribe(([isOpen]) => {
            var _a, _b;
            const element = this.elementRef.nativeElement.parentNode;
            const triggerWidth = element.getBoundingClientRect().width;
            this.isOpen = isOpen;
            if (isOpen) {
                this.hiddenInput.nativeElement.focus();
                if (!this.overlayRef) {
                    this.overlayRef = this.overlay.create({
                        positionStrategy: this.positionStrategy,
                        minWidth: triggerWidth,
                        disposeOnNavigation: true,
                        hasBackdrop: true,
                        backdropClass: 'cdk-overlay-transparent-backdrop',
                        scrollStrategy: this.overlay.scrollStrategies.reposition()
                    });
                    merge(this.overlayRef.backdropClick(), this.overlayRef.detachments(), this.overlayRef.keydownEvents().pipe(filter(e => e.keyCode === ESCAPE && !hasModifierKey(e))))
                        .pipe(mapTo(false), takeUntil(this.onDestroy))
                        .subscribe(this.overlayClose$);
                }
                else {
                    const overlayConfig = this.overlayRef.getConfig();
                    overlayConfig.minWidth = triggerWidth;
                    overlayConfig.hasBackdrop = true;
                }
                this.positionStrategy.withPositions([
                    {
                        originX: 'start',
                        originY: 'bottom',
                        overlayX: 'start',
                        overlayY: 'top'
                    },
                    {
                        originX: 'start',
                        originY: 'top',
                        overlayX: 'start',
                        overlayY: 'bottom'
                    },
                    {
                        originX: 'end',
                        originY: 'bottom',
                        overlayX: 'end',
                        overlayY: 'top'
                    },
                    {
                        originX: 'end',
                        originY: 'top',
                        overlayX: 'end',
                        overlayY: 'bottom'
                    }
                ]);
                if (!this.portal || ((_a = this.portal) === null || _a === void 0 ? void 0 : _a.templateRef) !== ((_b = this.optionWrap) === null || _b === void 0 ? void 0 : _b.templateRef)) {
                    this.portal = new TemplatePortal(this.optionWrap.templateRef, this.viewContainerRef);
                }
                this.overlayRef.attach(this.portal);
            }
            else {
                if (this.overlayRef) {
                    this.overlayRef.detach();
                }
                this.clearInput();
            }
            this.cdr.markForCheck();
        });
    }
    ngOnChanges(changes) {
        const { isOpen } = changes;
        if (isOpen) {
            this.inputVisible$.next(this.isOpen);
        }
    }
    ngOnDestroy() {
        this.onDestroy.next();
        this.onDestroy.complete();
        if (this.overlayRef) {
            this.overlayRef.dispose();
            this.overlayRef = null;
        }
    }
    onMouseLeave($event) {
        this.setOpenState(false);
    }
    onKeyDown(e) {
        if (this.disabled) {
            return;
        }
        const activatedIndex = this.listOfItems.findIndex(item => this.compareWith(item.value, (this.selectedOption ? this.selectedOption.value : '')));
        switch (e.keyCode) {
            case UP_ARROW:
                e.preventDefault();
                if (this.isOpen) {
                    const preIndex = activatedIndex > 0 ? activatedIndex - 1 : this.listOfItems.length - 1;
                    this.selectedOption = this.listOfItems[preIndex];
                }
                break;
            case DOWN_ARROW:
                e.preventDefault();
                if (this.isOpen) {
                    const nextIndex = activatedIndex < this.listOfItems.length - 1 ? activatedIndex + 1 : 0;
                    this.selectedOption = this.listOfItems[nextIndex];
                }
                else {
                    this.setOpenState(true);
                }
                break;
            case ENTER:
                e.preventDefault();
                if (this.isOpen) {
                    if (this.selectedOption) {
                        if (this.selectedOption.isNotSelectable) {
                            this.selectedOption.value = this.currentValue;
                        }
                        this.onItemClick(this.selectedOption);
                    }
                }
                else {
                    this.setOpenState(true);
                }
                break;
            case SPACE:
                if (!this.isOpen) {
                    this.setOpenState(true);
                    e.preventDefault();
                }
                break;
            case TAB:
                this.setOpenState(false);
                break;
            case ESCAPE:
                if (this.selectedOption) {
                    this.selectedOption.value = this.currentValue;
                }
                this.setOpenState(false);
                break;
            default:
                if (!this.isOpen) {
                    this.setOpenState(true);
                }
        }
    }
    trackValue(index, option) {
        return option.value;
    }
    onOpenChangeModel() {
        if (this.selectedOption) {
            this.onChange(this.selectedOption.value);
        }
        this.updateTemplateVariable();
        this.clearInput();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
};
NmSelectComponent.ɵfac = function NmSelectComponent_Factory(t) { return new (t || NmSelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.Platform)); };
NmSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmSelectComponent, selectors: [["nm-select"]], contentQueries: function NmSelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NmOptionComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listNmOptionComponent = _t);
    } }, viewQuery: function NmSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NmOptionWrap, 5);
        ɵngcc0.ɵɵviewQuery(_c8, 5);
        ɵngcc0.ɵɵviewQuery(NmSelectSearchComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.optionWrap = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.hiddenInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectSearchComponent = _t.first);
    } }, hostVars: 5, hostBindings: function NmSelectComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function NmSelectComponent_keydown_HostBindingHandler($event) { return ctx.keyDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("select__panel", true)("disabled", ctx.disabled || null);
    } }, inputs: { isOpen: "isOpen", size: "size", disabled: "disabled", isSearch: "isSearch", tableSelect: "tableSelect", validateStatus: "validateStatus", placeholder: "placeholder" }, outputs: { onOpenChange: "onOpenChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NmSelectComponent_1),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 19, consts: [[1, "nm-hidden"], ["type", "text", "aria-expanded", "true", 3, "autofocus"], ["hiddenInput", ""], [1, "select__header", "select-width", "input-group", 3, "click"], ["class", "select__item", "style", "opacity: 0.4", 4, "ngIf"], ["class", "select__item", 3, "opacity", 4, "ngIf"], ["class", "select-width", 4, "ngIf"], ["class", "affix__panel input-group-suffix dropdown-arrow-item", 4, "ngIf"], [3, "tableSelect"], ["class", "option__panel-item", 3, "option__active", "click", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "select__item", 2, "opacity", "0.4"], [1, "select__item"], [4, "ngIf"], [1, "select-width"], [3, "disabled", "value", "showInput", "focusTrigger", "valueChange"], [1, "affix__panel", "input-group-suffix", "dropdown-arrow-item"], ["xmlns", "http://www.w3.org/2000/svg", "width", "20", "height", "20", "viewBox", "0 0 16 16", "fill", "none"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M2.31319 4.98043C2.50846 4.78517 2.82504 4.78517 3.0203 4.98043L8.00008 9.96021L12.9799 4.98043C13.1751 4.78517 13.4917 4.78517 13.687 4.98043C13.8822 5.17569 13.8822 5.49228 13.687 5.68754L8.35363 11.0209C8.15837 11.2161 7.84179 11.2161 7.64653 11.0209L2.31319 5.68754C2.11793 5.49228 2.11793 5.17569 2.31319 4.98043Z", "fill", "#22242C"], [1, "option__panel-item", 3, "click"], [3, "ngTemplateOutlet"]], template: function NmSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "input", 1, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵlistener("click", function NmSelectComponent_Template_div_click_3_listener($event) { return ctx.setOpenState(!ctx.isOpen, $event); });
        ɵngcc0.ɵɵtemplate(4, NmSelectComponent_div_4_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(5, NmSelectComponent_div_5_Template, 2, 3, "div", 5);
        ɵngcc0.ɵɵtemplate(6, NmSelectComponent_div_6_Template, 1, 0, "div", 6);
        ɵngcc0.ɵɵtemplate(7, NmSelectComponent_div_7_Template, 2, 4, "div", 6);
        ɵngcc0.ɵɵtemplate(8, NmSelectComponent_span_8_Template, 4, 0, "span", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "nm-option-wrap", 8);
        ɵngcc0.ɵɵtemplate(10, NmSelectComponent_div_10_Template, 2, 3, "div", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("autofocus", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("dropdown-visible", ctx.isOpen)("table-select", ctx.tableSelect)("size-lg", ctx.size === "large")("size-md", ctx.size === "medium")("size-sm", ctx.size === "small");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isShowPlaceholder);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isShowLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isSearch);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSearch);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showArrow);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("tableSelect", ctx.tableSelect);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.listOfItems)("ngForTrackBy", ctx.trackValue);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, NmSelectSearchComponent, NmOptionWrap], encapsulation: 2, changeDetection: 0 });
NmSelectComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef },
    { type: Renderer2 },
    { type: Overlay },
    { type: ViewContainerRef },
    { type: Platform }
];
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmSelectComponent.prototype, "isOpen", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmSelectComponent.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmSelectComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmSelectComponent.prototype, "isSearch", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmSelectComponent.prototype, "placeholder", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmSelectComponent.prototype, "tableSelect", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmSelectComponent.prototype, "validateStatus", null);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmSelectComponent.prototype, "onOpenChange", void 0);
__decorate([
    ViewChild(NmOptionWrap),
    __metadata("design:type", NmOptionWrap)
], NmSelectComponent.prototype, "optionWrap", void 0);
__decorate([
    ViewChild('hiddenInput'),
    __metadata("design:type", ElementRef)
], NmSelectComponent.prototype, "hiddenInput", void 0);
__decorate([
    ContentChildren(NmOptionComponent, { descendants: true }),
    __metadata("design:type", QueryList)
], NmSelectComponent.prototype, "listNmOptionComponent", void 0);
__decorate([
    ViewChild(NmSelectSearchComponent),
    __metadata("design:type", NmSelectSearchComponent)
], NmSelectComponent.prototype, "selectSearchComponent", void 0);
__decorate([
    HostListener('keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], NmSelectComponent.prototype, "keyDown", null);
NmSelectComponent = NmSelectComponent_1 = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef,
        ElementRef,
        Renderer2,
        Overlay,
        ViewContainerRef,
        Platform])
], NmSelectComponent);

const iconTypeMap = {
    error: 'icon__false',
    success: 'icon__success',
};
let NmFormItemComponent = class NmFormItemComponent {
    constructor(cdr, elementRef) {
        this.cdr = cdr;
        this.elementRef = elementRef;
        this.color = 'default';
        this.size = 'small';
        this.disabled = false;
        this.autoFocus = false;
        this.required = false;
        this.validateControl = null;
        this.iconType = null;
        this.validateString = null;
        this.validateChanges = Subscription.EMPTY;
        this.status = null;
        this.isShowSuccessIcon = false;
        this.makeSuccess = false;
        this.onDestroy = new Subject();
        // do not remove elementRef, this is using another component
    }
    set validateStatus(value) {
        if (value instanceof AbstractControl || value instanceof NgModel) {
            this.validateControl = value;
            this.validateString = null;
            this.watchControl();
        }
        else if (value instanceof FormControlName) {
            this.validateControl = value.control;
            this.validateString = null;
            this.watchControl();
        }
        else {
            this.validateString = value;
            this.validateControl = null;
            this.setStatus();
        }
    }
    onItemClick($event = null) {
        if (this.selectComponent) {
            this.selectComponent.setOpenState(true);
        }
    }
    watchControl() {
        this.validateChanges.unsubscribe();
        if (this.validateControl && this.validateControl.statusChanges) {
            this.validateChanges = this.validateControl.statusChanges.pipe(takeUntil(this.onDestroy)).subscribe(_ => {
                this.setStatus();
                if (this.selectComponent) {
                    this.selectComponent.validateStatus = this.status;
                }
                this.cdr.markForCheck();
            });
        }
    }
    setStatus() {
        this.status = this.getControlStatus(this.validateString);
        this.iconType = this.status ? iconTypeMap[this.status] : null;
        this.alertTip = this.getInnerTip(this.status);
    }
    getControlStatus(validateString) {
        let status;
        if (validateString === 'error' || this.validateControlStatus('INVALID')) {
            status = 'error';
        }
        else if (validateString === 'success' || this.validateControlStatus('VALID')) {
            status = 'success';
        }
        else {
            status = null;
        }
        return status;
    }
    validateControlStatus(validStatus, statusType) {
        if (!this.validateControl) {
            return false;
        }
        else {
            const { dirty, touched, status } = this.validateControl;
            return (!!dirty || !!touched) && (statusType ? this.validateControl.hasError(statusType) : status === validStatus);
        }
    }
    getInnerTip(status) {
        switch (status) {
            case 'error':
                return this.alertError || null;
            case 'success':
                return this.alertSuccess || null;
            default:
                return null;
        }
    }
    ngOnInit() {
        this.setStatus();
    }
    ngOnDestroy() {
        this.onDestroy.next();
        this.onDestroy.complete();
    }
    ngAfterViewInit() {
        if (this.autoFocus) {
            requestAnimationFrame(() => {
                this.onItemClick();
            });
        }
    }
    ngAfterContentInit() {
        if (!this.validateControl && !this.validateString) {
            if (this.defaultValidateControl instanceof FormControlDirective) {
                this.validateStatus = this.defaultValidateControl.control;
            }
            else {
                this.validateStatus = this.defaultValidateControl;
            }
        }
    }
};
NmFormItemComponent.ɵfac = function NmFormItemComponent_Factory(t) { return new (t || NmFormItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NmFormItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmFormItemComponent, selectors: [["nm-form-item"]], contentQueries: function NmFormItemComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgControl, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, NmSelectComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.defaultValidateControl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectComponent = _t.first);
    } }, hostVars: 15, hostBindings: function NmFormItemComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NmFormItemComponent_click_HostBindingHandler($event) { return ctx.onItemClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("form-item", true)("form-item-success", ctx.status === "success")("form-item-error", ctx.status === "error")("form-item-alert", ctx.alertTip)("form-item--small", ctx.size === "small")("form-item--medium", ctx.size === "medium")("form-item--large", ctx.size === "large");
    } }, inputs: { color: "color", size: "size", disabled: "disabled", autoFocus: "autoFocus", required: "required", isShowSuccessIcon: "isShowSuccessIcon", makeSuccess: "makeSuccess", validateStatus: "validateStatus", suffix: "suffix", prefix: "prefix", alertSuccess: "alertSuccess", alertError: "alertError", label: "label" }, exportAs: ["nmFormItem"], ngContentSelectors: _c1, decls: 8, vars: 10, consts: [["class", "label__panel", 4, "ngIf"], [1, "form-item__control"], ["class", "affix__panel input-group-prefix", 4, "ngIf"], ["class", "affix__panel input-group-suffix", 4, "ngIf"], ["class", "alert__panel", 4, "ngIf"], [1, "label__panel"], ["class", "color__red", 4, "ngIf"], [1, "color__red"], [1, "affix__panel", "input-group-prefix"], [3, "ngTemplateOutlet"], [1, "affix__panel", "input-group-suffix"], ["width", "20", "height", "20", "viewBox", "0 0 13 9", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "icon__success"], ["d", "M1.04102 4.76471L1.96744 5.77677C3.34735 7.28423 4.0373 8.03796 4.91794 8.03796C5.79857 8.03796 6.48853 7.28423 7.86844 5.77677L12.241 1", "stroke", "#40DA9D", "stroke-linecap", "round", "stroke-linejoin", "round"], ["width", "20", "height", "20", "viewBox", "0 0 16 16", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "icon__false"], ["d", "M1.44211 14.4772C2.00951 15.0957 2.82101 15.3597 3.85463 15.486C4.87938 15.6112 6.22855 15.6112 7.96344 15.6112H8.00022H8.037C9.77188 15.6112 11.1211 15.6112 12.1458 15.486C13.1794 15.3597 13.9909 15.0957 14.5583 14.4772C14.865 14.1428 15.1038 13.752 15.2614 13.3265C15.5528 12.5394 15.4175 11.6968 15.0582 10.7195C14.702 9.75049 14.0863 8.54996 13.2946 7.00623L13.2779 6.97352L13.2606 6.93991C12.3368 5.13838 11.6219 3.74428 10.9609 2.7673C10.2991 1.78909 9.61986 1.11694 8.72296 0.927649C8.24638 0.827068 7.75405 0.827068 7.27747 0.927649C6.38057 1.11694 5.70134 1.78909 5.03954 2.7673C4.37857 3.74428 3.66365 5.13839 2.73979 6.93994L2.72257 6.97352L2.70579 7.00623C1.91413 8.54997 1.29847 9.75049 0.942264 10.7195C0.582976 11.6968 0.447596 12.5394 0.739051 13.3265C0.896604 13.752 1.13539 14.1428 1.44211 14.4772Z", "stroke", "#FF4E4E"], ["d", "M7.55566 4.85703C7.55566 4.62911 7.75465 4.44434 8.00011 4.44434C8.24557 4.44434 8.44455 4.62911 8.44455 4.85703V9.80942C8.44455 10.0373 8.24557 10.2221 8.00011 10.2221C7.75465 10.2221 7.55566 10.0373 7.55566 9.80942V4.85703Z", "fill", "#FF4E4E"], ["d", "M8.88911 12.0002C8.88911 12.4911 8.49114 12.8891 8.00022 12.8891C7.5093 12.8891 7.11133 12.4911 7.11133 12.0002C7.11133 11.5093 7.5093 11.1113 8.00022 11.1113C8.49114 11.1113 8.88911 11.5093 8.88911 12.0002Z", "fill", "#FF4E4E"], [1, "alert__panel"]], template: function NmFormItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NmFormItemComponent_div_0_Template, 4, 2, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, NmFormItemComponent_span_2_Template, 2, 1, "span", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵtemplate(4, NmFormItemComponent_span_4_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵtemplate(5, NmFormItemComponent_span_5_Template, 3, 0, "span", 3);
        ɵngcc0.ɵɵtemplate(6, NmFormItemComponent_span_6_Template, 5, 0, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, NmFormItemComponent_div_7_Template, 2, 1, "div", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("form-item__control-filled", ctx.color === "filled")("form-item__control-disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.prefix);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.suffix && ctx.status !== "error" && !ctx.isShowSuccessIcon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isShowSuccessIcon && (ctx.makeSuccess || ctx.iconType === "icon__success"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.iconType === "icon__false");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.alertTip);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2, changeDetection: 0 });
NmFormItemComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
__decorate([
    Input(),
    __metadata("design:type", String)
], NmFormItemComponent.prototype, "color", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmFormItemComponent.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmFormItemComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmFormItemComponent.prototype, "autoFocus", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmFormItemComponent.prototype, "required", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmFormItemComponent.prototype, "suffix", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmFormItemComponent.prototype, "prefix", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmFormItemComponent.prototype, "alertSuccess", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmFormItemComponent.prototype, "alertError", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmFormItemComponent.prototype, "label", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmFormItemComponent.prototype, "isShowSuccessIcon", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmFormItemComponent.prototype, "makeSuccess", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmFormItemComponent.prototype, "validateStatus", null);
__decorate([
    ContentChild(NgControl),
    __metadata("design:type", Object)
], NmFormItemComponent.prototype, "defaultValidateControl", void 0);
__decorate([
    ContentChild(NmSelectComponent),
    __metadata("design:type", NmSelectComponent)
], NmFormItemComponent.prototype, "selectComponent", void 0);
NmFormItemComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef,
        ElementRef])
], NmFormItemComponent);

let NmInputGroupComponent = class NmInputGroupComponent {
    ngAfterContentInit() {
        if (this.formItemComponent) {
            this.formItemComponent.suffix = this.suffix;
            this.formItemComponent.prefix = this.prefix;
        }
    }
};
NmInputGroupComponent.ɵfac = function NmInputGroupComponent_Factory(t) { return new (t || NmInputGroupComponent)(); };
NmInputGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmInputGroupComponent, selectors: [["nm-input-group"]], contentQueries: function NmInputGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NmFormItemComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formItemComponent = _t.first);
    } }, hostVars: 2, hostBindings: function NmInputGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("input-group", true);
    } }, inputs: { prefix: "prefix", suffix: "suffix" }, ngContentSelectors: _c1, decls: 5, vars: 2, consts: [[3, "ngIf", "ngIfElse"], ["affixTemplate", ""], ["contentTemplate", ""], [3, "ngTemplateOutlet"]], template: function NmInputGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NmInputGroupComponent_ng_template_0_Template, 1, 1, "ng-template", 0);
        ɵngcc0.ɵɵtemplate(1, NmInputGroupComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, NmInputGroupComponent_ng_template_3_Template, 1, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r3 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.prefix || ctx.suffix)("ngIfElse", _r3);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmInputGroupComponent.prototype, "prefix", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmInputGroupComponent.prototype, "suffix", void 0);
__decorate([
    ContentChild(NmFormItemComponent),
    __metadata("design:type", NmFormItemComponent)
], NmInputGroupComponent.prototype, "formItemComponent", void 0);

let NmCalcInputComponent = class NmCalcInputComponent {
    constructor(ngControl) {
        this.ngControl = ngControl;
        this.suffix = '₽';
        this._disabled = false;
        this.disabled$ = new Subject();
        this.destroy$ = new Subject();
        this.onChange = () => {
        };
        this.onTouched = () => {
        };
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
    }
    get disabled() {
        if (this.ngControl && this.ngControl.disabled !== null) {
            return this.ngControl.disabled;
        }
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = value != null && `${value}` !== 'false';
    }
    writeValue(value) {
        const data = value ? value.toString().replace(/,/g, '.') : value;
        this.currentValue = this.validNumber(data) ? data : 0;
        this.counterField.nativeElement.value = this.currentValue;
        this.setValue();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    ngOnInit() {
        var _a;
        if (this.ngControl) {
            (_a = this.ngControl.statusChanges) === null || _a === void 0 ? void 0 : _a.pipe(filter(() => this.ngControl.disabled !== null), takeUntil(this.destroy$)).subscribe(() => {
                this.disabled$.next(this.ngControl.disabled);
            });
        }
    }
    ngOnChanges(changes) {
        const { disabled } = changes;
        if (disabled) {
            this.disabled$.next(this.disabled);
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    setValue() {
        const { value } = this.counterField.nativeElement;
        const data = value ? value.toString().replace(/,/g, '.') : value;
        const isCorrect = this.validNumber(data);
        if (isCorrect) {
            this.counterField.nativeElement.value = data;
            this.counterField.nativeElement.oldValue = this.counterField.nativeElement.value;
            this.counterField.nativeElement.oldSelectionStart = this.counterField.nativeElement.selectionStart;
            this.counterField.nativeElement.oldSelectionEnd = this.counterField.nativeElement.selectionEnd;
        }
        else if (this.counterField.nativeElement.hasOwnProperty('oldValue')) {
            this.counterField.nativeElement.value = this.counterField.nativeElement.oldValue;
            this.counterField.nativeElement.setSelectionRange(this.counterField.nativeElement.oldSelectionStart, this.counterField.nativeElement.oldSelectionEnd);
        }
        else {
            this.counterField.nativeElement.value = '';
        }
        this.onChange(this.counterField.nativeElement.value);
    }
    validNumber(value) {
        return /^\d*[.,]?\d*$/.test(value) && (value === '' || parseInt(value, 10) >= 0);
    }
};
NmCalcInputComponent.ɵfac = function NmCalcInputComponent_Factory(t) { return new (t || NmCalcInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl, 10)); };
NmCalcInputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmCalcInputComponent, selectors: [["nm-calc"]], viewQuery: function NmCalcInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c9, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.counterField = _t.first);
    } }, hostVars: 7, hostBindings: function NmCalcInputComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("calc__panel", true)("calc__panel-disabled", ctx.disabled || null)("calc__panel-filled", ctx.color === "filled");
    } }, inputs: { suffix: "suffix", disabled: "disabled", color: "color" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 7, vars: 2, consts: [[1, "counter", "wrapper"], [1, "counter-form"], ["type", "text", "name", "counterValue", "id", "counterValue", "maxlength", "10", "autofocus", "", 1, "counter-value-field", 3, "input"], ["counterField", ""], [1, "counter__value"], [1, "quantity_hidden"]], template: function NmCalcInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("input", function NmCalcInputComponent_Template_input_input_2_listener() { return ctx.setValue(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 4)(5, "span", 5);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵattribute("data-suffix", ctx.suffix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(_r0.value);
    } }, encapsulation: 2 });
NmCalcInputComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }] }
];
__decorate([
    ViewChild('counterField', { static: true }),
    __metadata("design:type", ElementRef)
], NmCalcInputComponent.prototype, "counterField", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmCalcInputComponent.prototype, "color", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmCalcInputComponent.prototype, "suffix", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], NmCalcInputComponent.prototype, "disabled", null);
NmCalcInputComponent = __decorate([ __param(0, Optional()), __param(0, Self()),
    __metadata("design:paramtypes", [NgControl])
], NmCalcInputComponent);

var NmCheckBoxComponent_1;
let NmCheckBoxComponent = NmCheckBoxComponent_1 = class NmCheckBoxComponent {
    constructor() {
        this.disabled = false;
        this.control = false;
        this.nmIndeterminate = false;
        this.checkedChange = new EventEmitter();
        this.isChecked = false;
        this.onChange = () => {
        };
        this.onTouched = () => {
        };
    }
    onHostClick(e) {
        e.preventDefault();
        if (!this.disabled && !this.control) {
            this.updateValue(!this.isChecked);
        }
    }
    updateValue(value) {
        if (this.isChecked !== value) {
            this.isChecked = value;
            this.checkedChange.emit(this.isChecked);
            this.onChange(this.isChecked);
        }
    }
    writeValue(value) {
        this.isChecked = value;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
};
NmCheckBoxComponent.ɵfac = function NmCheckBoxComponent_Factory(t) { return new (t || NmCheckBoxComponent)(); };
NmCheckBoxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmCheckBoxComponent, selectors: [["nm-checkbox"]], hostVars: 2, hostBindings: function NmCheckBoxComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NmCheckBoxComponent_click_HostBindingHandler($event) { return ctx.onHostClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("checkbox--disabled", ctx.disabled);
    } }, inputs: { disabled: "disabled", control: "control", nmIndeterminate: "nmIndeterminate" }, outputs: { checkedChange: "checkedChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NmCheckBoxComponent_1),
                multi: true
            }
        ])], ngContentSelectors: _c1, decls: 5, vars: 3, consts: [[1, "checkbox-item"], ["type", "checkbox", 3, "checked"], [1, "checkmark"], [1, "checkbox-item-label"]], template: function NmCheckBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵelement(1, "input", 1)(2, "span", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nm-checkbox-inter", ctx.nmIndeterminate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("checked", ctx.isChecked);
    } }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmCheckBoxComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmCheckBoxComponent.prototype, "control", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmCheckBoxComponent.prototype, "nmIndeterminate", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmCheckBoxComponent.prototype, "checkedChange", void 0);
NmCheckBoxComponent = NmCheckBoxComponent_1 = __decorate([ __metadata("design:paramtypes", [])
], NmCheckBoxComponent);

let NomiaUiFormModule = class NomiaUiFormModule {
};
NomiaUiFormModule.ɵfac = function NomiaUiFormModule_Factory(t) { return new (t || NomiaUiFormModule)(); };
NomiaUiFormModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiFormModule });
NomiaUiFormModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule] });

const ICONS = {
    addGuestMediumDarkGray: `add-guest_medium_dark-gray`,
    applyBig: `apply_big`,
    arrowDownMiddleDarkGray: `arrow_down_middle_dark-gray`,
    arrowDownSmallGray: `arrow_down_small_gray`,
    arrowRightMediumDarkGray: `arrow_right_medium_dark-gray`,
    arrowUpMediumWhite: `arrow_up_medium_white`,
    arrowUpSmallWhite: `arrow_up_small_white`,
    barscanBigGray: `barscan_big_gray`,
    barscanBigWhite: `barscan_big_white`,
    bellMiddleGray: `bell_middle_gray`,
    bellMiddleWhite: `bell_middle_white`,
    canceledSmallRed: `canceled_small_red`,
    cardBigDarkGray: `card_big_dark-gray`,
    cardMiddleWhite: `card_middle_white`,
    cardSmallDarkGray: `card_small_dark-gray`,
    cashBigDarkGray: `cash_big_dark-gray`,
    cashMiddleWhite: `cash_middle_white`,
    cashSmallDarkGray: `cash_small_dark-gray`,
    cashboxBigLightGray: `cashbox_big_light-gray`,
    cashboxHugeLightGray: `cashbox_huge_light-gray`,
    cashierBigGray: `cashier_big_gray`,
    cashierBigWhite: `cashier_big_white`,
    checkSmallBlue: `check_small_blue`,
    checkSmallGreen: `check_small_green`,
    commentSmallGray: `comment_small_gray`,
    copyMiddleDarkGray: `copy_middle_dark-gray`,
    copyMiddleGray: `copy_middle_gray`,
    createOrderBigDarkGray: `create-order_big_dark-gray`,
    crossBigDarkGray: `cross_big_dark-gray`,
    crossSmallGray: `cross_small_gray`,
    crossSmallWhite: `cross_small_white`,
    dashboardWhite: `dashboard_white`,
    dashboard: `dashboard`,
    editOrderMiddleDarkGray: `edit-order_middle-dark-gray`,
    eraseMiddleDarkGray: `erase_middle_dark-gray`,
    finishMiddleGray: `finish_middle_gray`,
    finishBigDarkGray: `finish_big_dark-gray`,
    gearBigGray: `gear_big_gray`,
    gearBigLightGray: `gear_big_light-gray`,
    gearBigWhite: `gear_big_white`,
    guestMediumDarkGray: `guest_medium_dark-gray`,
    guestMediumGray: `guest_medium_gray`,
    guestMediumWhite: `guest_medium_white`,
    historyBigGray: `history_big_gray`,
    inputMoneyMediumGray: `input_money_medium_gray`,
    logo: `logo`,
    logout: `logout`,
    minusMiddleDarkGray: `minus_middle_dark-gray`,
    modifierMiddleDarkGray: `modifier_middle_dark-gray`,
    modifierSmallGray: `modifier_small_gray`,
    newOrderWhite: `new-order_white`,
    newOrder: `new-order`,
    ordersWhite: `orders_white`,
    orders: `orders`,
    outputMoneyMiddleGray: `output_money_middle_gray`,
    pattern: `pattern`,
    plusMiddleBlue: `plus_middle_blue`,
    plusMiddleDarkGray: `plus_middle_dark-gray`,
    printerBigGray: `printer_big_gray`,
    printerBigWhite: `printer_big_white`,
    receiptBigDarkGray: `receipt_big_dark-gray`,
    return: `return`,
    searchBig: `search_big`,
    search: `search`,
    sonar: `sonar`,
    squareDotsMiddleDarkGray: `square_dots_middle_dark-gray`,
    squareDotsMiddleWhite: `square_dots_middle_white`,
    stubSingle: `stub_single`,
    stubMultiple: `stub_multiple`,
    successMedium: `success_medium`,
    supportBigGray: `support_big_gray`,
    trashMediumDarkGray: `trash_medium_dark-gray`,
    trashMediumWhite: `trash_medium_white`,
    trashMiddleGray: `trash_middle_gray`,
    walletMiddleDarkGray: `wallet_middle_dark-gray`,
    warningMiddleRed: `warning_middle_red`,
    warningMiddleWhite: `warning_middle_white`,
    watchesBigLightGray: `watches_big_light-gray`,
    dinner: `dinner`,
    notFound404: `404`,
    caretIcon: `caret_icon`,
    notificationIcon: `notification_icon`,
    menuIcon: `menu_icon`,
    flagIcon: `flag_icon`,
    applePay: 'apple_pay',
    barscan: 'barscan',
    calendar: 'calendar',
    card: 'card',
    cash: 'cash',
    clock: 'clock',
    clockBlack: 'clos_black',
    course: 'course',
    day: 'day',
    delete: 'delete',
    dov: 'dov',
    duplicate: 'duplicate',
    edit: 'edit',
    enter: 'enter',
    excell: 'excell',
    gift: 'gift',
    goals: 'goals',
    google_pay: 'google_pay',
    gps: 'gps',
    graph: 'graph',
    guestAdd: 'guest_add',
    guestBlack: 'guest_black',
    iconView: 'icon_view',
    infinite: 'infinite',
    lamp: 'lamp',
    loyality: 'loyality',
    mastercard: 'mastercard',
    minusBlack: 'minus_black',
    more: 'more',
    night: 'night',
    offer: 'offer',
    orderClose: 'order_close',
    pay: 'pay',
    pdf: 'pdf',
    phoneCall: 'phone_call',
    play: 'play',
    plusBlack: 'plus_black',
    pos: 'pos',
    printReceipt: 'print_receipt',
    productReceipt: 'product_receipt',
    production: 'production',
    raitingLower: 'raiting_lower',
    raitingSame: 'raiting_same',
    raitingUpper: 'raiting_upper',
    redo: 'redo',
    resizeArea: 'resize-area',
    ruble: 'ruble',
    samsungPay: 'samsung_pay',
    sections: 'sections',
    sevronDown: 'sevron_down',
    sevronLeft: 'sevron_left',
    sevronRight: 'sevron_right',
    sevronUp: 'sevron_up',
    share: 'share',
    share2: 'share_2',
    shop: 'shop',
    shopItem: 'shop_item',
    shoppingCart: 'shopping_cart',
    showcase: 'showcase',
    sortArrows: 'sort_arrows',
    storageTracking: 'storage_tracking',
    success: 'success',
    successBold: 'success_bold',
    tableView: 'table_view',
    tags: 'tags',
    undo: 'undo',
    visa: 'visa',
    visible: 'visible',
    visibleNo: 'visible_no',
    warehouse: 'warehouse',
    warning: 'warning'
};

let NmPinCodeComponent = class NmPinCodeComponent {
    constructor() {
        this.pin = [1, 1, 1, 1]; // password or pin code which will be compared
        this.enableBgError = false; // Enable or Disable background color when pin is wrong entered.
        this.buttonColor = 'secondary';
        this.resultChange = new EventEmitter();
        this.padValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 'Сброс', 0, undefined]; // by default
        this.pinValue = [];
        this.icons = ICONS;
    }
    editPinValue(padValue) {
        if (typeof padValue === 'number') {
            this.pinValue.push(padValue);
            if (this.pinValue.length === this.pin.length) {
                this.checkPin();
            }
        }
        else if (typeof padValue === 'string') {
            this.pinValue = [];
        }
        else {
            this.pinValue.splice(-1, 1);
        }
    }
    checkPin() {
        const pin = this.pin.join();
        const pinValue = this.pinValue.join();
        this.success = pin === pinValue;
        this.pinValue = [];
        this.resultChange.emit(this.success);
        if (this.success === false) {
            this.pinpadSection.nativeElement.classList.add('section-pinpad_error');
        }
        setTimeout(() => {
            this.success = undefined;
            this.pinpadSection.nativeElement.classList.remove('section-pinpad_error');
        }, 2000);
    }
};
NmPinCodeComponent.ɵfac = function NmPinCodeComponent_Factory(t) { return new (t || NmPinCodeComponent)(); };
NmPinCodeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmPinCodeComponent, selectors: [["nm-pin-code"]], viewQuery: function NmPinCodeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c10, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.pinpadSection = _t.first);
    } }, hostAttrs: [1, "pin-code__panel"], inputs: { pin: "pin", enableBgError: "enableBgError", buttonColor: "buttonColor" }, outputs: { resultChange: "resultChange" }, decls: 9, vars: 2, consts: [[1, "section", "section-pinpad"], ["pinpadSection", ""], [1, "d-flex", "direction-column", "align-center", "align-middle"], [1, "h3", "pin__title"], [1, "d-flex", "justify-center", "pin__wrapper"], [4, "ngFor", "ngForOf"], [1, "pinpad__wrapper", "d-flex"], [1, "pin__dot"], ["nm-button", "", "size", "large", 3, "color", "click", 4, "ngIf"], ["nm-button", "", "color", "transparent", "size", "large", 3, "click", 4, "ngIf"], ["nm-button", "", "size", "large", 3, "color", "click"], ["nm-button", "", "color", "transparent", "size", "large", 3, "click"], [3, "iconName"]], template: function NmPinCodeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2)(3, "h3", 3);
        ɵngcc0.ɵɵtext(4, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 PIN-\u043A\u043E\u0434 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, NmPinCodeComponent_ng_container_6_Template, 2, 2, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, NmPinCodeComponent_ng_container_8_Template, 3, 2, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.pin);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.padValues);
    } }, dependencies: function () { return [ɵngcc1.NgForOf, ɵngcc1.NgIf, NmButton, IconLoaderComponent]; }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array)
], NmPinCodeComponent.prototype, "pin", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmPinCodeComponent.prototype, "enableBgError", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmPinCodeComponent.prototype, "buttonColor", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmPinCodeComponent.prototype, "resultChange", void 0);
__decorate([
    ViewChild('pinpadSection', { static: false }),
    __metadata("design:type", ElementRef)
], NmPinCodeComponent.prototype, "pinpadSection", void 0);

class IconLoaderConfig {
}

let IconLoaderService = class IconLoaderService {
    constructor(config) {
        if (config) {
            this.setPath(config.path);
        }
    }
    setPath(path) {
        this.spritePath = path;
    }
    getPath() {
        return this.spritePath;
    }
};
IconLoaderService.ɵfac = function IconLoaderService_Factory(t) { return new (t || IconLoaderService)(ɵngcc0.ɵɵinject(IconLoaderConfig, 8)); };
IconLoaderService.ctorParameters = () => [
    { type: IconLoaderConfig, decorators: [{ type: Optional }] }
];
IconLoaderService.ɵprov = ɵɵdefineInjectable({ factory: function IconLoaderService_Factory() { return new IconLoaderService(ɵɵinject(IconLoaderConfig, 8)); }, token: IconLoaderService, providedIn: "root" });
IconLoaderService = __decorate([ __param(0, Optional()),
    __metadata("design:paramtypes", [IconLoaderConfig])
], IconLoaderService);

let IconLoaderComponent = class IconLoaderComponent {
    constructor(iconLoaderService) {
        this.iconLoaderService = iconLoaderService;
    }
    set iconName(value) {
        if (value && !value.includes('#') && this.iconLoaderService.spritePath) {
            this.src = `${this.iconLoaderService.getPath()}#${value}`;
        }
    }
    ;
};
IconLoaderComponent.ɵfac = function IconLoaderComponent_Factory(t) { return new (t || IconLoaderComponent)(ɵngcc0.ɵɵdirectiveInject(IconLoaderService)); };
IconLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: IconLoaderComponent, selectors: [["nm-svg-loader"]], hostVars: 2, hostBindings: function IconLoaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("icon-item", true);
    } }, inputs: { iconName: "iconName", src: "src" }, decls: 2, vars: 1, consts: [["xmlns", "http://www.w3.org/2000/svg", 1, "icon-content"], [1, "ic"]], template: function IconLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "use", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("href", ctx.src, null, "xlink");
    } }, encapsulation: 2, changeDetection: 0 });
IconLoaderComponent.ctorParameters = () => [
    { type: IconLoaderService }
];
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], IconLoaderComponent.prototype, "iconName", null);
__decorate([
    Input(),
    __metadata("design:type", String)
], IconLoaderComponent.prototype, "src", void 0);
IconLoaderComponent = __decorate([ __metadata("design:paramtypes", [IconLoaderService])
], IconLoaderComponent);

var NomiaUiIconSpriteModule_1;
let NomiaUiIconSpriteModule = NomiaUiIconSpriteModule_1 = class NomiaUiIconSpriteModule {
    static forRoot(config) {
        return {
            ngModule: NomiaUiIconSpriteModule_1,
            providers: [
                { provide: IconLoaderConfig, useValue: config }
            ]
        };
    }
};
NomiaUiIconSpriteModule.ɵfac = function NomiaUiIconSpriteModule_Factory(t) { return new (t || NomiaUiIconSpriteModule)(); };
NomiaUiIconSpriteModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiIconSpriteModule });
NomiaUiIconSpriteModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let NomiaUiPinCodeModule = class NomiaUiPinCodeModule {
};
NomiaUiPinCodeModule.ɵfac = function NomiaUiPinCodeModule_Factory(t) { return new (t || NomiaUiPinCodeModule)(); };
NomiaUiPinCodeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiPinCodeModule });
NomiaUiPinCodeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        NomiaUiButtonModule,
        NomiaUiIconSpriteModule] });

let NmTableContentComponent = class NmTableContentComponent {
    constructor() {
        this.tableLayout = 'auto';
        this.theadTemplate = null;
        this.contentTemplate = null;
        this.listOfColWidth = [];
    }
};
NmTableContentComponent.ɵfac = function NmTableContentComponent_Factory(t) { return new (t || NmTableContentComponent)(); };
NmTableContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTableContentComponent, selectors: [["table", "nm-table-content", ""]], hostVars: 2, hostBindings: function NmTableContentComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("table-layout", ctx.tableLayout);
    } }, inputs: { tableLayout: "tableLayout", theadTemplate: "theadTemplate", contentTemplate: "contentTemplate", listOfColWidth: "listOfColWidth" }, attrs: _c11, ngContentSelectors: _c1, decls: 3, vars: 2, consts: [["class", "nm-table-thead", 4, "ngIf"], [3, "ngTemplateOutlet"], [1, "nm-table-thead"]], template: function NmTableContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NmTableContentComponent_thead_0_Template, 2, 1, "thead", 0);
        ɵngcc0.ɵɵtemplate(1, NmTableContentComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
        ɵngcc0.ɵɵprojection(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.theadTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmTableContentComponent.prototype, "tableLayout", void 0);
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], NmTableContentComponent.prototype, "theadTemplate", void 0);
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], NmTableContentComponent.prototype, "contentTemplate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], NmTableContentComponent.prototype, "listOfColWidth", void 0);

let NmTableInnerComponent = class NmTableInnerComponent {
    constructor() {
        this.theadTemplate = null;
        this.contentTemplate = null;
    }
};
NmTableInnerComponent.ɵfac = function NmTableInnerComponent_Factory(t) { return new (t || NmTableInnerComponent)(); };
NmTableInnerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTableInnerComponent, selectors: [["nm-table-inner"]], hostVars: 2, hostBindings: function NmTableInnerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nm-table-container", true);
    } }, inputs: { theadTemplate: "theadTemplate", contentTemplate: "contentTemplate" }, decls: 2, vars: 2, consts: [[1, "nm-table-content"], ["nm-table-content", "", 3, "theadTemplate", "contentTemplate"]], template: function NmTableInnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "table", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("theadTemplate", ctx.theadTemplate)("contentTemplate", ctx.contentTemplate);
    } }, dependencies: [NmTableContentComponent], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], NmTableInnerComponent.prototype, "theadTemplate", void 0);
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], NmTableInnerComponent.prototype, "contentTemplate", void 0);

let NmTableInnerScrollComponent = class NmTableInnerScrollComponent {
    constructor() {
        this.scrollY = null;
        this.contentTemplate = null;
        this.virtualTemplate = null;
        this.theadTemplate = null;
        this.listOfColWidth = [];
        this.onDestroy = new Subject();
    }
    ngOnChanges(changes) {
    }
    ngAfterViewInit() {
    }
    ngOnDestroy() {
        this.onDestroy.next();
        this.onDestroy.complete();
    }
};
NmTableInnerScrollComponent.ɵfac = function NmTableInnerScrollComponent_Factory(t) { return new (t || NmTableInnerScrollComponent)(); };
NmTableInnerScrollComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTableInnerScrollComponent, selectors: [["nm-table-inner-scroll"]], viewQuery: function NmTableInnerScrollComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c12, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tableBodyElement = _t.first);
    } }, hostVars: 2, hostBindings: function NmTableInnerScrollComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nm-table-container", true);
    } }, inputs: { scrollY: "scrollY", contentTemplate: "contentTemplate", virtualTemplate: "virtualTemplate", theadTemplate: "theadTemplate", listOfColWidth: "listOfColWidth" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 3, consts: [[1, "nm-table-content"], ["class", "nm-table-hide-scrollbar", 4, "ngIf"], ["class", "nm-table-body", 4, "ngIf"], ["style", "overflow-y: auto", "class", "table__scroll-item", 3, "height", 4, "ngIf"], [1, "nm-table-hide-scrollbar"], ["tableHeaderElement", ""], ["nm-table-content", "", "tableLayout", "fixed", 3, "listOfColWidth", "theadTemplate"], [1, "nm-table-body"], ["tableBodyElement", ""], ["nm-table-content", "", "tableLayout", "fixed", 3, "listOfColWidth", "theadTemplate", "contentTemplate"], [1, "table__scroll-item", 2, "overflow-y", "auto"], ["nm-table-content", "", "tableLayout", "fixed", 3, "listOfColWidth", "contentTemplate"]], template: function NmTableInnerScrollComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NmTableInnerScrollComponent_div_1_Template, 3, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(2, NmTableInnerScrollComponent_div_2_Template, 3, 3, "div", 2);
        ɵngcc0.ɵɵtemplate(3, NmTableInnerScrollComponent_div_3_Template, 3, 4, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.scrollY);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.virtualTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.virtualTemplate);
    } }, dependencies: [ɵngcc1.NgIf, NmTableContentComponent], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", String)
], NmTableInnerScrollComponent.prototype, "scrollY", void 0);
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], NmTableInnerScrollComponent.prototype, "contentTemplate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmTableInnerScrollComponent.prototype, "virtualTemplate", void 0);
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], NmTableInnerScrollComponent.prototype, "theadTemplate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], NmTableInnerScrollComponent.prototype, "listOfColWidth", void 0);
__decorate([
    ViewChild('tableBodyElement', { read: ElementRef }),
    __metadata("design:type", ElementRef)
], NmTableInnerScrollComponent.prototype, "tableBodyElement", void 0);
NmTableInnerScrollComponent = __decorate([ __metadata("design:paramtypes", [])
], NmTableInnerScrollComponent);

let NmTableStyleService = class NmTableStyleService {
    constructor() {
        this.theadTemplate$ = new Subject();
        this.enableAutoMeasure$ = new Subject();
    }
    setTheadTemplate(template) {
        this.theadTemplate$.next(template);
    }
    setScroll(scrollY) {
        const enableAutoMeasure = !!(scrollY);
        this.enableAutoMeasure$.next(enableAutoMeasure);
    }
};
NmTableStyleService.ɵfac = function NmTableStyleService_Factory(t) { return new (t || NmTableStyleService)(); };
NmTableStyleService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NmTableStyleService, factory: function (t) { return NmTableStyleService.ɵfac(t); } });
NmTableStyleService = __decorate([ __metadata("design:paramtypes", [])
], NmTableStyleService);

let NmTableComponent = class NmTableComponent {
    constructor(nmTableStyleService) {
        this.nmTableStyleService = nmTableStyleService;
        this.nmScroll = { y: null };
        this.scrollY = null;
        this.listOfAutoColWidth = [];
        this.theadTemplate = null;
    }
    ngOnInit() {
        const { theadTemplate$ } = this.nmTableStyleService;
        theadTemplate$.subscribe(theadTemplate => {
            this.theadTemplate = theadTemplate;
        });
    }
    ngOnChanges(changes) {
        const { nmScroll } = changes;
        if (nmScroll) {
            this.scrollY = (this.nmScroll && this.nmScroll.y) || null;
            this.nmTableStyleService.setScroll(this.scrollY);
        }
    }
};
NmTableComponent.ɵfac = function NmTableComponent_Factory(t) { return new (t || NmTableComponent)(ɵngcc0.ɵɵdirectiveInject(NmTableStyleService)); };
NmTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTableComponent, selectors: [["nm-table"]], inputs: { nmScroll: "nmScroll" }, exportAs: ["nmTable"], features: [ɵngcc0.ɵɵProvidersFeature([NmTableStyleService]), ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 7, vars: 2, consts: [[1, "nm-table"], ["tableMainElement", ""], [3, "scrollY", "theadTemplate", "listOfColWidth", "contentTemplate", "virtualTemplate", 4, "ngIf", "ngIfElse"], ["defaultTemplate", ""], ["contentTemplate", ""], [3, "scrollY", "theadTemplate", "listOfColWidth", "contentTemplate", "virtualTemplate"], [3, "theadTemplate", "contentTemplate"]], template: function NmTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, NmTableComponent_nm_table_inner_scroll_2_Template, 1, 5, "nm-table-inner-scroll", 2);
        ɵngcc0.ɵɵtemplate(3, NmTableComponent_ng_template_3_Template, 1, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, NmTableComponent_ng_template_5_Template, 1, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.scrollY)("ngIfElse", _r2);
    } }, dependencies: [ɵngcc1.NgIf, NmTableInnerComponent, NmTableInnerScrollComponent], encapsulation: 2 });
NmTableComponent.ctorParameters = () => [
    { type: NmTableStyleService }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmTableComponent.prototype, "nmScroll", void 0);
NmTableComponent = __decorate([ __metadata("design:paramtypes", [NmTableStyleService])
], NmTableComponent);

let NmThItemComponent = class NmThItemComponent {
    constructor(cdr) {
        this.cdr = cdr;
        this.manualClickOrder$ = new Subject();
        this.sortDirections = ['asc', 'desc']; // [asc. desc. null]
        this.sortOrderChange$ = new Subject();
        this.destroy$ = new Subject();
        this.sortOrder = null;
        this.nmSortOrder = null;
        this.nmSortDirections = ['asc', 'desc'];
        this.showSort = false;
        this.nmSortChange = new EventEmitter();
    }
    getNextSortDirection(sortDirections, current) {
        const index = sortDirections.indexOf(current);
        if (index === sortDirections.length - 1) {
            return sortDirections[0];
        }
        else {
            return sortDirections[index + 1];
        }
    }
    emitNextSortValue() {
        if (this.showSort) {
            const nextOrder = this.getNextSortDirection(this.sortDirections, this.sortOrder);
            this.setSortOrder(nextOrder);
            this.manualClickOrder$.next(this);
        }
    }
    setSortOrder(order) {
        this.sortOrderChange$.next(order);
    }
    ngOnInit() {
        this.sortOrderChange$.pipe(takeUntil(this.destroy$)).subscribe(order => {
            if (this.sortOrder !== order) {
                this.sortOrder = order;
                this.nmSortChange.emit(order);
            }
            this.cdr.markForCheck();
        });
    }
    ngOnChanges(changes) {
        const { nmSortDirections, nmSortOrder, } = changes;
        if (nmSortDirections) {
            if (this.nmSortDirections && this.nmSortDirections.length) {
                this.sortDirections = this.nmSortDirections;
            }
        }
        if (nmSortOrder) {
            this.sortOrder = this.nmSortOrder;
            this.setSortOrder(this.nmSortOrder);
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
};
NmThItemComponent.ɵfac = function NmThItemComponent_Factory(t) { return new (t || NmThItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
NmThItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmThItemComponent, selectors: [["th"]], hostVars: 4, hostBindings: function NmThItemComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NmThItemComponent_click_HostBindingHandler() { return ctx.emitNextSortValue(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nm-table-column-has-sorters", ctx.showSort)("nm-table-column-sort", ctx.sortOrder === "desc" || ctx.sortOrder === "asc");
    } }, inputs: { nmSortOrder: "nmSortOrder", nmSortDirections: "nmSortDirections", showSort: "showSort", columnKey: "columnKey" }, outputs: { nmSortChange: "nmSortChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 5, vars: 1, consts: [[3, "ngTemplateOutlet"], ["sortTemplate", ""], ["contentTemplate", ""], [3, "sortOrder", "sortDirections", "contentTemplate"]], template: function NmThItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NmThItemComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵtemplate(1, NmThItemComponent_ng_template_1_Template, 1, 3, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, NmThItemComponent_ng_template_3_Template, 1, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        const _r3 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.showSort ? _r1 : _r3);
    } }, dependencies: function () { return [ɵngcc1.NgTemplateOutlet, NmTableSortersComponent]; }, encapsulation: 2 });
NmThItemComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    Input(),
    __metadata("design:type", String)
], NmThItemComponent.prototype, "columnKey", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmThItemComponent.prototype, "nmSortOrder", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], NmThItemComponent.prototype, "nmSortDirections", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmThItemComponent.prototype, "showSort", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], NmThItemComponent.prototype, "nmSortChange", void 0);
NmThItemComponent = __decorate([ __metadata("design:paramtypes", [ChangeDetectorRef])
], NmThItemComponent);

let NmTheadComponent = class NmTheadComponent {
    constructor(elementRef, renderer, nmTableStyleService) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.nmTableStyleService = nmTableStyleService;
        this.nmSortChange = new EventEmitter();
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        if (this.nmTableStyleService) {
            this.nmTableStyleService.setTheadTemplate(this.templateRef);
        }
    }
    ngOnChanges(changes) {
    }
    ngAfterContentInit() {
        const listOfColumn$ = this.listOfThItem.changes.pipe(startWith(this.listOfThItem));
        const manualSort$ = listOfColumn$.pipe(switchMap(() => merge(...this.listOfThItem.map(th => th.manualClickOrder$))), takeUntil(this.destroy$));
        manualSort$.subscribe((data) => {
            const emitValue = { key: data.columnKey, value: data.sortOrder };
            this.nmSortChange.emit(emitValue);
        });
    }
    ngAfterViewInit() {
        if (this.nmTableStyleService) {
            this.renderer.removeChild(this.renderer.parentNode(this.elementRef.nativeElement), this.elementRef.nativeElement);
        }
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
};
NmTheadComponent.ɵfac = function NmTheadComponent_Factory(t) { return new (t || NmTheadComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(NmTableStyleService, 8)); };
NmTheadComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTheadComponent, selectors: [["thead", 9, "nm-table-thead"]], contentQueries: function NmTheadComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NmThItemComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listOfThItem = _t);
    } }, viewQuery: function NmTheadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c13, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, outputs: { nmSortChange: "nmSortChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 2, vars: 0, consts: [["contentTemplate", ""]], template: function NmTheadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NmTheadComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, encapsulation: 2 });
NmTheadComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: NmTableStyleService, decorators: [{ type: Optional }] }
];
__decorate([
    ViewChild('contentTemplate', { static: true }),
    __metadata("design:type", TemplateRef)
], NmTheadComponent.prototype, "templateRef", void 0);
__decorate([
    ContentChildren(NmThItemComponent, { descendants: true }),
    __metadata("design:type", QueryList)
], NmTheadComponent.prototype, "listOfThItem", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], NmTheadComponent.prototype, "nmSortChange", void 0);
NmTheadComponent = __decorate([ __param(2, Optional()),
    __metadata("design:paramtypes", [ElementRef,
        Renderer2,
        NmTableStyleService])
], NmTheadComponent);

let NmTbodyComponent = class NmTbodyComponent {
    constructor(nmTableStyleService) {
        this.nmTableStyleService = nmTableStyleService;
    }
};
NmTbodyComponent.ɵfac = function NmTbodyComponent_Factory(t) { return new (t || NmTbodyComponent)(ɵngcc0.ɵɵdirectiveInject(NmTableStyleService, 8)); };
NmTbodyComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTbodyComponent, selectors: [["tbody"]], hostVars: 2, hostBindings: function NmTbodyComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nm-table-tbody", true);
    } }, ngContentSelectors: _c1, decls: 1, vars: 0, template: function NmTbodyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
NmTbodyComponent.ctorParameters = () => [
    { type: NmTableStyleService, decorators: [{ type: Optional }] }
];
NmTbodyComponent = __decorate([ __param(0, Optional()),
    __metadata("design:paramtypes", [NmTableStyleService])
], NmTbodyComponent);

let NmTrDirective = class NmTrDirective {
    constructor(nmTableStyleService) {
        this.nmTableStyleService = nmTableStyleService;
        this.destroy$ = new Subject();
        this.isInsideTable = false;
    }
    ngAfterContentInit() {
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
};
NmTrDirective.ɵfac = function NmTrDirective_Factory(t) { return new (t || NmTrDirective)(ɵngcc0.ɵɵdirectiveInject(NmTableStyleService, 8)); };
NmTrDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmTrDirective, selectors: [["tr", 3, "nm-table-fixed-row", ""]], hostVars: 2, hostBindings: function NmTrDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nm-table-row", ctx.isInsideTable);
    } } });
NmTrDirective.ctorParameters = () => [
    { type: NmTableStyleService, decorators: [{ type: Optional }] }
];
NmTrDirective = __decorate([ __param(0, Optional()),
    __metadata("design:paramtypes", [NmTableStyleService])
], NmTrDirective);

let NmTableSortersComponent = class NmTableSortersComponent {
    constructor() {
        this.sortDirections = ['asc', 'desc', null];
        this.sortOrder = null;
        this.contentTemplate = null;
        this.isUp = false;
        this.isDown = false;
        this.icons = ICONS;
    }
    ngOnChanges(changes) {
        const { sortDirections } = changes;
        if (sortDirections) {
            this.isUp = this.sortDirections.indexOf('asc') !== -1;
            this.isDown = this.sortDirections.indexOf('desc') !== -1;
        }
    }
};
NmTableSortersComponent.ɵfac = function NmTableSortersComponent_Factory(t) { return new (t || NmTableSortersComponent)(); };
NmTableSortersComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTableSortersComponent, selectors: [["nm-table-sorters"]], hostVars: 2, hostBindings: function NmTableSortersComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nm-table-column-sorters", true);
    } }, inputs: { sortDirections: "sortDirections", sortOrder: "sortOrder", contentTemplate: "contentTemplate" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 6, vars: 5, consts: [[3, "ngTemplateOutlet"], [1, "nm-table-column-sorter"], [1, "nm-table-column-sorter-inner"], ["class", "nm-table-column-sorter-up", 3, "iconName", "active", 4, "ngIf"], ["class", "nm-table-column-sorter-down", 3, "iconName", "active", 4, "ngIf"], [1, "nm-table-column-sorter-up", 3, "iconName"], [1, "nm-table-column-sorter-down", 3, "iconName"]], template: function NmTableSortersComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span");
        ɵngcc0.ɵɵtemplate(1, NmTableSortersComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "span", 1)(3, "span", 2);
        ɵngcc0.ɵɵtemplate(4, NmTableSortersComponent_nm_svg_loader_4_Template, 1, 3, "nm-svg-loader", 3);
        ɵngcc0.ɵɵtemplate(5, NmTableSortersComponent_nm_svg_loader_5_Template, 1, 3, "nm-svg-loader", 4);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("nm-table-column-sorter-full", ctx.isDown && ctx.isUp);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isUp);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isDown);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, IconLoaderComponent], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array)
], NmTableSortersComponent.prototype, "sortDirections", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmTableSortersComponent.prototype, "sortOrder", void 0);
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], NmTableSortersComponent.prototype, "contentTemplate", void 0);

let NmCellEditorComponent = class NmCellEditorComponent {
    constructor(el) {
        this.el = el;
        this.editing = false;
    }
    editingCell() {
        this.editing = true;
    }
    closeEditingCell() {
        this.editing = false;
    }
};
NmCellEditorComponent.ɵfac = function NmCellEditorComponent_Factory(t) { return new (t || NmCellEditorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NmCellEditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmCellEditorComponent, selectors: [["nm-cell-editor"]], inputs: { inputTemplate: "inputTemplate", outPutTemplate: "outPutTemplate" }, exportAs: ["nmCellEditor"], decls: 2, vars: 2, consts: [[4, "ngIf"], [4, "ngTemplateOutlet"]], template: function NmCellEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NmCellEditorComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, NmCellEditorComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.editing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.editing);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
NmCellEditorComponent.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], NmCellEditorComponent.prototype, "inputTemplate", void 0);
__decorate([
    Input(),
    __metadata("design:type", TemplateRef)
], NmCellEditorComponent.prototype, "outPutTemplate", void 0);
NmCellEditorComponent = __decorate([ __metadata("design:paramtypes", [ElementRef])
], NmCellEditorComponent);

let NmTdEditorComponent = class NmTdEditorComponent {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.clickListener = (event) => {
            this.documentClickEvent(event);
        };
    }
    onClick(event) {
        this.openCell();
    }
    keyDown(event) {
        this.onKeyDown(event);
    }
    ngAfterContentInit() {
        document.addEventListener('click', this.clickListener, false);
    }
    ngOnDestroy() {
        document.removeEventListener('click', this.clickListener, false);
    }
    documentClickEvent(event) {
        const targetElement = event.target;
        if (!targetElement) {
            return;
        }
        const clickedInside = this.el.nativeElement.contains(targetElement) || this.el.nativeElement.isSameNode(targetElement);
        if (!clickedInside) {
            this.closeCell();
        }
    }
    onKeyDown(e) {
        if (e.key === 'Escape' || e.keyCode === ESCAPE) {
            this.closeCell();
        }
        if (e.key === 'Enter' || e.keyCode === ENTER) {
            this.closeCell();
        }
    }
    openCell() {
        this.renderer.addClass(this.el.nativeElement, 'td-editing');
        this.contentComponent.editingCell();
    }
    closeCell() {
        this.renderer.removeClass(this.el.nativeElement, 'td-editing');
        this.contentComponent.closeEditingCell();
    }
};
NmTdEditorComponent.ɵfac = function NmTdEditorComponent_Factory(t) { return new (t || NmTdEditorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NmTdEditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTdEditorComponent, selectors: [["", "tdEditable", ""]], contentQueries: function NmTdEditorComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NmCellEditorComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentComponent = _t.first);
    } }, hostAttrs: [1, "td-editable"], hostBindings: function NmTdEditorComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NmTdEditorComponent_click_HostBindingHandler($event) { return ctx.onClick($event); })("keydown", function NmTdEditorComponent_keydown_HostBindingHandler($event) { return ctx.keyDown($event); });
    } }, exportAs: ["tdEditable"], attrs: _c14, ngContentSelectors: _c1, decls: 1, vars: 0, template: function NmTdEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0, 0, ["#contentComponent", ""]);
    } }, encapsulation: 2 });
NmTdEditorComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
__decorate([
    ContentChild(NmCellEditorComponent),
    __metadata("design:type", NmCellEditorComponent)
], NmTdEditorComponent.prototype, "contentComponent", void 0);
__decorate([
    HostListener('click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MouseEvent]),
    __metadata("design:returntype", void 0)
], NmTdEditorComponent.prototype, "onClick", null);
__decorate([
    HostListener('keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], NmTdEditorComponent.prototype, "keyDown", null);
NmTdEditorComponent = __decorate([ __metadata("design:paramtypes", [ElementRef,
        Renderer2])
], NmTdEditorComponent);

let NmCellWidthDirective = class NmCellWidthDirective {
};
NmCellWidthDirective.ɵfac = function NmCellWidthDirective_Factory(t) { return new (t || NmCellWidthDirective)(); };
NmCellWidthDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmCellWidthDirective, selectors: [["", "cellWidth", ""]], hostVars: 4, hostBindings: function NmCellWidthDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.cellWidth, "px")("min-width", ctx.cellWidth, "px");
    } }, inputs: { cellWidth: "cellWidth" } });
__decorate([
    Input(),
    __metadata("design:type", String)
], NmCellWidthDirective.prototype, "cellWidth", void 0);

let ClickOutsideDirective = class ClickOutsideDirective {
    constructor(_el, _ngZone) {
        this._el = _el;
        this._ngZone = _ngZone;
        this.clickOutsideEnabled = true;
        this.attachOutsideOnClick = false;
        this.delayClickOutsideInit = false;
        this.emitOnBlur = false;
        this.exclude = '';
        this.excludeBeforeClick = false;
        this.clickOutsideEvents = '';
        this.clickOutside = new EventEmitter();
        this._nodesExcluded = [];
        this._events = ['click'];
        this._initOnClickBody = this._initOnClickBody.bind(this);
        this._onClickBody = this._onClickBody.bind(this);
        this._onWindowBlur = this._onWindowBlur.bind(this);
    }
    ngOnInit() {
        this._init();
    }
    ngOnDestroy() {
        this._removeClickOutsideListener();
        this._removeAttachOutsideOnClickListener();
        this._removeWindowBlurListener();
    }
    ngOnChanges(changes) {
        if (changes['attachOutsideOnClick'] || changes['exclude'] || changes['emitOnBlur']) {
            this._init();
        }
    }
    _init() {
        if (this.clickOutsideEvents !== '') {
            this._events = this.clickOutsideEvents.split(',').map(e => e.trim());
        }
        this._excludeCheck();
        if (this.attachOutsideOnClick) {
            this._initAttachOutsideOnClickListener();
        }
        else {
            this._initOnClickBody();
        }
        if (this.emitOnBlur) {
            this._initWindowBlurListener();
        }
    }
    _initOnClickBody() {
        if (this.delayClickOutsideInit) {
            setTimeout(this._initClickOutsideListener.bind(this));
        }
        else {
            this._initClickOutsideListener();
        }
    }
    _excludeCheck() {
        if (this.exclude) {
            try {
                const nodes = Array.from(document.querySelectorAll(this.exclude));
                if (nodes) {
                    this._nodesExcluded = nodes;
                }
            }
            catch (err) {
                console.error('error syntax', err);
            }
        }
    }
    _onClickBody(ev) {
        if (!this.clickOutsideEnabled) {
            return;
        }
        if (this.excludeBeforeClick) {
            this._excludeCheck();
        }
        if (!this._el.nativeElement.contains(ev.target) && !this._shouldExclude(ev.target)) {
            this._emit(ev);
            if (this.attachOutsideOnClick) {
                this._removeClickOutsideListener();
            }
        }
    }
    _onWindowBlur(ev) {
        setTimeout(() => {
            if (!document.hidden) {
                this._emit(ev);
            }
        });
    }
    _emit(ev) {
        if (!this.clickOutsideEnabled) {
            return;
        }
        this._ngZone.run(() => this.clickOutside.emit(ev));
    }
    _shouldExclude(target) {
        for (let excludedNode of this._nodesExcluded) {
            if (excludedNode.contains(target)) {
                return true;
            }
        }
        return false;
    }
    _initClickOutsideListener() {
        this._ngZone.runOutsideAngular(() => {
            this._events.forEach(e => document.addEventListener(e, this._onClickBody));
        });
    }
    _removeClickOutsideListener() {
        this._ngZone.runOutsideAngular(() => {
            this._events.forEach(e => document.removeEventListener(e, this._onClickBody));
        });
    }
    _initAttachOutsideOnClickListener() {
        this._ngZone.runOutsideAngular(() => {
            this._events.forEach(e => this._el.nativeElement.addEventListener(e, this._initOnClickBody));
        });
    }
    _removeAttachOutsideOnClickListener() {
        this._ngZone.runOutsideAngular(() => {
            this._events.forEach(e => this._el.nativeElement.removeEventListener(e, this._initOnClickBody));
        });
    }
    _initWindowBlurListener() {
        this._ngZone.runOutsideAngular(() => {
            window.addEventListener('blur', this._onWindowBlur);
        });
    }
    _removeWindowBlurListener() {
        this._ngZone.runOutsideAngular(() => {
            window.removeEventListener('blur', this._onWindowBlur);
        });
    }
};
ClickOutsideDirective.ɵfac = function ClickOutsideDirective_Factory(t) { return new (t || ClickOutsideDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
ClickOutsideDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ClickOutsideDirective, selectors: [["", "clickOutside", ""]], inputs: { clickOutsideEnabled: "clickOutsideEnabled", attachOutsideOnClick: "attachOutsideOnClick", delayClickOutsideInit: "delayClickOutsideInit", emitOnBlur: "emitOnBlur", exclude: "exclude", excludeBeforeClick: "excludeBeforeClick", clickOutsideEvents: "clickOutsideEvents" }, outputs: { clickOutside: "clickOutside" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
ClickOutsideDirective.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ClickOutsideDirective, factory: function (t) { return ClickOutsideDirective.ɵfac(t); } });
ClickOutsideDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ClickOutsideDirective.prototype, "clickOutsideEnabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ClickOutsideDirective.prototype, "attachOutsideOnClick", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ClickOutsideDirective.prototype, "delayClickOutsideInit", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ClickOutsideDirective.prototype, "emitOnBlur", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ClickOutsideDirective.prototype, "exclude", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], ClickOutsideDirective.prototype, "excludeBeforeClick", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ClickOutsideDirective.prototype, "clickOutsideEvents", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], ClickOutsideDirective.prototype, "clickOutside", void 0);
ClickOutsideDirective = __decorate([ __metadata("design:paramtypes", [ElementRef,
        NgZone])
], ClickOutsideDirective);

let NomiaUiDirectivesModule = class NomiaUiDirectivesModule {
};
NomiaUiDirectivesModule.ɵfac = function NomiaUiDirectivesModule_Factory(t) { return new (t || NomiaUiDirectivesModule)(); };
NomiaUiDirectivesModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiDirectivesModule });
NomiaUiDirectivesModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let NomiaUiTableModule = class NomiaUiTableModule {
};
NomiaUiTableModule.ɵfac = function NomiaUiTableModule_Factory(t) { return new (t || NomiaUiTableModule)(); };
NomiaUiTableModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiTableModule });
NomiaUiTableModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        NomiaUiIconSpriteModule,
        NomiaUiDirectivesModule] });

let CustomCurrencyPipe = class CustomCurrencyPipe {
    transform(value) {
        switch (value) {
            case Currencies.RUB: {
                this.currency = '₽';
                break;
            }
            case Currencies.USD: {
                this.currency = '$';
                break;
            }
            case Currencies.EUR: {
                this.currency = '€';
            }
            case Currencies.KZT: {
                this.currency = '₸';
            }
        }
        return this.currency;
    }
};
CustomCurrencyPipe.ɵfac = function CustomCurrencyPipe_Factory(t) { return new (t || CustomCurrencyPipe)(); };
CustomCurrencyPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "customCurrency", type: CustomCurrencyPipe, pure: true });
var Currencies;
(function (Currencies) {
    Currencies["RUB"] = "RUB";
    Currencies["USD"] = "USD";
    Currencies["EUR"] = "EUR";
    Currencies["KZT"] = "KZT";
})(Currencies || (Currencies = {}));

let NoCommasPipe = class NoCommasPipe {
    transform(value) {
        if (value !== null && value !== undefined) {
            const index = value.toString().indexOf('.');
            if (index > 0) {
                return +value.toString().slice(0, index + 3);
            }
            else {
                return value;
            }
        }
        else {
            return 0;
        }
    }
};
NoCommasPipe.ɵfac = function NoCommasPipe_Factory(t) { return new (t || NoCommasPipe)(); };
NoCommasPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "noCommas", type: NoCommasPipe, pure: true });

let NomiaUiPipeModule = class NomiaUiPipeModule {
};
NomiaUiPipeModule.ɵfac = function NomiaUiPipeModule_Factory(t) { return new (t || NomiaUiPipeModule)(); };
NomiaUiPipeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiPipeModule });
NomiaUiPipeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let PopularItemComponent = class PopularItemComponent {
    constructor() {
    }
    ngOnInit() {
        this.getMarginStake();
    }
    get percents() {
        return this.item.profitPercent + '%';
    }
    get incomeWidth() {
        return (this.item.revenue / this.maxValue * 100).toFixed(0) + '%';
    }
    get marginWidth() {
        return this.item.profitPercent + '%';
    }
    getMarginStake() {
        const value = this.item.profitPercent;
        if (value <= 30) {
            this.stake = STAKE.LOW;
        }
        else if (value > 30 && value < 70) {
            this.stake = STAKE.MEDIUM;
        }
        else if (value >= 70) {
            this.stake = STAKE.HIGH;
        }
    }
};
PopularItemComponent.ɵfac = function PopularItemComponent_Factory(t) { return new (t || PopularItemComponent)(); };
PopularItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PopularItemComponent, selectors: [["nm-popular-item"]], inputs: { item: "item", index: "index", maxValue: "maxValue" }, decls: 21, vars: 24, consts: [[1, "popular-item", "d-flex", "align-middle"], [1, "popular-item__index", "d-flex", "align-middle", "justify-center", "small-medium"], [1, "chart-block__wrapper", "d-flex", "direction-column"], [1, "d-flex", "align-middle", "justify-space-between"], [1, "small-medium"], [1, "chart__wrapper"], [1, "chart__line", "chart__line_income"], [1, "chart__line", "chart__line_margin"], [1, "small-medium", "chart__complex-data"]], template: function PopularItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2)(4, "div", 3)(5, "span", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "span", 4);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(9, "div", 5)(10, "span", 6);
        ɵngcc0.ɵɵelement(11, "span", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(12, "div", 3)(13, "span", 8);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "noCommas");
        ɵngcc0.ɵɵpipe(16, "customCurrency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "span", 4);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵpipe(19, "noCommas");
        ɵngcc0.ɵɵpipe(20, "customCurrency");
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.index);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.item.name);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.item.quantity);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleProp("width", ctx.incomeWidth);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.stake);
        ɵngcc0.ɵɵstyleProp("width", ctx.marginWidth);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap(ctx.stake);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate3("", ctx.percents, " - ", ɵngcc0.ɵɵpipeBind1(15, 16, ctx.item.profit), " ", ɵngcc0.ɵɵpipeBind1(16, 18, ctx.item.currency), "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate2("", ɵngcc0.ɵɵpipeBind1(19, 20, ctx.item.revenue / ctx.item.quantity), " ", ɵngcc0.ɵɵpipeBind1(20, 22, ctx.item.currency), "");
    } }, dependencies: [NoCommasPipe, CustomCurrencyPipe], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], PopularItemComponent.prototype, "item", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PopularItemComponent.prototype, "index", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], PopularItemComponent.prototype, "maxValue", void 0);
PopularItemComponent = __decorate([ __metadata("design:paramtypes", [])
], PopularItemComponent);
var STAKE;
(function (STAKE) {
    STAKE["LOW"] = "low";
    STAKE["MEDIUM"] = "medium";
    STAKE["HIGH"] = "high";
})(STAKE || (STAKE = {}));

let NomiaUiPopularItemModule = class NomiaUiPopularItemModule {
};
NomiaUiPopularItemModule.ɵfac = function NomiaUiPopularItemModule_Factory(t) { return new (t || NomiaUiPopularItemModule)(); };
NomiaUiPopularItemModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiPopularItemModule });
NomiaUiPopularItemModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        NomiaUiPipeModule] });

let NmWrapperComponent = class NmWrapperComponent {
    constructor() {
    }
    ngOnInit() {
    }
    getCardIcon() {
        return this.miniCardIcon;
    }
};
NmWrapperComponent.ɵfac = function NmWrapperComponent_Factory(t) { return new (t || NmWrapperComponent)(); };
NmWrapperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmWrapperComponent, selectors: [["nm-wrapper"]], inputs: { cardTitle: "cardTitle", cardSubtitle: "cardSubtitle", miniCard: "miniCard", miniCardIcon: "miniCardIcon", optionalValue: "optionalValue", empty: "empty" }, ngContentSelectors: _c16, decls: 12, vars: 9, consts: [[1, "dashboard-card", "d-flex", "direction-column"], [1, "dashboard-card__header", "d-flex", "align-middle", "justify-space-between"], [1, "d-flex", "direction-column"], [1, "h2", "dashboard-card__title"], ["class", "normal-reg", 4, "ngIf"], [4, "ngIf"], ["class", "calc-small mini-card__optional-value", 4, "ngIf"], ["class", "mini-card__icon", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["stub", ""], [1, "normal-reg"], [1, "calc-small", "mini-card__optional-value"], [1, "mini-card__icon"], [3, "media"]], template: function NmWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c15);
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "h2", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, NmWrapperComponent_span_5_Template, 2, 1, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, NmWrapperComponent_ng_content_6_Template, 1, 0, "ng-content", 5);
        ɵngcc0.ɵɵtemplate(7, NmWrapperComponent_span_7_Template, 2, 1, "span", 6);
        ɵngcc0.ɵɵtemplate(8, NmWrapperComponent_div_8_Template, 2, 0, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, NmWrapperComponent_ng_content_9_Template, 1, 0, "ng-content", 8);
        ɵngcc0.ɵɵtemplate(10, NmWrapperComponent_ng_template_10_Template, 1, 1, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r5 = ɵngcc0.ɵɵreference(11);
        ɵngcc0.ɵɵclassProp("dashboard-card_mini", ctx.miniCard);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate(ctx.cardTitle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardSubtitle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.miniCard);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.optionalValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.miniCard);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.empty !== true)("ngIfElse", _r5);
    } }, dependencies: function () { return [ɵngcc1.NgIf, NmNoDataStubComponent]; }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", String)
], NmWrapperComponent.prototype, "cardTitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmWrapperComponent.prototype, "cardSubtitle", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmWrapperComponent.prototype, "miniCard", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmWrapperComponent.prototype, "miniCardIcon", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmWrapperComponent.prototype, "optionalValue", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmWrapperComponent.prototype, "empty", void 0);
NmWrapperComponent = __decorate([ __metadata("design:paramtypes", [])
], NmWrapperComponent);

let NmNoDataStubComponent = class NmNoDataStubComponent {
    constructor() {
        this.icons = ICONS;
    }
    ngOnInit() {
    }
};
NmNoDataStubComponent.ɵfac = function NmNoDataStubComponent_Factory(t) { return new (t || NmNoDataStubComponent)(); };
NmNoDataStubComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmNoDataStubComponent, selectors: [["nm-no-data-stub"]], inputs: { media: "media" }, decls: 3, vars: 2, consts: [["class", "stub d-flex direction-column align-middle justify-center", 4, "ngIf", "ngIfElse"], ["emptyStub", ""], [1, "stub", "d-flex", "direction-column", "align-middle", "justify-center"], [1, "stub__icon", 3, "iconName"], [1, "stub__message", "big-reg", "secondary-text"], [1, "stub", "d-flex", "stub_empty"]], template: function NmNoDataStubComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NmNoDataStubComponent_div_0_Template, 4, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NmNoDataStubComponent_ng_template_1_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.media === true)("ngIfElse", _r1);
    } }, dependencies: [ɵngcc1.NgIf, IconLoaderComponent], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmNoDataStubComponent.prototype, "media", void 0);
NmNoDataStubComponent = __decorate([ __metadata("design:paramtypes", [])
], NmNoDataStubComponent);

let NomiaUiWrapperModule = class NomiaUiWrapperModule {
};
NomiaUiWrapperModule.ɵfac = function NomiaUiWrapperModule_Factory(t) { return new (t || NomiaUiWrapperModule)(); };
NomiaUiWrapperModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiWrapperModule });
NomiaUiWrapperModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        NomiaUiPipeModule,
        NomiaUiIconSpriteModule] });

let BaseModalComponent = class BaseModalComponent {
    constructor() {
        this.classNameField = true;
        this.closeModal = new EventEmitter();
    }
    set data(value) {
        if (!!value) {
            this._data = value;
        }
    }
    get data() {
        return this._data;
    }
    close(args) {
        this.closeModal.emit(args);
    }
};
BaseModalComponent.ɵfac = function BaseModalComponent_Factory(t) { return new (t || BaseModalComponent)(); };
BaseModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BaseModalComponent, selectors: [["nm-base-modal"]], hostVars: 2, hostBindings: function BaseModalComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("modal-box__popup", ctx.classNameField);
    } }, inputs: { data: "data" }, outputs: { closeModal: "closeModal" }, decls: 1, vars: 0, template: function BaseModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div");
    } }, encapsulation: 2 });
__decorate([
    HostBinding('class.modal-box__popup'),
    __metadata("design:type", Boolean)
], BaseModalComponent.prototype, "classNameField", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], BaseModalComponent.prototype, "closeModal", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], BaseModalComponent.prototype, "data", null);
BaseModalComponent = __decorate([ __metadata("design:paramtypes", [])
], BaseModalComponent);

let NmModalWrapperComponent = class NmModalWrapperComponent {
    constructor() {
        this.closeModal = new EventEmitter();
    }
    close() {
        this.closeModal.emit();
    }
};
NmModalWrapperComponent.ɵfac = function NmModalWrapperComponent_Factory(t) { return new (t || NmModalWrapperComponent)(); };
NmModalWrapperComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmModalWrapperComponent, selectors: [["nm-modal-wrap"]], hostVars: 8, hostBindings: function NmModalWrapperComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("w-full", true)("d-flex", true)("direction-column", true)("scroll-auto", true);
    } }, inputs: { modalTitle: "modalTitle" }, outputs: { closeModal: "closeModal" }, ngContentSelectors: _c18, decls: 11, vars: 1, consts: [[1, "modal-box__header"], [1, "modal-box__title", "bold"], ["type", "button", 1, "modal-box__close-button", "button", 3, "click"], [1, "button__icon", "icon", "icon--baseline"], ["viewBox", "0 0 128 128", 1, "icon__svg", "icon__svg--times"], ["d", "M76.518,64.002L114.338,26.182L122.137,18.382C123.288,17.232 123.288,15.362 122.137,14.212L113.792,5.867C112.641,4.716 110.772,4.716 109.621,5.867L64.002,51.486L18.382,5.863C17.232,4.712 15.362,4.712 14.212,5.863L5.863,14.208C4.712,15.359 4.712,17.228 5.863,18.379L51.486,64.002L5.863,109.621C4.712,110.772 4.712,112.641 5.863,113.792L14.208,122.137C15.359,123.288 17.228,123.288 18.379,122.137L64.002,76.518L109.621,122.137C110.772,123.288 112.641,123.288 113.792,122.137L122.137,113.792C123.288,112.641 123.288,110.772 122.137,109.621L76.518,64.002Z", 2, "fill-rule", "nonzero"], [1, "modal-box__container", "modal-box__container--content"], [1, "modal-box__control-bar"]], template: function NmModalWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c17);
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "h3", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 2);
        ɵngcc0.ɵɵlistener("click", function NmModalWrapperComponent_Template_button_click_3_listener() { return ctx.close(); });
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(5, "svg", 4);
        ɵngcc0.ɵɵelement(6, "path", 5);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵprojection(10, 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.modalTitle);
    } }, encapsulation: 2 });
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmModalWrapperComponent.prototype, "closeModal", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmModalWrapperComponent.prototype, "modalTitle", void 0);
NmModalWrapperComponent = __decorate([ __metadata("design:paramtypes", [])
], NmModalWrapperComponent);

let ModalContentDirective = class ModalContentDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
};
ModalContentDirective.ɵfac = function ModalContentDirective_Factory(t) { return new (t || ModalContentDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
ModalContentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ModalContentDirective, selectors: [["", "appModalContent", ""]] });
ModalContentDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
ModalContentDirective = __decorate([ __metadata("design:paramtypes", [ViewContainerRef])
], ModalContentDirective);

let OverlayComponent = class OverlayComponent {
    constructor(componentFactoryResolver, renderer, el, router) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.renderer = renderer;
        this.el = el;
        this.router = router;
        this._active = false;
        this.onDestroy = new Subject();
        this.allowOverlayClick = true;
        this.showCloseButton = true;
        this.modalSize = 'x-small';
        this.whenOverlayClicked$ = new EventEmitter();
        this.classModalBoxField = true;
    }
    set data(data) {
        this._data = data;
        this.setData();
    }
    onOverlayClick(event) {
        if (this.allowOverlayClick && !this._componentRef.location.nativeElement.contains(event.target)) {
            this.closeModal(event);
        }
    }
    set component(component) {
        if (!this._modal) {
            this._modal = component;
            this.setupContent();
        }
    }
    get componentInstance() {
        return this._componentRef;
    }
    ngOnInit() {
        this._active = true;
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.onDestroy))
            .subscribe(() => {
            this.closeModalForce();
        });
    }
    ngOnDestroy() {
        this.onDestroy.next();
        this.onDestroy.complete();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.renderer.addClass(this.el.nativeElement, 'modal-box--active');
        });
    }
    closeModal(event) {
        if (!!event) {
            event.stopPropagation();
            event.preventDefault();
        }
        this.renderer.removeClass(this.el.nativeElement, 'modal-box--active');
        setTimeout(() => {
            this.whenOverlayClicked$.emit(this.args);
        }, 200);
    }
    closeModalForce() {
        this.whenOverlayClicked$.emit();
    }
    setData() {
        this.renderer.addClass(this.el.nativeElement, 'modal-box--' + this.modalSize);
        if (this._componentRef && 'data' in this._componentRef.instance) {
            this._componentRef.instance.data = this._data;
        }
    }
    setupCloseListener() {
        if (this._componentRef && 'closeModal' in this._componentRef.instance) {
            this._componentRef.instance.closeModal
                .pipe(takeWhile(() => this._active))
                .subscribe((args) => {
                this.args = args;
                this.closeModal();
            });
        }
    }
    setupContent() {
        if (this._modal) {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this._modal);
            const viewContainerRef = this.contentContainer.viewContainerRef;
            viewContainerRef.clear();
            this._componentRef = viewContainerRef.createComponent(componentFactory);
            this.setupCloseListener();
        }
    }
};
OverlayComponent.ɵfac = function OverlayComponent_Factory(t) { return new (t || OverlayComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Router)); };
OverlayComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OverlayComponent, selectors: [["nm-overlay"]], viewQuery: function OverlayComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(ModalContentDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contentContainer = _t.first);
    } }, hostVars: 2, hostBindings: function OverlayComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function OverlayComponent_click_HostBindingHandler($event) { return ctx.onOverlayClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("modal-box", ctx.classModalBoxField);
    } }, decls: 2, vars: 0, consts: [[1, "overlay"], ["appModalContent", ""]], template: function OverlayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, OverlayComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
    } }, dependencies: [ModalContentDirective], styles: ["[_nghost-%COMP%]{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center;left:0;position:fixed;top:0;width:100%;z-index:9999;background:rgba(0,0,0,.7)}"] });
OverlayComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: Renderer2 },
    { type: ElementRef },
    { type: Router }
];
__decorate([
    ViewChild(ModalContentDirective, { static: true }),
    __metadata("design:type", ModalContentDirective)
], OverlayComponent.prototype, "contentContainer", void 0);
__decorate([
    HostListener('click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], OverlayComponent.prototype, "onOverlayClick", null);
__decorate([
    HostBinding('class.modal-box'),
    __metadata("design:type", Boolean)
], OverlayComponent.prototype, "classModalBoxField", void 0);
OverlayComponent = __decorate([ __metadata("design:paramtypes", [ComponentFactoryResolver,
        Renderer2,
        ElementRef,
        Router])
], OverlayComponent);

let DomService = class DomService {
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.id = 0;
        this.componentRefs = {};
    }
    appendComponentToBody(component) {
        const componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);
        this.appRef.attachView(componentRef.hostView);
        const domElem = componentRef.hostView.rootNodes[0];
        document.body.appendChild(domElem);
        this.id++;
        this.componentRefs[this.id] = componentRef;
        return this.id;
    }
    getComponent(id) {
        if (this.componentRefs[id]) {
            return this.componentRefs[id];
        }
        return null;
    }
    removeComponentFromBody(id) {
        if (this.componentRefs[id]) {
            this.appRef.detachView(this.componentRefs[id].hostView);
            this.componentRefs[id].destroy();
        }
    }
};
DomService.ɵfac = function DomService_Factory(t) { return new (t || DomService)(ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵinject(ɵngcc0.ApplicationRef), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DomService.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ApplicationRef },
    { type: Injector }
];
DomService.ɵprov = ɵɵdefineInjectable({ factory: function DomService_Factory() { return new DomService(ɵɵinject(ComponentFactoryResolver), ɵɵinject(ApplicationRef), ɵɵinject(INJECTOR)); }, token: DomService, providedIn: "root" });
DomService = __decorate([ __metadata("design:paramtypes", [ComponentFactoryResolver,
        ApplicationRef,
        Injector])
], DomService);

let ModalService = class ModalService {
    constructor(domService) {
        this.domService = domService;
        this.openModals = {};
    }
    closeModal(refId) {
        this.domService.removeComponentFromBody(refId);
    }
    getModalContentInstance(refId) {
        return !!this.openModals[refId] ? this.openModals[refId].instance.componentInstance.instance : null;
    }
    setConfig(refId, config) {
        this.openModals[refId].instance.allowOverlayClick =
            'allowOverlayClick' in config ? !!config.allowOverlayClick : this.openModals[refId].instance.allowOverlayClick;
        this.openModals[refId].instance.showCloseButton =
            'showCloseButton' in config ? !!config.showCloseButton : this.openModals[refId].instance.showCloseButton;
        this.openModals[refId].instance.modalSize =
            'modalSize' in config ? config.modalSize : this.openModals[refId].instance.modalSize;
        if ('whenClosed' in config) {
            this.openModals[refId].instance.whenOverlayClicked$.subscribe((args) => {
                if (!!config.whenClosed) {
                    config.whenClosed(args);
                }
            });
        }
        if ('data' in config) {
            this.openModals[refId].instance.data = config.data;
        }
    }
    showModal(content, config) {
        const refId = this.domService.appendComponentToBody(OverlayComponent);
        this.openModals[refId] = this.domService.getComponent(refId);
        this.openModals[refId].instance.component = content;
        if (config) {
            this.setConfig(refId, config);
        }
        this.openModals[refId].instance.whenOverlayClicked$.subscribe(() => {
            this.closeModal(refId);
        });
        return refId;
    }
};
ModalService.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(ɵngcc0.ɵɵinject(DomService)); };
ModalService.ctorParameters = () => [
    { type: DomService }
];
ModalService.ɵprov = ɵɵdefineInjectable({ factory: function ModalService_Factory() { return new ModalService(ɵɵinject(DomService)); }, token: ModalService, providedIn: "root" });
ModalService = __decorate([ __metadata("design:paramtypes", [DomService])
], ModalService);

let NomiaUiModalModule = class NomiaUiModalModule {
};
NomiaUiModalModule.ɵfac = function NomiaUiModalModule_Factory(t) { return new (t || NomiaUiModalModule)(); };
NomiaUiModalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiModalModule });
NomiaUiModalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let NmExtendedCalendarComponent = class NmExtendedCalendarComponent {
    constructor() {
        this.disabled = false;
        this.extended = false;
        this.size = 'middle';
        this.changeDate = new EventEmitter();
        this.months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
        this.weekdays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
        this.days = [];
        this.currentDate = new Date();
        this.currentDay = this.currentDate.getTime();
        this.currentMonth = this.currentDate.getMonth();
        this.currentYear = this.currentDate.getFullYear();
        this.state = {
            startDate: this.currentDate.getTime(),
            endDate: null
        };
        // NEXT CALENDAR
        this.daysNext = [];
        this.currentDateNext = new Date();
        this.currentMonthNext = this.currentDateNext.getMonth() + 1;
        this.currentYearNext = this.currentDateNext.getFullYear();
        if (this.currentMonthNext > 11) {
            this.currentMonthNext = 0;
            this.currentYearNext++;
        }
        if (this.currentMonthNext < 0) {
            this.currentMonthNext = 11;
            this.currentYearNext--;
        }
    }
    set selection(value) {
        this.localSelection = value;
        if (this.localSelection === 'single') {
            this.bufEndDate = this.state.endDate;
            this.state.endDate = null;
        }
        else {
            this.state.endDate = this.bufEndDate;
        }
        this.createCalendar();
        this.createCalendarNext();
    }
    ;
    set dateValue(date) {
        if (date) {
            this.currentDay = date;
            this.currentMonth = new Date(date).getMonth();
            this.currentYear = new Date(date).getFullYear();
            if (this.currentMonthNext !== this.currentMonth) {
                this.currentMonthNext = this.currentMonth + 1;
                this.currentYearNext = this.currentYear;
                if (this.currentMonthNext > 11) {
                    this.currentMonthNext = 0;
                    this.currentYearNext++;
                }
            }
            else {
                this.currentMonth = this.currentMonthNext - 1;
                this.currentYear = this.currentYearNext;
                if (this.currentMonth > 11) {
                    this.currentMonth = 0;
                    this.currentYear++;
                }
                if (this.currentMonth < 0) {
                    this.currentMonth = 11;
                    this.currentYear--;
                }
            }
            this.createCalendar();
            this.createCalendarNext();
        }
    }
    set startDateValue(date) {
        if (date) {
            this.state.startDate = date;
            this.currentMonth = new Date(date).getMonth();
            this.currentYear = new Date(date).getFullYear();
            this.currentMonthNext = this.currentMonth + 1;
            this.currentYearNext = this.currentYear;
            if (this.currentMonthNext > 11) {
                this.currentMonthNext = 0;
                this.currentYearNext++;
            }
            this.createCalendar();
            this.createCalendarNext();
        }
    }
    set endDateValue(date) {
        if (date) {
            this.state.endDate = date;
            this.currentMonthNext = new Date(date).getMonth();
            this.currentYearNext = new Date(date).getFullYear();
            this.currentMonth = this.currentMonthNext - 1;
            this.currentYear = this.currentYearNext;
            if (this.currentMonth < 0) {
                this.currentMonth = 11;
                this.currentYear--;
            }
            this.createCalendar();
            this.createCalendarNext();
        }
    }
    ngAfterContentInit() {
        requestAnimationFrame(() => {
            this.createCalendar();
            this.createCalendarNext();
        });
    }
    createCalendar() {
        const year = this.currentYear;
        const month = this.currentMonth;
        this.days = [];
        let mon = month;
        let d = new Date(year, mon);
        // пробелы для первого ряда
        // с понедельника до первого дня месяца
        // * * * 1  2  3  4
        for (let i = 0; i < this.getDay(d); i++) {
            this.days.push('  ');
        }
        // ячейки календаря с датами
        while (d.getMonth() === mon) {
            this.days.push({
                fullDate: d.getTime(),
                date: d.getDate(),
                selected: this.isSelected(d.getTime())
            });
            d.setDate(d.getDate() + 1);
        }
        // добить таблицу пустыми ячейками, если нужно
        // 29 30 31 * * * *
        if (this.getDay(d) !== 0) {
            for (let i = this.getDay(d); i < 7; i++) {
                this.days.push('  ');
            }
        }
    }
    createCalendarNext() {
        const year = this.currentYearNext;
        const month = this.currentMonthNext;
        this.daysNext = [];
        let mon = month;
        let d = new Date(year, mon);
        // пробелы для первого ряда
        // с понедельника до первого дня месяца
        // * * * 1  2  3  4
        for (let i = 0; i < this.getDay(d); i++) {
            this.daysNext.push('  ');
        }
        // ячейки календаря с датами
        while (d.getMonth() === mon) {
            this.daysNext.push({
                fullDate: d.getTime(),
                date: d.getDate(),
                selected: this.isSelected(d.getTime())
            });
            d.setDate(d.getDate() + 1);
        }
        // добить таблицу пустыми ячейками, если нужно
        // 29 30 31 * * * *
        if (this.getDay(d) !== 0) {
            for (let i = this.getDay(d); i < 7; i++) {
                this.daysNext.push('  ');
            }
        }
    }
    getDay(date) {
        let day = date.getDay();
        if (day === 0)
            day = 7; // сделать воскресенье (0) последним днем
        return day - 1;
    }
    selectDay(day) {
        this.currentDay = day;
        this.changeDate.emit({ date: this.formateDate(this.currentDay) });
    }
    selectDayRange(day) {
        if (day) {
            if ((!this.state.startDate && !this.state.endDate) ||
                (this.state.startDate && this.state.endDate)) {
                this.state.startDate = day;
                this.state.endDate = null;
            }
            else {
                if (!this.state.endDate && this.isBefore(this.state.startDate, day)) {
                    this.state.endDate = day;
                }
                else {
                    this.state.startDate = day;
                }
            }
            this.changeDate.emit({
                date: this.state.startDate ? this.formateDate(this.state.startDate) : null,
                endDate: this.state.endDate ? this.formateDate(this.state.endDate) : null
            });
            this.createCalendar();
            this.createCalendarNext();
        }
    }
    isSelected(date) {
        return this.isAfter(date, this.state.startDate) && this.isBefore(date, this.state.endDate)
            || date === this.state.startDate || date === this.state.endDate;
    }
    goToPrevMonth() {
        this.currentMonth--;
        if (this.currentMonth < 0) {
            this.currentMonth = 11;
            this.currentYear--;
        }
        this.currentMonthNext--;
        if (this.currentMonthNext < 0) {
            this.currentMonthNext = 11;
            this.currentYearNext--;
        }
        this.createCalendar();
        this.createCalendarNext();
    }
    goToNextMonth() {
        this.currentMonth++;
        if (this.currentMonth > 11) {
            this.currentMonth = 0;
            this.currentYear++;
        }
        this.currentMonthNext++;
        if (this.currentMonthNext > 11) {
            this.currentMonthNext = 0;
            this.currentYearNext++;
        }
        this.createCalendar();
        this.createCalendarNext();
    }
    isAfter(date1, date2) {
        return new Date(date2).getTime() < new Date(date1).getTime();
    }
    isBefore(date1, date2) {
        return new Date(date1).getTime() < new Date(date2).getTime();
    }
    isSame(date1, date2) {
        return this.formateDate(date1) === this.formateDate(date2);
    }
    formateDate(date) {
        const _date = new Date(date);
        return _date.getFullYear() + '/' + (_date.getMonth() + 1) + '/' + _date.getDate();
    }
};
NmExtendedCalendarComponent.ɵfac = function NmExtendedCalendarComponent_Factory(t) { return new (t || NmExtendedCalendarComponent)(); };
NmExtendedCalendarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmExtendedCalendarComponent, selectors: [["nm-extended-calendar"]], hostAttrs: [1, "calendar"], hostVars: 3, hostBindings: function NmExtendedCalendarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("calendar-size__large", ctx.size === "large");
    } }, inputs: { disabled: "disabled", color: "color", size: "size", extended: "extended", selection: "selection", dateValue: "dateValue", startDateValue: "startDateValue", endDateValue: "endDateValue" }, outputs: { changeDate: "changeDate" }, decls: 12, vars: 6, consts: [[1, "nm-calendar"], [1, "arrow", "back", 3, "click"], [1, "nm-calendar__wrapper"], [1, "nm-calendar__month"], [1, "nm-calendar__week-names"], ["class", "nm-calendar__weekday", 4, "ngFor", "ngForOf"], [1, "nm-calendar__days"], [3, "ngIf"], ["class", "nm-calendar__wrapper", "style", "margin-left: 12px", 4, "ngIf"], [1, "arrow", "next", 3, "click"], [1, "nm-calendar__weekday"], ["class", "nm-calendar__day", 4, "ngFor", "ngForOf"], [1, "nm-calendar__day"], [3, "click"], ["class", "nm-calendar__day", 3, "selected", "day--first", "day--last", 4, "ngFor", "ngForOf"], [1, "nm-calendar__wrapper", 2, "margin-left", "12px"]], template: function NmExtendedCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function NmExtendedCalendarComponent_Template_div_click_1_listener() { return ctx.goToPrevMonth(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, NmExtendedCalendarComponent_div_6_Template, 2, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, NmExtendedCalendarComponent_ng_template_8_Template, 1, 1, "ng-template", 7);
        ɵngcc0.ɵɵtemplate(9, NmExtendedCalendarComponent_ng_template_9_Template, 1, 1, "ng-template", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(10, NmExtendedCalendarComponent_div_10_Template, 8, 5, "div", 8);
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵlistener("click", function NmExtendedCalendarComponent_Template_div_click_11_listener() { return ctx.goToNextMonth(); });
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.months[ctx.currentMonth], ", ", ctx.currentYear, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.weekdays);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.localSelection === "single");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.localSelection === "range");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.extended);
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmExtendedCalendarComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmExtendedCalendarComponent.prototype, "extended", void 0);
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], NmExtendedCalendarComponent.prototype, "selection", null);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmExtendedCalendarComponent.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmExtendedCalendarComponent.prototype, "dateValue", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmExtendedCalendarComponent.prototype, "startDateValue", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmExtendedCalendarComponent.prototype, "endDateValue", null);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmExtendedCalendarComponent.prototype, "changeDate", void 0);
NmExtendedCalendarComponent = __decorate([ __metadata("design:paramtypes", [])
], NmExtendedCalendarComponent);

let NmCalendarComponent = class NmCalendarComponent {
    constructor() {
        this.disabled = false;
        this.extended = false;
        this.selection = 'single';
        this.showOldCalendar = false;
        this.size = 'middle';
        this.cals = [];
        this.changeDate = new EventEmitter();
        this.currentDate = new Date();
        this.currentDay = this.currentDate.getTime();
    }
    set dateValue(date) {
        if (date) {
            this.currentDay = new Date(date).getTime();
        }
    }
    set startDateValue(date) {
        if (date) {
            this.startDate = date;
        }
    }
    set endDateValue(date) {
        if (date) {
            this.endDate = date;
        }
    }
    onChangeDate(value) {
        this.changeDate.emit(value);
    }
    renderCalendar() {
        this.singleCalendar.createCalendar();
    }
};
NmCalendarComponent.ɵfac = function NmCalendarComponent_Factory(t) { return new (t || NmCalendarComponent)(); };
NmCalendarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmCalendarComponent, selectors: [["nm-calendar"]], viewQuery: function NmCalendarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c19, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.singleCalendar = _t.first);
    } }, hostAttrs: [1, "calendar"], hostVars: 1, hostBindings: function NmCalendarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
    } }, inputs: { disabled: "disabled", color: "color", size: "size", extended: "extended", selection: "selection", showOldCalendar: "showOldCalendar", dateValue: "dateValue", startDateValue: "startDateValue", endDateValue: "endDateValue" }, outputs: { changeDate: "changeDate" }, decls: 3, vars: 2, consts: [[1, "nm-calendar"], [3, "disabled", "extended", "selection", "dateValue", "startDateValue", "endDateValue", "size", "changeDate", 4, "ngIf"], [3, "disabled", "selection", "dateValue", "startDateValue", "endDateValue", "size", "changeDate", 4, "ngIf"], [3, "disabled", "extended", "selection", "dateValue", "startDateValue", "endDateValue", "size", "changeDate"], ["singleCalendar", ""], [3, "disabled", "selection", "dateValue", "startDateValue", "endDateValue", "size", "changeDate"]], template: function NmCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NmCalendarComponent_nm_extended_calendar_1_Template, 2, 7, "nm-extended-calendar", 1);
        ɵngcc0.ɵɵtemplate(2, NmCalendarComponent_nm_single_calendar_2_Template, 2, 6, "nm-single-calendar", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.extended);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.extended);
    } }, dependencies: function () { return [ɵngcc1.NgIf, NmExtendedCalendarComponent, NmSingleCalendarComponent]; }, encapsulation: 2 });
__decorate([
    ViewChild('singleCalendar'),
    __metadata("design:type", NmExtendedCalendarComponent)
], NmCalendarComponent.prototype, "singleCalendar", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmCalendarComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmCalendarComponent.prototype, "extended", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmCalendarComponent.prototype, "selection", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmCalendarComponent.prototype, "showOldCalendar", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmCalendarComponent.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmCalendarComponent.prototype, "dateValue", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmCalendarComponent.prototype, "startDateValue", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmCalendarComponent.prototype, "endDateValue", null);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmCalendarComponent.prototype, "changeDate", void 0);
NmCalendarComponent = __decorate([ __metadata("design:paramtypes", [])
], NmCalendarComponent);

let NmSingleCalendarComponent = class NmSingleCalendarComponent {
    constructor() {
        this.disabled = false;
        this.size = 'middle';
        this.changeDate = new EventEmitter();
        this.months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
        this.weekdays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
        this.days = [];
        this.currentDate = new Date();
        this.currentDay = this.currentDate.getTime();
        this.currentMonth = this.currentDate.getMonth();
        this.currentYear = this.currentDate.getFullYear();
        this.state = {
            startDate: this.currentDate.getTime(),
            endDate: null
        };
    }
    set selection(value) {
        this.localSelection = value;
        if (this.localSelection === 'single') {
            this.bufEndDate = this.state.endDate;
            this.state.endDate = null;
        }
        else {
            this.state.endDate = this.bufEndDate;
        }
        this.createCalendar();
    }
    ;
    set dateValue(date) {
        if (date) {
            this.currentDay = date;
            this.currentMonth = new Date(date).getMonth();
            this.currentYear = new Date(date).getFullYear();
            if (this.currentMonth > 11) {
                this.currentMonth = 0;
                this.currentYear++;
            }
            if (this.currentMonth < 0) {
                this.currentMonth = 11;
                this.currentYear--;
            }
            this.createCalendar();
        }
    }
    set startDateValue(date) {
        if (date) {
            this.state.startDate = date;
            this.currentMonth = new Date(date).getMonth();
            this.currentYear = new Date(date).getFullYear();
            this.createCalendar();
        }
    }
    set endDateValue(date) {
        if (date) {
            this.state.endDate = date;
            if (this.currentMonth < 0) {
                this.currentMonth = 11;
                this.currentYear--;
            }
            this.createCalendar();
        }
    }
    ngAfterContentInit() {
        requestAnimationFrame(() => {
            this.createCalendar();
        });
    }
    createCalendar() {
        const year = this.currentYear;
        const month = this.currentMonth;
        this.days = [];
        let mon = month;
        let d = new Date(year, mon);
        // пробелы для первого ряда
        // с понедельника до первого дня месяца
        // * * * 1  2  3  4
        for (let i = 0; i < this.getDay(d); i++) {
            this.days.push('  ');
        }
        // ячейки календаря с датами
        while (d.getMonth() === mon) {
            this.days.push({
                fullDate: d.getTime(),
                date: d.getDate(),
                selected: this.isSelected(d.getTime())
            });
            d.setDate(d.getDate() + 1);
        }
        // добить таблицу пустыми ячейками, если нужно
        // 29 30 31 * * * *
        if (this.getDay(d) !== 0) {
            for (let i = this.getDay(d); i < 7; i++) {
                this.days.push('  ');
            }
        }
    }
    getDay(date) {
        let day = date.getDay();
        if (day === 0)
            day = 7; // сделать воскресенье (0) последним днем
        return day - 1;
    }
    selectDay(day) {
        if (!day) {
            return;
        }
        this.currentDay = day;
        this.changeDate.emit({ date: this.formateDate(this.currentDay) });
    }
    selectDayRange(day) {
        if (day) {
            if ((!this.state.startDate && !this.state.endDate) ||
                (this.state.startDate && this.state.endDate)) {
                this.state.startDate = day;
                this.state.endDate = null;
            }
            else {
                if (!this.state.endDate && this.isBefore(this.state.startDate, day)) {
                    this.state.endDate = day;
                }
                else {
                    this.state.startDate = day;
                }
            }
            this.changeDate.emit({
                date: this.state.startDate ? this.formateDate(this.state.startDate) : null,
                endDate: this.state.endDate ? this.formateDate(this.state.endDate) : null
            });
            this.createCalendar();
        }
    }
    isSelected(date) {
        return this.isAfter(date, this.state.startDate) && this.isBefore(date, this.state.endDate)
            || date === this.state.startDate || date === this.state.endDate;
    }
    goToPrevMonth() {
        this.currentMonth--;
        if (this.currentMonth < 0) {
            this.currentMonth = 11;
            this.currentYear--;
        }
        this.createCalendar();
    }
    goToNextMonth() {
        this.currentMonth++;
        if (this.currentMonth > 11) {
            this.currentMonth = 0;
            this.currentYear++;
        }
        this.createCalendar();
    }
    isAfter(date1, date2) {
        return new Date(date2).getTime() < new Date(date1).getTime();
    }
    isBefore(date1, date2) {
        return new Date(date1).getTime() < new Date(date2).getTime();
    }
    isSame(date1, date2) {
        return this.formateDate(date1) === this.formateDate(date2);
    }
    formateDate(date) {
        const _date = new Date(date);
        return _date.getFullYear() + '/' + (_date.getMonth() + 1) + '/' + _date.getDate();
    }
};
NmSingleCalendarComponent.ɵfac = function NmSingleCalendarComponent_Factory(t) { return new (t || NmSingleCalendarComponent)(); };
NmSingleCalendarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmSingleCalendarComponent, selectors: [["nm-single-calendar"]], hostAttrs: [1, "calendar"], hostVars: 3, hostBindings: function NmSingleCalendarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("calendar-size__large", ctx.size === "large");
    } }, inputs: { disabled: "disabled", color: "color", size: "size", selection: "selection", dateValue: "dateValue", startDateValue: "startDateValue", endDateValue: "endDateValue" }, outputs: { changeDate: "changeDate" }, decls: 11, vars: 5, consts: [[1, "nm-calendar"], [1, "arrow", "back", 3, "click"], [1, "nm-calendar__wrapper"], [1, "nm-calendar__month"], [1, "nm-calendar__week-names"], ["class", "nm-calendar__weekday", 4, "ngFor", "ngForOf"], [1, "nm-calendar__days"], [3, "ngIf"], [1, "arrow", "next", 3, "click"], [1, "nm-calendar__weekday"], ["class", "nm-calendar__day", 4, "ngFor", "ngForOf"], [1, "nm-calendar__day"], [3, "click"], ["class", "nm-calendar__day", 3, "selected", "day--first", "day--last", 4, "ngFor", "ngForOf"]], template: function NmSingleCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function NmSingleCalendarComponent_Template_div_click_1_listener() { return ctx.goToPrevMonth(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2)(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, NmSingleCalendarComponent_div_6_Template, 2, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, NmSingleCalendarComponent_ng_template_8_Template, 1, 1, "ng-template", 7);
        ɵngcc0.ɵɵtemplate(9, NmSingleCalendarComponent_ng_template_9_Template, 1, 1, "ng-template", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(10, "div", 8);
        ɵngcc0.ɵɵlistener("click", function NmSingleCalendarComponent_Template_div_click_10_listener() { return ctx.goToNextMonth(); });
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.months[ctx.currentMonth], ", ", ctx.currentYear, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.weekdays);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.localSelection === "single");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.localSelection === "range");
    } }, dependencies: [ɵngcc1.NgForOf, ɵngcc1.NgIf], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmSingleCalendarComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], NmSingleCalendarComponent.prototype, "selection", null);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmSingleCalendarComponent.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmSingleCalendarComponent.prototype, "dateValue", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmSingleCalendarComponent.prototype, "startDateValue", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NmSingleCalendarComponent.prototype, "endDateValue", null);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmSingleCalendarComponent.prototype, "changeDate", void 0);
NmSingleCalendarComponent = __decorate([ __metadata("design:paramtypes", [])
], NmSingleCalendarComponent);

var NmInputCalendar_1;
let NmInputCalendar = NmInputCalendar_1 = class NmInputCalendar {
    constructor() {
        this.changeValue = new EventEmitter();
        this.placeholder = '';
        this.size = 'medium';
        this.disabled = false;
        this.visible = false;
        this.currentValue = new Date();
        this.inputValue = '';
        this.onChange = () => {
        };
        this.onTouched = () => {
        };
    }
    writeValue(value) {
        this.normalizeDate(value || new Date());
        requestAnimationFrame(() => {
            this.nmCalendar.renderCalendar();
        });
    }
    onDropDownChange(value) {
        this.visible = value;
    }
    onChangeDate(value) {
        const dateStr = this.convertDateLocalString(value.date);
        this.changeValue.emit(value);
        this.normalizeDate(dateStr);
        this.onChange(dateStr);
        this.visible = false;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    convertDateLocalString(date) {
        return `${date.year}/${+date.month + 1}/${date.date}`;
    }
    normalizeDate(value) {
        const date = new Date(value);
        this.currentValue = date;
        this.inputValue = this.convertDateLocalString({
            year: date.getFullYear(),
            month: date.getMonth(),
            date: date.getDate()
        });
    }
};
NmInputCalendar.ɵfac = function NmInputCalendar_Factory(t) { return new (t || NmInputCalendar)(); };
NmInputCalendar.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmInputCalendar, selectors: [["nm-input-calendar"]], viewQuery: function NmInputCalendar_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c20, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.nmCalendar = _t.first);
    } }, inputs: { placeholder: "placeholder", size: "size", disabled: "disabled" }, outputs: { changeValue: "changeValue" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => NmInputCalendar_1),
                multi: true
            }
        ])], decls: 5, vars: 14, consts: [["type", "text", "nm-dropdown", "", "triggerEvent", "click", 1, "base-input", 3, "disabled", "dVisible", "placeholder", "nmDropdownMenu", "value", "dropdownOpen"], ["calendarMenu", "nmDropdownMenu"], ["selection", "single", 1, "input-calendar__panel", 3, "dateValue", "changeDate"], ["nmCalendar", ""]], template: function NmInputCalendar_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0);
        ɵngcc0.ɵɵlistener("dropdownOpen", function NmInputCalendar_Template_input_dropdownOpen_0_listener($event) { return ctx.onDropDownChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(1, "nm-dropdown-menu", null, 1)(3, "nm-calendar", 2, 3);
        ɵngcc0.ɵɵlistener("changeDate", function NmInputCalendar_Template_nm_calendar_changeDate_3_listener($event) { return ctx.onChangeDate($event); });
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵclassProp("nm-input-disabled", ctx.disabled)("size-lg", ctx.size === "large")("size-md", ctx.size === "medium")("size-sm", ctx.size === "small");
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("dVisible", ctx.visible)("placeholder", ctx.placeholder)("nmDropdownMenu", _r0)("value", ctx.inputValue);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("dateValue", ctx.currentValue);
    } }, dependencies: [NmDropDownMenu, NmDropDownDirective, NmCalendarComponent], encapsulation: 2 });
__decorate([
    ViewChild('nmCalendar'),
    __metadata("design:type", NmCalendarComponent)
], NmInputCalendar.prototype, "nmCalendar", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmInputCalendar.prototype, "changeValue", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmInputCalendar.prototype, "placeholder", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmInputCalendar.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmInputCalendar.prototype, "disabled", void 0);
NmInputCalendar = NmInputCalendar_1 = __decorate([ __metadata("design:paramtypes", [])
], NmInputCalendar);

let NomiaUiCalendarModule = class NomiaUiCalendarModule {
};
NomiaUiCalendarModule.ɵfac = function NomiaUiCalendarModule_Factory(t) { return new (t || NomiaUiCalendarModule)(); };
NomiaUiCalendarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiCalendarModule });
NomiaUiCalendarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        NomiaUiDropDownModule] });

let TreeCheckboxComponent = class TreeCheckboxComponent {
    constructor() {
        this.checkedNode = new EventEmitter();
    }
    onCheckedNode(value) {
        this.checkedNode.emit(value);
    }
};
TreeCheckboxComponent.ɵfac = function TreeCheckboxComponent_Factory(t) { return new (t || TreeCheckboxComponent)(); };
TreeCheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TreeCheckboxComponent, selectors: [["nm-tree-checkbox"]], inputs: { tree: "tree" }, outputs: { checkedNode: "checkedNode" }, decls: 2, vars: 1, consts: [[1, "tree__panel"], [3, "node", "checkedNode", 4, "ngFor", "ngForOf"], [3, "node", "checkedNode"]], template: function TreeCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TreeCheckboxComponent_nm_node_checkbox_1_Template, 1, 1, "nm-node-checkbox", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tree);
    } }, dependencies: function () { return [ɵngcc1.NgForOf, TreeNodeCheckboxComponent]; }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array)
], TreeCheckboxComponent.prototype, "tree", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], TreeCheckboxComponent.prototype, "checkedNode", void 0);

class TreeNode {
    constructor() {
    }
}

let TreeNodeCheckboxComponent = class TreeNodeCheckboxComponent {
    constructor() {
        this.checkedNode = new EventEmitter();
        this.icons = ICONS;
    }
    toggleChild(e) {
        e.stopPropagation();
        this.node.isExpanded = !this.node.isExpanded;
    }
    onCheckedChange(value) {
        this.node.isChecked = value;
        if (this.node.children && this.node.children.length > 0) {
            this.node.children.forEach(childNode => {
                this.checkOneLeaf(childNode, value);
            });
        }
        this.checkedNode.emit(this.node);
    }
    onCheckedNode(value) {
        this.checkedNode.emit(value);
    }
    checkOneLeaf(node, value) {
        if (node) {
            node.isChecked = value;
            if (node.children && node.children.length > 0) {
                node.children.forEach(childNode => this.checkOneLeaf(childNode, value));
            }
        }
    }
};
TreeNodeCheckboxComponent.ɵfac = function TreeNodeCheckboxComponent_Factory(t) { return new (t || TreeNodeCheckboxComponent)(); };
TreeNodeCheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TreeNodeCheckboxComponent, selectors: [["nm-node-checkbox"]], inputs: { node: "node" }, outputs: { checkedNode: "checkedNode" }, decls: 6, vars: 7, consts: [[1, "node-item-checkbox__panel"], [3, "ngModel", "nmIndeterminate", "checkedChange"], [1, "node-item-checkbox__content"], ["type", "button", "class", "node-item-checkbox__button", 3, "click", 4, "ngIf"], [3, "ngIf"], ["type", "button", 1, "node-item-checkbox__button", 3, "click"], [3, "iconName"], [1, "node-item-checkbox-child__panel"], [3, "tree", "checkedNode"]], template: function TreeNodeCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "nm-checkbox", 1);
        ɵngcc0.ɵɵlistener("checkedChange", function TreeNodeCheckboxComponent_Template_nm_checkbox_checkedChange_1_listener($event) { return ctx.onCheckedChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, TreeNodeCheckboxComponent_button_4_Template, 2, 3, "button", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, TreeNodeCheckboxComponent_ng_template_5_Template, 2, 1, "ng-template", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("node-item-checkbox__panel--active", ctx.node == null ? null : ctx.node.isChecked);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.node == null ? null : ctx.node.isChecked)("nmIndeterminate", ctx.node == null ? null : ctx.node.indeterminate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.node.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.node.children && ctx.node.children.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.node == null ? null : ctx.node.isExpanded) && ctx.node.children && ctx.node.children.length > 0);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, IconLoaderComponent, NmCheckBoxComponent, TreeCheckboxComponent], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", TreeNode)
], TreeNodeCheckboxComponent.prototype, "node", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], TreeNodeCheckboxComponent.prototype, "checkedNode", void 0);
TreeNodeCheckboxComponent = __decorate([ __metadata("design:paramtypes", [])
], TreeNodeCheckboxComponent);

let TreeNodeItemComponent = class TreeNodeItemComponent {
    constructor(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.icons = ICONS;
    }
    toggleChild(e) {
        e.stopPropagation();
        this.node.isExpanded = !this.node.isExpanded;
    }
    openDropDown(e) {
        e.stopPropagation();
    }
    selectNode() {
        document.querySelectorAll('.node__panel--active').forEach((val) => {
            val.classList.remove('node__panel--active');
        });
        this.renderer.addClass(this.elementRef.nativeElement, 'node__panel--active');
    }
};
TreeNodeItemComponent.ɵfac = function TreeNodeItemComponent_Factory(t) { return new (t || TreeNodeItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TreeNodeItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TreeNodeItemComponent, selectors: [["nm-node-item"]], inputs: { node: "node", dropDownMenu: "dropDownMenu" }, decls: 24, vars: 7, consts: [[1, "node__panel", 3, "click"], ["type", "button", "class", "node__button", 3, "click", 4, "ngIf"], ["nm-dropdown", "", "triggerEvent", "click", 1, "button__t", 3, "nmDropdownMenu", "click"], ["width", "24", "height", "24", "viewBox", "0 0 24 24", "xmlns", "http://www.w3.org/2000/svg"], ["cx", "12", "cy", "7", "r", "1", "transform", "rotate(90 12 7)"], ["cx", "12", "cy", "12", "r", "1", "transform", "rotate(90 12 12)"], ["cx", "12", "cy", "17", "r", "1", "transform", "rotate(90 12 17)"], [1, "node__content"], [1, "button__arrow"], [1, "button__t", 3, "click"], ["d", "M11.134 7.5a1 1 0 011.732 0l4.33 7.5a1 1 0 01-.866 1.5H7.67a1 1 0 01-.866-1.5l4.33-7.5z"], ["d", "M11.134 16.5a1 1 0 001.732 0l4.33-7.5a1 1 0 00-.866-1.5H7.67A1 1 0 006.804 9l4.33 7.5z"], [1, "node__content-f"], [1, "left-border"], [3, "ngIf"], ["type", "button", 1, "node__button", 3, "click"], [3, "iconName"], [1, "node-child__panel"], [3, "tree", "dropDownMenu"]], template: function TreeNodeItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function TreeNodeItemComponent_Template_div_click_0_listener() { return ctx.selectNode(); });
        ɵngcc0.ɵɵtemplate(1, TreeNodeItemComponent_button_1_Template, 2, 3, "button", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function TreeNodeItemComponent_Template_button_click_2_listener($event) { return ctx.openDropDown($event); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(3, "svg", 3);
        ɵngcc0.ɵɵelement(4, "circle", 4)(5, "circle", 5)(6, "circle", 6);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 8)(10, "button", 9);
        ɵngcc0.ɵɵlistener("click", function TreeNodeItemComponent_Template_button_click_10_listener($event) { return ctx.openDropDown($event); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(11, "svg", 3);
        ɵngcc0.ɵɵelement(12, "path", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(13, "span");
        ɵngcc0.ɵɵtext(14, "\u0412\u0432\u0435\u0440\u0445");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(15, "button", 9);
        ɵngcc0.ɵɵlistener("click", function TreeNodeItemComponent_Template_button_click_15_listener($event) { return ctx.openDropDown($event); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(16, "svg", 3);
        ɵngcc0.ɵɵelement(17, "path", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(18, "span");
        ɵngcc0.ɵɵtext(19, "\u0412\u043D\u0438\u0437");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(20, "div", 12);
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(22, "div", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(23, TreeNodeItemComponent_ng_template_23_Template, 2, 2, "ng-template", 14);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.node.children && ctx.node.children.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("nmDropdownMenu", ctx.dropDownMenu);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.node.title, " ");
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵtextInterpolate1(" ", (ctx.node == null ? null : ctx.node.price) ? "RUB " + ctx.node.price : "", " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("background-color", ctx.node == null ? null : ctx.node.color);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.node == null ? null : ctx.node.isExpanded) && ctx.node.children && ctx.node.children.length > 0);
    } }, dependencies: function () { return [ɵngcc1.NgIf, IconLoaderComponent, NmDropDownDirective, TreeNodeComponent]; }, encapsulation: 2 });
TreeNodeItemComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
__decorate([
    Input(),
    __metadata("design:type", TreeNode)
], TreeNodeItemComponent.prototype, "node", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], TreeNodeItemComponent.prototype, "dropDownMenu", void 0);
TreeNodeItemComponent = __decorate([ __metadata("design:paramtypes", [Renderer2, ElementRef])
], TreeNodeItemComponent);

let TreeNodeComponent = class TreeNodeComponent {
};
TreeNodeComponent.ɵfac = function TreeNodeComponent_Factory(t) { return new (t || TreeNodeComponent)(); };
TreeNodeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TreeNodeComponent, selectors: [["nm-item-tree"]], inputs: { tree: "tree", dropDownMenu: "dropDownMenu" }, decls: 2, vars: 1, consts: [[1, "tree__panel"], [3, "node", "dropDownMenu", 4, "ngFor", "ngForOf"], [3, "node", "dropDownMenu"]], template: function TreeNodeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TreeNodeComponent_nm_node_item_1_Template, 1, 2, "nm-node-item", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tree);
    } }, dependencies: [ɵngcc1.NgForOf, TreeNodeItemComponent], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Array)
], TreeNodeComponent.prototype, "tree", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], TreeNodeComponent.prototype, "dropDownMenu", void 0);

let NomiaUiTreeModule = class NomiaUiTreeModule {
};
NomiaUiTreeModule.ɵfac = function NomiaUiTreeModule_Factory(t) { return new (t || NomiaUiTreeModule)(); };
NomiaUiTreeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiTreeModule });
NomiaUiTreeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        NomiaUiIconSpriteModule,
        NomiaUiFormModule,
        NomiaUiDropDownModule] });

let NmCardComponent = class NmCardComponent {
    constructor() {
        this.disabled = false;
        this.cardType = null;
        this.cardTopLeftClick = new EventEmitter();
        this.cardBottomLeftClick = new EventEmitter();
        this.cardTopRightClick = new EventEmitter();
        this.cardBottomRightClick = new EventEmitter();
    }
    cardTopLeftClickEvent(event) {
        this.cardTopLeftClick.emit(event);
    }
    cardTopRightClickEvent(event) {
        this.cardTopRightClick.emit(event);
    }
    cardBottomLeftClickEvent(event) {
        this.cardBottomLeftClick.emit(event);
    }
    cardBottomRightClickEvent(event) {
        this.cardBottomRightClick.emit(event);
    }
};
NmCardComponent.ɵfac = function NmCardComponent_Factory(t) { return new (t || NmCardComponent)(); };
NmCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmCardComponent, selectors: [["nm-card-item"]], hostAttrs: [1, "card-item"], hostVars: 9, hostBindings: function NmCardComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("simple-card", ctx.cardType === "simple")("universal-card", ctx.cardType === "universal")("order-card", ctx.cardType === "order")("unit-card", ctx.cardType === "unit");
    } }, inputs: { disabled: "disabled", color: "color", size: "size", cardType: "cardType" }, outputs: { cardTopLeftClick: "cardTopLeftClick", cardBottomLeftClick: "cardBottomLeftClick", cardTopRightClick: "cardTopRightClick", cardBottomRightClick: "cardBottomRightClick" }, ngContentSelectors: _c22, decls: 10, vars: 0, consts: [[1, "card-item__top"], [1, "d-flex", "direction-column", "card-item__top-left", 3, "click"], [1, "d-flex", "card-item__top-right", 3, "click"], [1, "card-item__bottom"], [1, "card-item__bottom-left", 3, "click"], [1, "card-item__bottom-right", 3, "click"]], template: function NmCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c21);
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function NmCardComponent_Template_div_click_1_listener($event) { return ctx.cardTopLeftClickEvent($event); });
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵlistener("click", function NmCardComponent_Template_div_click_3_listener($event) { return ctx.cardTopRightClickEvent($event); });
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 3)(6, "div", 4);
        ɵngcc0.ɵɵlistener("click", function NmCardComponent_Template_div_click_6_listener($event) { return ctx.cardBottomLeftClickEvent($event); });
        ɵngcc0.ɵɵprojection(7, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵlistener("click", function NmCardComponent_Template_div_click_8_listener($event) { return ctx.cardBottomRightClickEvent($event); });
        ɵngcc0.ɵɵprojection(9, 3);
        ɵngcc0.ɵɵelementEnd()();
    } }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmCardComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmCardComponent.prototype, "cardType", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmCardComponent.prototype, "cardTopLeftClick", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmCardComponent.prototype, "cardBottomLeftClick", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmCardComponent.prototype, "cardTopRightClick", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmCardComponent.prototype, "cardBottomRightClick", void 0);
NmCardComponent = __decorate([ __metadata("design:paramtypes", [])
], NmCardComponent);

let NomiaUiCardModule = class NomiaUiCardModule {
};
NomiaUiCardModule.ɵfac = function NomiaUiCardModule_Factory(t) { return new (t || NomiaUiCardModule)(); };
NomiaUiCardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiCardModule });
NomiaUiCardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

let NmTagComponent = class NmTagComponent {
    constructor() {
        this.disabled = false;
        this.selected = false;
        this.isCreator = false;
        this.hideDeleteButton = false;
        this.tagDelete = new EventEmitter();
    }
    tagDeleteEvent(e) {
        e.stopPropagation();
        this.tagDelete.emit();
    }
};
NmTagComponent.ɵfac = function NmTagComponent_Factory(t) { return new (t || NmTagComponent)(); };
NmTagComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmTagComponent, selectors: [["nm-tag"]], hostAttrs: [1, "tag-item"], hostVars: 5, hostBindings: function NmTagComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
        ɵngcc0.ɵɵclassProp("tag__selected", ctx.selected)("tag__creator", ctx.isCreator);
    } }, inputs: { disabled: "disabled", color: "color", size: "size", selected: "selected", isCreator: "isCreator", hideDeleteButton: "hideDeleteButton" }, outputs: { tagDelete: "tagDelete" }, ngContentSelectors: _c1, decls: 2, vars: 2, consts: [[3, "ngIf"], ["class", "d-flex ml-1", 3, "click", 4, "ngIf"], [1, "d-flex", "ml-1", 3, "click"], ["width", "16", "height", "16", "viewBox", "0 0 16 16", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["clip-path", "url(#clip0)"], ["d", "M2.9082 13.0911L13.0905 2.90873", "stroke", "#C3CEE0", "stroke-linecap", "round"], ["d", "M2.9082 2.90894L13.0905 13.0913", "stroke", "#C3CEE0", "stroke-linecap", "round"], ["id", "clip0"], ["width", "16", "height", "16", "fill", "white"], ["d", "M7.99902 1.6001V14.4001", "stroke", "#22242C", "stroke-linecap", "round"], ["d", "M1.59961 8.00024L14.3996 8.00024", "stroke", "#22242C", "stroke-linecap", "round"]], template: function NmTagComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NmTagComponent_ng_template_0_Template, 2, 1, "ng-template", 0);
        ɵngcc0.ɵɵtemplate(1, NmTagComponent_ng_template_1_Template, 7, 0, "ng-template", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isCreator);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isCreator);
    } }, dependencies: [ɵngcc1.NgIf], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmTagComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmTagComponent.prototype, "selected", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmTagComponent.prototype, "isCreator", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmTagComponent.prototype, "hideDeleteButton", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmTagComponent.prototype, "tagDelete", void 0);
NmTagComponent = __decorate([ __metadata("design:paramtypes", [])
], NmTagComponent);

let NomiaUiTagsModule = class NomiaUiTagsModule {
};
NomiaUiTagsModule.ɵfac = function NomiaUiTagsModule_Factory(t) { return new (t || NomiaUiTagsModule)(); };
NomiaUiTagsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiTagsModule });
NomiaUiTagsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });

let NmSlideBarComponent = class NmSlideBarComponent {
    constructor(renderer) {
        this.renderer = renderer;
        this.state = false;
        this.disabled = false;
        this.size = 'medium';
        this.position = 'right';
        this.className = '';
        this.closeSideBar = new EventEmitter();
        this.isCloseble = true;
    }
    ngOnChanges(changes) {
        const { state } = changes;
        if (state === null || state === void 0 ? void 0 : state.currentValue) {
            this.renderer.addClass(document.getElementsByTagName('body')[0], 'overflow-hidden');
        }
        else {
            this.renderer.removeClass(document.getElementsByTagName('body')[0], 'overflow-hidden');
        }
    }
    mouseDown(event) {
        this.isCloseble = !this.sidebar.nativeElement.contains(event.target);
    }
    mouseUp(event) {
        if (this.isCloseble) {
            this.close();
        }
    }
    close() {
        this.closeSideBar.emit();
    }
};
NmSlideBarComponent.ɵfac = function NmSlideBarComponent_Factory(t) { return new (t || NmSlideBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NmSlideBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmSlideBarComponent, selectors: [["nm-slide-bar"]], viewQuery: function NmSlideBarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c23, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.sidebar = _t.first);
    } }, hostAttrs: [1, "nm__sidebar"], hostVars: 1, hostBindings: function NmSlideBarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
    } }, inputs: { disabled: "disabled", color: "color", size: "size", state: "state", position: "position", className: "className", title: "title" }, outputs: { closeSideBar: "closeSideBar" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 5, vars: 17, consts: [[1, "sidebar__wrap", 3, "ngClass", "mousedown", "mouseup"], [1, "sidebar"], [1, "sidebar__container"], ["sidebar", ""]], template: function NmSlideBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("mousedown", function NmSlideBarComponent_Template_div_mousedown_0_listener($event) { return ctx.mouseDown($event); })("mouseup", function NmSlideBarComponent_Template_div_mouseup_0_listener($event) { return ctx.mouseUp($event); });
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "div", 2, 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("sidebar--active", ctx.state)("sidebar__wrap--small", ctx.size === "small")("sidebar__wrap--medium", ctx.size === "medium")("sidebar__wrap--large", ctx.size === "large");
        ɵngcc0.ɵɵproperty("ngClass", ctx.className || "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("sidebar__position--left", ctx.position === "left")("sidebar__position--right", ctx.position === "right")("sidebar__position--top", ctx.position === "top")("sidebar__position--bottom", ctx.position === "bottom");
    } }, dependencies: [ɵngcc1.NgClass], encapsulation: 2 });
NmSlideBarComponent.ctorParameters = () => [
    { type: Renderer2 }
];
__decorate([
    ViewChild('sidebar'),
    __metadata("design:type", ElementRef)
], NmSlideBarComponent.prototype, "sidebar", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmSlideBarComponent.prototype, "title", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmSlideBarComponent.prototype, "state", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmSlideBarComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmSlideBarComponent.prototype, "size", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmSlideBarComponent.prototype, "position", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmSlideBarComponent.prototype, "className", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmSlideBarComponent.prototype, "closeSideBar", void 0);
NmSlideBarComponent = __decorate([ __metadata("design:paramtypes", [Renderer2])
], NmSlideBarComponent);

let NomiaUiSlideBarModule = class NomiaUiSlideBarModule {
};
NomiaUiSlideBarModule.ɵfac = function NomiaUiSlideBarModule_Factory(t) { return new (t || NomiaUiSlideBarModule)(); };
NomiaUiSlideBarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiSlideBarModule });
NomiaUiSlideBarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [NomiaUiButtonModule,
        CommonModule] });

let NmRangeSlideComponent = class NmRangeSlideComponent {
    constructor() {
        this.disabledSalePrice = false;
        this.disabledPrimePrice = false;
        this.changeValue = new EventEmitter();
    }
    ngOnChanges(changes) {
        this.initial();
    }
    rangeChange(primePrice, range) {
        const primePriceValue = Number(primePrice.ngControl.control.value);
        const rangeValue = Number(range.value);
        const calculated = ((primePriceValue * 100) / (100 - (rangeValue === 100 ? 99.9 : rangeValue))).toString().slice(0, 6);
        this.changeValue.emit({
            salePrice: calculated,
        });
        this.formGroup.patchValue({
            salePrice: calculated,
        });
    }
    calcProfit(primePrice, salePrice) {
        const primePriceValue = Number(primePrice.ngControl.control.value) || 0;
        const salePriceValue = Number(salePrice.ngControl.control.value) || 0;
        this.generateProfit(salePriceValue, primePriceValue);
    }
    generateProfit(salePriceValue, primePriceValue) {
        let profit = (((salePriceValue - primePriceValue) / salePriceValue) *
            100).toFixed(0);
        if (!isFinite(+profit) || isNaN(+profit)) {
            profit = '0';
        }
        this.profit = profit;
        this.margin = (salePriceValue - primePriceValue).toString().slice(0, 6);
    }
    initial() {
        this.generateProfit(this.formGroup.value.salePrice, this.formGroup.value.primePrice);
    }
};
NmRangeSlideComponent.ɵfac = function NmRangeSlideComponent_Factory(t) { return new (t || NmRangeSlideComponent)(); };
NmRangeSlideComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmRangeSlideComponent, selectors: [["nm-slide-range"]], hostAttrs: [1, "full"], inputs: { disabledSalePrice: "disabledSalePrice", disabledPrimePrice: "disabledPrimePrice", formGroup: "formGroup" }, outputs: { changeValue: "changeValue" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 36, vars: 12, consts: [[3, "formGroup"], [1, "range__wrapper"], [1, "d-flex", "justify-space-between", "mb-1"], [1, "mr-1", "full"], ["label", "\u0421\u0435\u0431\u0435\u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C:  ", "size", "small", "alertError", "This is error message", 1, "full", 3, "disabled"], [3, "formControlName", "suffix", "ngModelChange"], ["primePrice", ""], [1, "full"], ["label", "\u0426\u0435\u043D\u0430:  ", "size", "small", "alertError", "This is error message", 1, "full", 3, "disabled"], ["salePrice", ""], [1, "margin__panel", "d-flex", "direction-column"], [1, "margin-label"], [1, "d-flex", "margin-value"], [1, "range-value"], [2, "margin", "0px .4rem"], [1, "currency-value"], ["type", "range", "min", "1", "max", "100", "step", "1", 1, "range", 3, "ngModel", "ngModelOptions", "ngModelChange"], ["range", ""], [1, "d-flex", "align-middle", "justify-space-between", "m-t"]], template: function NmRangeSlideComponent_Template(rf, ctx) { if (rf & 1) {
        const _r3 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "form", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "nm-input-group")(5, "nm-form-item", 4)(6, "nm-calc", 5, 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function NmRangeSlideComponent_Template_nm_calc_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r3); const _r0 = ɵngcc0.ɵɵreference(7); const _r1 = ɵngcc0.ɵɵreference(12); return ɵngcc0.ɵɵresetView(ctx.calcProfit(_r0, _r1)); });
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(8, "div", 7)(9, "nm-input-group")(10, "nm-form-item", 8)(11, "nm-calc", 5, 9);
        ɵngcc0.ɵɵlistener("ngModelChange", function NmRangeSlideComponent_Template_nm_calc_ngModelChange_11_listener() { ɵngcc0.ɵɵrestoreView(_r3); const _r0 = ɵngcc0.ɵɵreference(7); const _r1 = ɵngcc0.ɵɵreference(12); return ɵngcc0.ɵɵresetView(ctx.calcProfit(_r0, _r1)); });
        ɵngcc0.ɵɵelementEnd()()()()();
        ɵngcc0.ɵɵelementStart(13, "div")(14, "div", 10)(15, "div")(16, "span", 11);
        ɵngcc0.ɵɵtext(17, "\u041C\u0430\u0440\u0436\u0430: ");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(18, "div", 12)(19, "span", 13);
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "span", 14);
        ɵngcc0.ɵɵtext(22, " = ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "span");
        ɵngcc0.ɵɵtext(24);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "span", 15);
        ɵngcc0.ɵɵtext(26, " \u20BD ");
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(27, "input", 16, 17);
        ɵngcc0.ɵɵlistener("ngModelChange", function NmRangeSlideComponent_Template_input_ngModelChange_27_listener($event) { return ctx.profit = $event; })("ngModelChange", function NmRangeSlideComponent_Template_input_ngModelChange_27_listener() { ɵngcc0.ɵɵrestoreView(_r3); const _r0 = ɵngcc0.ɵɵreference(7); const _r2 = ɵngcc0.ɵɵreference(28); return ɵngcc0.ɵɵresetView(ctx.rangeChange(_r0, _r2)); });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(29, "div", 18)(30, "div");
        ɵngcc0.ɵɵtext(31, " 0 % ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "div");
        ɵngcc0.ɵɵtext(33, " 50 % ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "div");
        ɵngcc0.ɵɵtext(35, " 99.9 % ");
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabledPrimePrice);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", "primePrice")("suffix", "\u20BD");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabledSalePrice);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", "salePrice")("suffix", "\u20BD");
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.profit, "%");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.margin, " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.profit)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(11, _c24));
    } }, dependencies: [ɵngcc4.ɵNgNoValidate, ɵngcc4.DefaultValueAccessor, ɵngcc4.RangeValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgControlStatusGroup, ɵngcc4.NgModel, ɵngcc4.FormGroupDirective, ɵngcc4.FormControlName, NmInputGroupComponent, NmFormItemComponent, NmCalcInputComponent], encapsulation: 2, changeDetection: 0 });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmRangeSlideComponent.prototype, "disabledSalePrice", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmRangeSlideComponent.prototype, "disabledPrimePrice", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], NmRangeSlideComponent.prototype, "formGroup", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmRangeSlideComponent.prototype, "changeValue", void 0);
NmRangeSlideComponent = __decorate([ __metadata("design:paramtypes", [])
], NmRangeSlideComponent);

let NomiaUiRangeSlideModule = class NomiaUiRangeSlideModule {
};
NomiaUiRangeSlideModule.ɵfac = function NomiaUiRangeSlideModule_Factory(t) { return new (t || NomiaUiRangeSlideModule)(); };
NomiaUiRangeSlideModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiRangeSlideModule });
NomiaUiRangeSlideModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [FormsModule,
        ReactiveFormsModule,
        NomiaUiFormModule] });

let NmGoalsComponent = class NmGoalsComponent {
    constructor() {
        this.disabledAllGoals = false;
        this.isExpand = false;
    }
};
NmGoalsComponent.ɵfac = function NmGoalsComponent_Factory(t) { return new (t || NmGoalsComponent)(); };
NmGoalsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmGoalsComponent, selectors: [["nm-goals"]], hostAttrs: [1, "task__panel"], hostVars: 1, hostBindings: function NmGoalsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabledAllGoals", ctx.disabledAllGoals || null);
    } }, inputs: { disabledAllGoals: "disabledAllGoals", color: "color", size: "size", goal: "goal" }, ngContentSelectors: _c26, decls: 13, vars: 3, consts: [[1, "d-flex", "align-middle", "justify-space-between"], [1, "d-flex", "align-middle"], ["width", "18", "height", "24", "viewBox", "0 0 18 24", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "mr-1"], ["d", "M4 15.5L4 14M4 14V3.39903C4 1.88478 4 1.12765 4.49287 0.837644C4.98574 0.547636 5.64759 0.915329 6.97129 1.65071L14.1246 5.62478C15.6042 6.44677 16.344 6.85777 16.3262 7.46573C16.3085 8.07369 15.546 8.44083 14.0209 9.1751L4 14Z", "stroke", "#22242C", "stroke-linecap", "round"], ["cx", "4", "cy", "20.5", "r", "3", "stroke", "#22242C", "stroke-linecap", "round"], [1, "h2"], [1, "d-flex", "align-middle", "cursor-pointer", 3, "click"], [1, "mr-1"], ["width", "14", "height", "7", "viewBox", "0 0 14 7", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M12.625 0.875L9.82843 3.67157C8.49509 5.00491 7.82843 5.67157 7 5.67157C6.17157 5.67157 5.50491 5.00491 4.17157 3.67157L1.375 0.874999", "stroke", "#22242C", "stroke-linecap", "round", "stroke-linejoin", "round"], ["class", "task__panel--body", 4, "ngIf"], [1, "task__panel--body"], [3, "goal", "index", "disabled", "hideIndex", 4, "ngFor", "ngForOf"], [3, "goal", "index", "disabled", "hideIndex"]], template: function NmGoalsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c25);
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(2, "svg", 2);
        ɵngcc0.ɵɵelement(3, "path", 3)(4, "circle", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵlistener("click", function NmGoalsComponent_Template_div_click_7_listener() { return ctx.isExpand = !ctx.isExpand; });
        ɵngcc0.ɵɵelementStart(8, "span", 7);
        ɵngcc0.ɵɵprojection(9, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(10, "svg", 8);
        ɵngcc0.ɵɵelement(11, "path", 9);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵtemplate(12, NmGoalsComponent_div_12_Template, 2, 1, "div", 10);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵclassProp("rotate180", ctx.isExpand);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isExpand);
    } }, dependencies: function () { return [ɵngcc1.NgForOf, ɵngcc1.NgIf, NmGoalItemComponent]; }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmGoalsComponent.prototype, "goal", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmGoalsComponent.prototype, "disabledAllGoals", void 0);
NmGoalsComponent = __decorate([ __metadata("design:paramtypes", [])
], NmGoalsComponent);

let NmGoalItemComponent = class NmGoalItemComponent {
    constructor() {
        this.hideIndex = false;
        this.disabled = false;
    }
};
NmGoalItemComponent.ɵfac = function NmGoalItemComponent_Factory(t) { return new (t || NmGoalItemComponent)(); };
NmGoalItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmGoalItemComponent, selectors: [["nm-goal-item"]], hostAttrs: [1, "task__item"], hostVars: 1, hostBindings: function NmGoalItemComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
    } }, inputs: { disabled: "disabled", color: "color", size: "size", hideIndex: "hideIndex", goal: "goal", index: "index" }, decls: 9, vars: 7, consts: [[1, "d-flex", "align-top", "task-item__el"], [1, "mr-1", 2, "min-width", "14px"], [3, "hidden"], [1, "task-item__el--body"], [1, "mb-1"], [3, "ngModel", "disabled", "ngModelChange"]], template: function NmGoalItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(4, "div", 3)(5, "div", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(7, "div")(8, "nm-checkbox", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function NmGoalItemComponent_Template_nm_checkbox_ngModelChange_8_listener($event) { return ctx.goal.isComplete = $event; });
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("nm-task-item--active", ctx.goal == null ? null : ctx.goal.isComplete);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.hideIndex);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.index, ".");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.goal.name);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.goal.isComplete)("disabled", ctx.disabled || ctx.goal.disabled);
    } }, dependencies: [ɵngcc4.NgControlStatus, ɵngcc4.NgModel, NmCheckBoxComponent], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmGoalItemComponent.prototype, "goal", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], NmGoalItemComponent.prototype, "index", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmGoalItemComponent.prototype, "hideIndex", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmGoalItemComponent.prototype, "disabled", void 0);
NmGoalItemComponent = __decorate([ __metadata("design:paramtypes", [])
], NmGoalItemComponent);

let NomiaUiGoalsModule = class NomiaUiGoalsModule {
};
NomiaUiGoalsModule.ɵfac = function NomiaUiGoalsModule_Factory(t) { return new (t || NomiaUiGoalsModule)(); };
NomiaUiGoalsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiGoalsModule });
NomiaUiGoalsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        NomiaUiFormModule] });

let NmLineGraphComponent = class NmLineGraphComponent {
    constructor() {
        this.width = 100;
        this.height = 100;
        this.data = [];
    }
    ngOnChanges(changes) {
        const { data } = changes;
        if (data.previousValue !== data.currentValue) {
            this.renderLineGraph();
        }
    }
    ngAfterViewInit() {
        this.renderLineGraph();
    }
    renderLineGraph() {
        const arr = this.data;
        if (arr.length && arr.length > 0) {
            let arrData = [];
            arr.forEach((item, index) => {
                arrData.push({
                    x: index * 10,
                    y: item,
                });
            });
            const maxValue = Math.max(...arr);
            let myLineChart = new LineGraph({
                canvas: this.canvas.nativeElement,
                minX: 0,
                minY: 0,
                maxX: (arr.length > 0 ? arr.length - 1 : 0) * 10,
                maxY: maxValue,
                unitsPerTickX: 10,
                unitsPerTickY: 10
            });
            myLineChart.drawLine(arrData, '#39A5FF', 1);
        }
    }
};
NmLineGraphComponent.ɵfac = function NmLineGraphComponent_Factory(t) { return new (t || NmLineGraphComponent)(); };
NmLineGraphComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmLineGraphComponent, selectors: [["nm-line-graph"]], viewQuery: function NmLineGraphComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c27, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.canvas = _t.first);
    } }, inputs: { width: "width", height: "height", data: "data" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "width", "height"], ["canvas", ""]], template: function NmLineGraphComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "canvas", 0, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("width", ctx.width);
        ɵngcc0.ɵɵpropertyInterpolate("height", ctx.height);
    } }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmLineGraphComponent.prototype, "width", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmLineGraphComponent.prototype, "height", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], NmLineGraphComponent.prototype, "data", void 0);
__decorate([
    ViewChild('canvas', { static: true }),
    __metadata("design:type", ElementRef)
], NmLineGraphComponent.prototype, "canvas", void 0);
NmLineGraphComponent = __decorate([ __metadata("design:paramtypes", [])
], NmLineGraphComponent);
class LineGraph {
    constructor(opt) {
        // constants
        this.padding = 0;
        this.tickSize = 10;
        this.axisColor = '#555';
        this.pointRadius = 0;
        this.font = '12pt Calibri';
        this.fontHeight = 12;
        this.canvas = opt.canvas;
        this.minX = opt.minX;
        this.minY = opt.minY;
        this.maxX = opt.maxX;
        this.maxY = opt.maxY;
        this.unitsPerTickX = opt.unitsPerTickX;
        this.unitsPerTickY = opt.unitsPerTickY;
        this.context = this.canvas.getContext('2d');
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.rangeX = this.maxX - this.minY;
        this.rangeY = this.maxY - this.minY;
        this.numXTicks = Math.round(this.rangeX / this.unitsPerTickX);
        this.numYTicks = Math.round(this.rangeY / this.unitsPerTickY);
        // this.x = this.getLongestValueWidth() + this.padding * 2;
        // this.y = this.padding * 2;
        this.x = 0;
        this.y = 0;
        this.width = this.canvas.width - this.x - this.padding * 2;
        this.height = this.canvas.height - this.y - this.padding - this.fontHeight;
        this.scaleX = this.width / this.rangeX;
        this.scaleY = this.height / this.rangeY;
    }
    getLongestValueWidth() {
        this.context.font = this.font;
        let longestValueWidth = 0;
        for (let n = 0; n <= this.numYTicks; n++) {
            let value = this.maxY - (n * this.unitsPerTickY);
            longestValueWidth = Math.max(longestValueWidth, this.context.measureText(value).width);
        }
        return longestValueWidth;
    }
    drawXAxis() {
        let context = this.context;
        context.save();
        context.beginPath();
        context.moveTo(this.x, this.y + this.height);
        context.lineTo(this.x + this.width, this.y + this.height);
        context.strokeStyle = this.axisColor;
        context.lineWidth = 2;
        context.stroke();
        // draw tick marks
        for (let n = 0; n < this.numXTicks; n++) {
            context.beginPath();
            context.moveTo((n + 1) * this.width / this.numXTicks + this.x, this.y + this.height);
            context.lineTo((n + 1) * this.width / this.numXTicks + this.x, this.y + this.height - this.tickSize);
            context.stroke();
        }
        // draw labels
        context.font = this.font;
        context.fillStyle = 'black';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        for (let n = 0; n < this.numXTicks; n++) {
            const label = Math.round((n + 1) * this.maxX / this.numXTicks);
            context.save();
            context.translate((n + 1) * this.width / this.numXTicks + this.x, this.y + this.height + this.padding);
            context.fillText(label, 0, 0);
            context.restore();
        }
        context.restore();
    }
    drawYAxis() {
        let context = this.context;
        context.save();
        context.beginPath();
        context.moveTo(this.x, this.y);
        context.lineTo(this.x, this.y + this.height);
        context.strokeStyle = this.axisColor;
        context.lineWidth = 2;
        context.stroke();
        context.restore();
        // draw tick marks
        for (let n = 0; n < this.numYTicks; n++) {
            context.beginPath();
            context.moveTo(this.x, n * this.height / this.numYTicks + this.y);
            context.lineTo(this.x + this.tickSize, n * this.height / this.numYTicks + this.y);
            context.stroke();
        }
        // draw values
        context.font = this.font;
        context.fillStyle = 'black';
        context.textAlign = 'right';
        context.textBaseline = 'middle';
        for (let n = 0; n < this.numYTicks; n++) {
            const value = Math.round(this.maxY - n * this.maxY / this.numYTicks);
            context.save();
            context.translate(this.x - this.padding, n * this.height / this.numYTicks + this.y);
            context.fillText(value, 0, 0);
            context.restore();
        }
        context.restore();
    }
    drawLine(data, color, width) {
        let context = this.context;
        context.save();
        this.transformContext();
        context.lineWidth = width;
        context.strokeStyle = color;
        context.fillStyle = color;
        context.beginPath();
        context.moveTo(data[0].x * this.scaleX, data[0].y * this.scaleY);
        for (let n = 0; n < data.length; n++) {
            const point = data[n];
            // draw segment
            context.lineTo(point.x * this.scaleX, point.y * this.scaleY);
            context.stroke();
            context.closePath();
            context.beginPath();
            context.arc(point.x * this.scaleX, point.y * this.scaleY, this.pointRadius, 0, 2 * Math.PI, false);
            // context.fill();
            context.closePath();
            // position for next segment
            context.beginPath();
            context.moveTo(point.x * this.scaleX, point.y * this.scaleY);
        }
        context.restore();
    }
    transformContext() {
        let context = this.context;
        // move context to center of canvas
        this.context.translate(this.x, this.y + this.height);
        context.scale(1, -1);
    }
}

let NomiaUiGraphicsModule = class NomiaUiGraphicsModule {
};
NomiaUiGraphicsModule.ɵfac = function NomiaUiGraphicsModule_Factory(t) { return new (t || NomiaUiGraphicsModule)(); };
NomiaUiGraphicsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiGraphicsModule });
NomiaUiGraphicsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

let NmScrollDirective = class NmScrollDirective {
    constructor(element, zone) {
        this.element = element;
        this.zone = zone;
        this.scrolled = new EventEmitter();
        this.scrolledUp = new EventEmitter();
        this.scrollDisabled = false;
        this.scrollDownDistance = 2;
        this.scrollUpDistance = 1.5;
        this.lastScrollTop = 0;
    }
    ngAfterViewInit() {
        if (!this.scrollDisabled) {
            this.setup();
        }
    }
    ngOnChanges() {
    }
    setup() {
        const container = document.querySelector(this.selectorContainer);
        if (container) {
            this.zone.runOutsideAngular(() => {
                fromEvent(container, 'scroll')
                    .pipe(tap(() => this.getPosition(container)), throttleTime(150), filter(() => this.shouldFireScrollEvent(container)))
                    .subscribe((payload) => this.zone.run(() => this.handleOnScroll(payload)));
            });
        }
    }
    getPosition(container) {
        let st = container.scrollTop;
        if (st > this.lastScrollTop) {
            this.isDown = true;
        }
        else {
            this.isDown = false;
        }
        this.lastScrollTop = st <= 0 ? 0 : st;
    }
    handleOnScroll(data) {
        if (this.isDown) {
            this.scrolled.emit(data);
        }
        else {
            this.scrolledUp.emit(data);
        }
    }
    shouldFireScrollEvent(container) {
        let remaining;
        let containerBreakpoint;
        if (container.scrollHeight <= 0) {
            return false;
        }
        const scrolledUntilNow = container.clientHeight + container.scrollTop;
        if (this.isDown) {
            remaining = (container.scrollHeight - scrolledUntilNow) / container.scrollHeight;
            containerBreakpoint = this.scrollDownDistance / 10;
        }
        else {
            const totalHiddenContentHeight = container.scrollTop + (container.scrollHeight - scrolledUntilNow);
            remaining = container.scrollTop / totalHiddenContentHeight;
            containerBreakpoint = this.scrollUpDistance / 10;
        }
        const shouldFireEvent = remaining <= containerBreakpoint;
        return shouldFireEvent;
    }
    ngOnDestroy() {
        this.destroyScroller();
    }
    destroyScroller() {
        if (this.disposeScroller) {
            this.disposeScroller.unsubscribe();
        }
    }
};
NmScrollDirective.ɵfac = function NmScrollDirective_Factory(t) { return new (t || NmScrollDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
NmScrollDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NmScrollDirective, selectors: [["", "nmScroll", ""]], inputs: { scrollDisabled: "scrollDisabled", scrollDownDistance: "scrollDownDistance", scrollUpDistance: "scrollUpDistance", selectorContainer: "selectorContainer" }, outputs: { scrolled: "scrolled", scrolledUp: "scrolledUp" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
NmScrollDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
__decorate([
    Output(),
    __metadata("design:type", Object)
], NmScrollDirective.prototype, "scrolled", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], NmScrollDirective.prototype, "scrolledUp", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmScrollDirective.prototype, "selectorContainer", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmScrollDirective.prototype, "scrollDisabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], NmScrollDirective.prototype, "scrollDownDistance", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], NmScrollDirective.prototype, "scrollUpDistance", void 0);
NmScrollDirective = __decorate([ __metadata("design:paramtypes", [ElementRef, NgZone])
], NmScrollDirective);

let NmScrollContentComponent = class NmScrollContentComponent {
    constructor(zone) {
        this.zone = zone;
        this.position = 'bottom';
        this.onDestroy = new Subject();
        this.drag = (e) => {
            e.stopPropagation();
            const delta = e.pageX - this.lastPageX;
            this.lastPageX = e.pageX;
            this.scrollElement.nativeElement.scrollLeft += delta / (this.scrollElement.nativeElement.clientWidth / this.scrollElement.nativeElement.scrollWidth);
        };
        this.stop = (e) => {
            e.stopPropagation();
            window.removeEventListener('mousemove', this.drag);
            window.removeEventListener('mouseup', this.stop);
            requestAnimationFrame(() => {
                this.scrollLine.nativeElement.addEventListener('click', this.scrollLineEvent);
            });
        };
        this.scrollLineEvent = (e) => {
            e.stopPropagation();
            const timelineWidth = parseInt(getComputedStyle(this.scrollLine.nativeElement).width, 10);
            const timeToSeek = e.offsetX / timelineWidth * this.scrollElement.nativeElement.scrollWidth;
            this.scrollElement.nativeElement.scrollLeft = timeToSeek;
        };
    }
    ngOnInit() {
        let startX, // get start horizontal position
        startY, // get start vertical position
        distX, // get horizontal distance
        distY, // get vertical distance
        positionX, newPositionX;
        this.zone.runOutsideAngular(() => {
            fromEvent(this.scrollElement.nativeElement, 'mousewheel')
                .pipe(takeUntil(this.onDestroy))
                .subscribe((data) => {
                if (data.shiftKey) {
                    let delta = (data.wheelDelta || -data.detail);
                    if (delta < 0) {
                        this.scrollElement.nativeElement.scrollLeft = this.scrollElement.nativeElement.scrollLeft + 200;
                    }
                    else if (delta > 0) {
                        this.scrollElement.nativeElement.scrollLeft = this.scrollElement.nativeElement.scrollLeft - 200;
                    }
                }
            });
            fromEvent(this.scrollElement.nativeElement, 'touchstart')
                .pipe(takeUntil(this.onDestroy))
                .subscribe((e) => {
                requestAnimationFrame(() => {
                    e.preventDefault();
                    const touchobj = e.changedTouches[0];
                    positionX = -this.scrollElement.nativeElement.scrollLeft; // get current position scrollLeft element
                    startX = touchobj.pageX;
                    startY = touchobj.pageY;
                });
            });
            fromEvent(this.scrollElement.nativeElement, 'touchmove')
                .pipe(takeUntil(this.onDestroy))
                .subscribe((e) => {
                requestAnimationFrame(() => {
                    const touchobj = e.changedTouches[0];
                    distX = touchobj.pageX - startX;
                    distY = touchobj.pageY - startY;
                    if (Math.abs(distX) > Math.abs(distY)) {
                        e.preventDefault();
                        newPositionX = positionX + distX;
                        this.scrollElement.nativeElement.scrollLeft = -newPositionX; // move element to left via touchMove event (i'm using negative, so it's like mobile app behavior
                    }
                    else { // else consider this a vertical movement
                        return false; // it's not working here
                    }
                });
            });
            fromEvent(this.scrollElement.nativeElement, 'scroll')
                .pipe(takeUntil(this.onDestroy))
                .subscribe((data) => {
                if (!this.ticking) {
                    requestAnimationFrame(() => {
                        this.renderProgress();
                    });
                }
            });
            fromEvent(this.scrollStick.nativeElement, 'mousedown')
                .pipe(takeUntil(this.onDestroy))
                .subscribe((e) => {
                e.stopPropagation();
                this.lastPageX = e.pageX;
                window.addEventListener('mousemove', this.drag);
                window.addEventListener('mouseup', this.stop);
                this.scrollLine.nativeElement.removeEventListener('click', this.scrollLineEvent);
            });
            fromEvent(this.scrollStick.nativeElement, 'touchstart')
                .pipe(takeUntil(this.onDestroy))
                .subscribe((e) => {
                requestAnimationFrame(() => {
                    e.preventDefault();
                    const touchobj = e.changedTouches[0];
                    positionX = -this.scrollElement.nativeElement.scrollLeft; // get current position scrollLeft element
                    startX = touchobj.pageX;
                    startY = touchobj.pageY;
                });
            });
            fromEvent(this.scrollStick.nativeElement, 'touchmove')
                .pipe(takeUntil(this.onDestroy))
                .subscribe((e) => {
                requestAnimationFrame(() => {
                    const touchobj = e.changedTouches[0];
                    distX = touchobj.pageX - startX;
                    distY = touchobj.pageY - startY;
                    if (Math.abs(distX) > Math.abs(distY)) {
                        e.preventDefault();
                        newPositionX = positionX + distX;
                        this.scrollElement.nativeElement.scrollLeft = newPositionX;
                    }
                    else { // else consider this a vertical movement
                        return false; // it's not working here
                    }
                });
            });
            this.scrollLine.nativeElement.addEventListener('click', this.scrollLineEvent);
        });
    }
    ngAfterViewInit() {
        this.renderProgress();
    }
    ngOnDestroy() {
        this.onDestroy.next();
        this.onDestroy.complete();
    }
    renderProgress() {
        let documentScrollLeft = this.scrollElement.nativeElement.scrollLeft;
        if (this.scrollLeft !== documentScrollLeft) {
            const totalWidth = this.scrollElement.nativeElement.scrollWidth, ownWidth = this.scrollElement.nativeElement.clientWidth;
            let scrollPercentage = 100 * documentScrollLeft / (totalWidth - ownWidth);
            this.ratio = ownWidth / totalWidth;
            this.scrollProgress.nativeElement.style.width = scrollPercentage + '%';
            this.scrollStick.nativeElement.style.width = Math.max(this.ratio * 100, 10) + '%';
            this.scrollStick.nativeElement.style.left = (documentScrollLeft / totalWidth) * 100 + '%';
            this.scrollLeft = documentScrollLeft;
        }
        else {
            console.log('scroll y: ');
        }
        this.ticking = false;
    }
};
NmScrollContentComponent.ɵfac = function NmScrollContentComponent_Factory(t) { return new (t || NmScrollContentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
NmScrollContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmScrollContentComponent, selectors: [["nm-scroll-content"]], viewQuery: function NmScrollContentComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c28, 7);
        ɵngcc0.ɵɵviewQuery(_c29, 7);
        ɵngcc0.ɵɵviewQuery(_c30, 7);
        ɵngcc0.ɵɵviewQuery(_c31, 7);
        ɵngcc0.ɵɵviewQuery(_c32, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scrollElement = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scrollInner = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scrollStick = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scrollProgress = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.scrollLine = _t.first);
    } }, hostVars: 2, hostBindings: function NmScrollContentComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("scroll-line__top", ctx.position === "top");
    } }, inputs: { position: "position" }, ngContentSelectors: _c1, decls: 18, vars: 0, consts: [[1, "scroll__panel"], ["scrollElement", ""], [1, "scrollable_inner"], ["scrollInner", ""], [1, "scroll-line"], ["scrollLine", ""], [1, "progress"], ["scrollProgress", ""], [1, "bar"], ["scrollStick", ""], [1, "bar__panel"], ["width", "2", "height", "12", "viewBox", "0 0 2 12", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "bar__item"], ["width", "2", "height", "12", "rx", "1", "fill", "#EDF1F8"]], template: function NmScrollContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2, 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 4, 5);
        ɵngcc0.ɵɵelement(7, "div", 6, 7);
        ɵngcc0.ɵɵelementStart(9, "div", 8, 9)(11, "div", 10);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(12, "svg", 11);
        ɵngcc0.ɵɵelement(13, "rect", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "svg", 11);
        ɵngcc0.ɵɵelement(15, "rect", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "svg", 11);
        ɵngcc0.ɵɵelement(17, "rect", 12);
        ɵngcc0.ɵɵelementEnd()()()();
    } }, encapsulation: 2 });
NmScrollContentComponent.ctorParameters = () => [
    { type: NgZone }
];
__decorate([
    ViewChild('scrollElement', { static: true }),
    __metadata("design:type", ElementRef)
], NmScrollContentComponent.prototype, "scrollElement", void 0);
__decorate([
    ViewChild('scrollInner', { static: true }),
    __metadata("design:type", ElementRef)
], NmScrollContentComponent.prototype, "scrollInner", void 0);
__decorate([
    ViewChild('scrollStick', { static: true }),
    __metadata("design:type", ElementRef)
], NmScrollContentComponent.prototype, "scrollStick", void 0);
__decorate([
    ViewChild('scrollProgress', { static: true }),
    __metadata("design:type", ElementRef)
], NmScrollContentComponent.prototype, "scrollProgress", void 0);
__decorate([
    ViewChild('scrollLine', { static: true }),
    __metadata("design:type", ElementRef)
], NmScrollContentComponent.prototype, "scrollLine", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmScrollContentComponent.prototype, "position", void 0);
NmScrollContentComponent = __decorate([ __metadata("design:paramtypes", [NgZone])
], NmScrollContentComponent);

let NomiaUiScrollModule = class NomiaUiScrollModule {
};
NomiaUiScrollModule.ɵfac = function NomiaUiScrollModule_Factory(t) { return new (t || NomiaUiScrollModule)(); };
NomiaUiScrollModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiScrollModule });
NomiaUiScrollModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

let NmAdviceComponent = class NmAdviceComponent {
    constructor() {
        this.disabled = false;
    }
};
NmAdviceComponent.ɵfac = function NmAdviceComponent_Factory(t) { return new (t || NmAdviceComponent)(); };
NmAdviceComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmAdviceComponent, selectors: [["nm-advice-item"]], hostAttrs: [1, "advice-item"], hostVars: 1, hostBindings: function NmAdviceComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
    } }, inputs: { disabled: "disabled", color: "color", size: "size" }, ngContentSelectors: _c34, decls: 7, vars: 0, consts: [[1, "advice-item__body"], [1, "advice-item__bottom"], [1, "advice-arrow"], ["width", "21", "height", "32", "viewBox", "0 0 21 32", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M7.40504 24.4874L18.7403 6.09899C20.4043 3.39975 21.2362 2.05012 20.6639 1.02506C20.0917 0 18.5062 0 15.3353 0H4C2.11438 0 1.17157 0 0.585786 0.585786C0 1.17157 0 2.11438 0 4V22.3884C0 28.1002 0 30.9561 1.45458 31.3684C2.90916 31.7807 4.40778 29.3496 7.40504 24.4874Z", "fill", "#EDF1F8"]], template: function NmAdviceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c33);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(5, "svg", 3);
        ɵngcc0.ɵɵelement(6, "path", 4);
        ɵngcc0.ɵɵelementEnd()();
    } }, encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmAdviceComponent.prototype, "disabled", void 0);
NmAdviceComponent = __decorate([ __metadata("design:paramtypes", [])
], NmAdviceComponent);

let NomiaUiAdviceModule = class NomiaUiAdviceModule {
};
NomiaUiAdviceModule.ɵfac = function NomiaUiAdviceModule_Factory(t) { return new (t || NomiaUiAdviceModule)(); };
NomiaUiAdviceModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiAdviceModule });
NomiaUiAdviceModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});

let NmUploadImageMenuPositionComponent = class NmUploadImageMenuPositionComponent {
    constructor() {
        this.previewSrc = '';
        this.disabled = false;
        this.buttonColor = 'secondary';
        this.buttonShape = 'round';
        this.placeHolder = 'добавить фото';
        this.multiple = true;
        this.uploadFileChange = new EventEmitter();
        this.deleteFile = new EventEmitter();
        this.validFileExtensions = ['.jpg', '.jpeg', '.png', '.webp'];
    }
    onClick($event) {
        $event.stopPropagation();
    }
    onFilesAdded() {
        const file = this.file.nativeElement.files[0];
        let reader = new FileReader();
        reader.onloadend = () => {
            this.previewSrc = reader.result;
            this.uploadFileChange.emit(file);
        };
        if (file) {
            let blnValid = false;
            for (let j = 0; j < this.validFileExtensions.length; j++) {
                let sCurExtension = this.validFileExtensions[j];
                if (file.name.substr(file.name.length - sCurExtension.length, sCurExtension.length).toLowerCase() === sCurExtension.toLowerCase()) {
                    blnValid = true;
                    break;
                }
            }
            if (!blnValid) {
                this.file.nativeElement.value = '';
                this.previewSrc = '';
                return false;
            }
            else {
                reader.readAsDataURL(file);
            }
        }
        else {
            this.previewSrc = '';
        }
    }
    deleteFileEvent() {
        this.file.nativeElement.value = '';
        this.previewSrc = '';
        this.deleteFile.emit();
    }
    addFiles() {
        this.file.nativeElement.click();
    }
};
NmUploadImageMenuPositionComponent.ɵfac = function NmUploadImageMenuPositionComponent_Factory(t) { return new (t || NmUploadImageMenuPositionComponent)(); };
NmUploadImageMenuPositionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NmUploadImageMenuPositionComponent, selectors: [["nm-upload-position"]], viewQuery: function NmUploadImageMenuPositionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c35, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.file = _t.first);
    } }, hostAttrs: [1, "upload-position__panel"], hostVars: 1, hostBindings: function NmUploadImageMenuPositionComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function NmUploadImageMenuPositionComponent_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("disabled", ctx.disabled || null);
    } }, inputs: { disabled: "disabled", color: "color", size: "size", previewSrc: "previewSrc", buttonColor: "buttonColor", buttonShape: "buttonShape", placeHolder: "placeHolder", multiple: "multiple" }, outputs: { uploadFileChange: "uploadFileChange", deleteFile: "deleteFile" }, decls: 4, vars: 3, consts: [["type", "file", 2, "display", "none", 3, "multiple", "change"], ["file", ""], [3, "ngIf"], ["class", "img-upload__panel", 3, "click", 4, "ngIf"], [1, "upload-img__wr"], ["width", "100%", "height", "100%", "alt", "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0435 \u0444\u043E\u0442\u043E", 3, "src"], ["nm-button", "", "size", "medium", "type", "button", 1, "button__img--delete", 3, "color", "shape", "click"], [1, "icon-item"], [1, "icon-content"], ["width", "20", "height", "20", "viewBox", "0.5 1 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M16.8506 3.14348C17.0459 3.33872 17.0459 3.65531 16.8507 3.85059L10.7041 9.99844L16.8507 16.1463C17.0459 16.3416 17.0459 16.6582 16.8506 16.8534C16.6554 17.0486 16.3388 17.0486 16.1435 16.8533L9.99708 10.7056L3.85359 16.8504C3.65835 17.0457 3.34177 17.0457 3.14648 16.8504C2.9512 16.6552 2.95117 16.3386 3.14641 16.1433L9.29005 9.99844L3.14641 3.85354C2.95117 3.65825 2.9512 3.34167 3.14648 3.14643C3.34177 2.95119 3.65835 2.95122 3.85359 3.1465L9.99708 9.29126L16.1435 3.14355C16.3388 2.94827 16.6553 2.94824 16.8506 3.14348Z", "fill", "#22242C"], [1, "img-upload__panel", 3, "click"], [1, "d-flex", "direction-column", "align-middle", "justify-center"], ["width", "20", "height", "20", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M10.4995 3C10.4995 2.72386 10.2757 2.5 9.99951 2.5C9.72337 2.5 9.49951 2.72386 9.49951 3V9.5H3C2.72386 9.5 2.5 9.72386 2.5 10C2.5 10.2761 2.72386 10.5 3 10.5H9.49951V17C9.49951 17.2761 9.72337 17.5 9.99951 17.5C10.2757 17.5 10.4995 17.2761 10.4995 17V10.5H17C17.2761 10.5 17.5 10.2761 17.5 10C17.5 9.72386 17.2761 9.5 17 9.5H10.4995V3Z", "fill", "#22242C"], [2, "margin-bottom", "6px"]], template: function NmUploadImageMenuPositionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "input", 0, 1);
        ɵngcc0.ɵɵlistener("change", function NmUploadImageMenuPositionComponent_Template_input_change_0_listener() { return ctx.onFilesAdded(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, NmUploadImageMenuPositionComponent_ng_template_2_Template, 7, 3, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(3, NmUploadImageMenuPositionComponent_div_3_Template, 6, 1, "div", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("multiple", ctx.multiple);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.previewSrc);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.previewSrc);
    } }, dependencies: [ɵngcc1.NgIf, NmButton], encapsulation: 2 });
__decorate([
    Input(),
    __metadata("design:type", Object)
], NmUploadImageMenuPositionComponent.prototype, "previewSrc", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmUploadImageMenuPositionComponent.prototype, "disabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmUploadImageMenuPositionComponent.prototype, "buttonColor", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmUploadImageMenuPositionComponent.prototype, "buttonShape", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], NmUploadImageMenuPositionComponent.prototype, "placeHolder", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], NmUploadImageMenuPositionComponent.prototype, "multiple", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmUploadImageMenuPositionComponent.prototype, "uploadFileChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], NmUploadImageMenuPositionComponent.prototype, "deleteFile", void 0);
__decorate([
    ViewChild('file', { static: false }),
    __metadata("design:type", Object)
], NmUploadImageMenuPositionComponent.prototype, "file", void 0);
__decorate([
    HostListener('click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NmUploadImageMenuPositionComponent.prototype, "onClick", null);
NmUploadImageMenuPositionComponent = __decorate([ __metadata("design:paramtypes", [])
], NmUploadImageMenuPositionComponent);

let NomiaUiUploadFileModule = class NomiaUiUploadFileModule {
};
NomiaUiUploadFileModule.ɵfac = function NomiaUiUploadFileModule_Factory(t) { return new (t || NomiaUiUploadFileModule)(); };
NomiaUiUploadFileModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiUploadFileModule });
NomiaUiUploadFileModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        NomiaUiButtonModule] });

let NomiaUiLibModule = class NomiaUiLibModule {
};
NomiaUiLibModule.ɵfac = function NomiaUiLibModule_Factory(t) { return new (t || NomiaUiLibModule)(); };
NomiaUiLibModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NomiaUiLibModule });
NomiaUiLibModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [NomiaUiButtonModule,
        NomiaUiDropDownModule,
        NomiaUiSwitchModule,
        NomiaUiTabsModule,
        NomiaUiFormModule,
        NomiaUiPinCodeModule,
        NomiaUiTableModule,
        NomiaUiScrollModule,
        NomiaUiPopularItemModule,
        NomiaUiPipeModule,
        NomiaUiWrapperModule,
        NomiaUiModalModule,
        NomiaUiDirectivesModule,
        NomiaUiCalendarModule,
        NomiaUiTreeModule,
        NomiaUiTagsModule,
        NomiaUiCardModule,
        NomiaUiSlideBarModule,
        NomiaUiRangeSlideModule,
        NomiaUiGoalsModule,
        NomiaUiUploadFileModule,
        NomiaUiGraphicsModule,
        NomiaUiAdviceModule, NomiaUiButtonModule, NomiaUiDropDownModule, NomiaUiSwitchModule, NomiaUiTabsModule, NomiaUiFormModule, NomiaUiPinCodeModule, NomiaUiTableModule, NomiaUiScrollModule, NomiaUiPopularItemModule, NomiaUiPipeModule, NomiaUiWrapperModule, NomiaUiModalModule, NomiaUiDirectivesModule, NomiaUiCalendarModule, NomiaUiCardModule, NomiaUiTagsModule, NomiaUiAdviceModule, NomiaUiSlideBarModule, NomiaUiRangeSlideModule, NomiaUiGoalsModule, NomiaUiUploadFileModule, NomiaUiGraphicsModule, NomiaUiTreeModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmButton, [{
        type: Component,
        args: [{
                selector: 'button[nm-button]',
                template: '<ng-content></ng-content>',
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'button',
                    '[class.button_primary]': `color === 'primary'`,
                    '[class.button_secondary]': `color === 'secondary'`,
                    '[class.button_peach]': `color === 'peach'`,
                    '[class.button_filled]': `color === 'filled'`,
                    '[class.button-round]': `shape === 'round'`,
                    '[class.button-square]': `shape === 'square'`,
                    '[class.button-triangle]': `shape === 'triangle'`,
                    '[class.button-large]': `size === 'large'`,
                    '[class.button-medium]': `size === 'medium'`
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { color: [{
            type: Input
        }], size: [{
            type: Input
        }], shape: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmButtonBack, [{
        type: Component,
        args: [{
                selector: 'button[nm-button-back]',
                template: `
    <button type="button" class="button-back">
        <span class="button-back__corner">
          <svg width="14" height="36" viewBox="0 0 14 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.39929 2.20794C10.0306 1.1488 11.1727 0.5 12.4057 0.5H32C33.933 0.5 35.5 2.067 35.5 4V32C35.5 33.933 33.933 35.5 32 35.5H12.5333C11.2407 35.5 10.0533 34.7876 9.44507 33.6471L1.50335 18.7563C0.926502 17.6747 0.95754 16.3701 1.58518 15.3172L9.39929 2.20794Z"
              stroke="#C3CEE0"></path></svg>
        </span>
      <div class="button-back__content">
          <span class="button-back__arrow">
            <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0)">
                <path
                  d="M0 3.5L2.91549 7L3.60563 6.18841L2.38028 4.7343L1.67606 4.02415L1.69014 3.97343L3.05634 4.07488H10V2.92512H3.05634L1.69014 3.02657L1.67606 2.97585L2.38028 2.2657L3.60563 0.811595L2.91549 0L0 3.5Z"
                  fill="#22242C"></path>
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="10" height="7" fill="white"></rect>
                </clipPath>
              </defs>
            </svg>
          </span>
        <span class="button-back__title"> 
          <ng-content></ng-content>
        </span>
      </div>
    </button>
  `,
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'button-back',
                    '[class.button-back-mini]': `isMini`,
                    '[class.button-large]': `size === 'large'`,
                    '[class.button-medium]': `size === 'medium'`
                },
                inputs: ['disabled', 'size']
            }]
    }], function () { return []; }, { size: [{
            type: Input
        }], isMini: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmButtonTransparentDirective, [{
        type: Directive,
        args: [{
                selector: '[nm-button-transparent]',
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'button-transparent',
                    '[class.button-large]': `size === 'large'`,
                    '[class.button-medium]': `size === 'medium'`
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return []; }, { size: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiButtonModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmButton,
                    NmButtonBack,
                    NmButtonTransparentDirective
                ],
                imports: [],
                exports: [
                    NmButton,
                    NmButtonBack,
                    NmButtonTransparentDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiButtonModule, { declarations: [NmButton, NmButtonBack, NmButtonTransparentDirective], exports: [NmButton, NmButtonBack, NmButtonTransparentDirective] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownService, [{
        type: Injectable
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmDropDownMenu, [{
        type: Component,
        args: [{
                selector: 'nm-dropdown-menu',
                exportAs: 'nmDropdownMenu',
                template: `
    <ng-template>
      <div
        [ngClass]="'full-width'"
        (mouseenter)="setMouseState(true)"
        (mouseleave)="setMouseState(false)">
        <ng-content></ng-content>
      </div>
    </ng-template>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: DropdownService }, { type: ɵngcc0.ViewContainerRef }]; }, { templateRef: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmDropDownDirective, [{
        type: Directive,
        args: [{
                selector: '[nm-dropdown]',
                host: {
                    '[class.button-dropdown-trigger]': 'true',
                    '[class.dropdown-visible]': 'dVisible'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc2.Overlay }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc3.Platform }]; }, { nmDropdownMenu: [{
            type: Input
        }], triggerEvent: [{
            type: Input
        }], dDisabled: [{
            type: Input
        }], dVisible: [{
            type: Input
        }], dropdownOpen: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmDropDownItemDirective, [{
        type: Directive,
        args: [{
                selector: '[dropdown-item]',
                host: {
                    '[class.dropdown-item]': 'true',
                    '(click)': 'clickItem($event)'
                }
            }]
    }], function () { return [{ type: DropdownService }]; }, { disabled: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmDropDownWrapDirective, [{
        type: Directive,
        args: [{
                selector: '[dropdown-wrap]',
                host: {
                    '[class.dropdown-wrap]': 'true'
                }
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiDropDownModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmDropDownMenu,
                    NmDropDownDirective,
                    NmDropDownItemDirective,
                    NmDropDownWrapDirective
                ],
                imports: [
                    CommonModule,
                    OverlayModule,
                    PlatformModule
                ],
                exports: [
                    NmDropDownMenu,
                    NmDropDownDirective,
                    NmDropDownItemDirective,
                    NmDropDownWrapDirective,
                    OverlayModule,
                    PlatformModule
                ],
                providers: [
                    DropdownService
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiDropDownModule, { declarations: function () { return [NmDropDownMenu, NmDropDownDirective, NmDropDownItemDirective, NmDropDownWrapDirective]; }, imports: function () { return [CommonModule,
        OverlayModule,
        PlatformModule]; }, exports: function () { return [NmDropDownMenu, NmDropDownDirective, NmDropDownItemDirective, NmDropDownWrapDirective, OverlayModule,
        PlatformModule]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmSwitch, [{
        type: Component,
        args: [{
                selector: 'nm-switch',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => NmSwitch_1),
                        multi: true
                    }
                ],
                template: `
    <button
      type="button"
      class="switch"
      #switchElement
      [disabled]="disabled"
      [class.switch-checked]="isChecked"
      [class.brightness-less]="isDark"
      [class.switch-type__success]="type === 'success'"
      [class.switch-disabled]="disabled"
    >
      <span class="switch-inner">
        
          <span class="left-item"><ng-container>{{ checkedChildren }}</ng-container></span>
              <div class="switcher">
                <svg class="switcher-icon icon__success" width="13" height="9" viewBox="0 0 13 9" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.04102 4.76471L1.96744 5.77677C3.34735 7.28423 4.0373 8.03796 4.91794 8.03796C5.79857 8.03796 6.48853 7.28423 7.86844 5.77677L12.241 1"
                    stroke="#40DA9D" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg class="switcher-icon icon__false" width="16" height="16" viewBox="0 0 16 16" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M12.6549 3.34483C12.8453 3.53527 12.8453 3.84404 12.6549 4.03448L4.03426 12.6551C3.84382 12.8456 3.53505 12.8456 3.34461 12.6551C3.15417 12.4647 3.15417 12.1559 3.34461 11.9655L11.9652 3.34483C12.1557 3.15438 12.4644 3.15438 12.6549 3.34483Z"
                        fill="#FF4E4E"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M12.6549 12.6554C12.4645 12.8458 12.1557 12.8458 11.9653 12.6554L3.34466 4.03472C3.15421 3.84428 3.15421 3.53551 3.34466 3.34507C3.5351 3.15463 3.84386 3.15463 4.03431 3.34507L12.6549 11.9657C12.8454 12.1562 12.8454 12.4649 12.6549 12.6554Z"
                        fill="#FF4E4E"/>
                </svg>
              </div>
          <span class="right-item"><ng-container>{{ unCheckedChildren }}</ng-container></span>
      </span>
    </button>
  `,
                host: {
                    '(click)': 'onHostClick($event)'
                }
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], control: [{
            type: Input
        }], isDark: [{
            type: Input
        }], type: [{
            type: Input
        }], checkedChildren: [{
            type: Input
        }], unCheckedChildren: [{
            type: Input
        }], switchElement: [{
            type: ViewChild,
            args: ['switchElement', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiSwitchModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmSwitch
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    NmSwitch
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiSwitchModule, { declarations: function () { return [NmSwitch]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NmSwitch]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabActiveService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTabItem, [{
        type: Component,
        args: [{
                selector: 'nm-tab-item',
                template: `
    <div [hidden]="!_active" class="tab__content">
      <ng-template>
        <ng-content></ng-content>
      </ng-template>
    </div>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: TabActiveService }]; }, { isCloseable: [{
            type: Input
        }], action: [{
            type: Output
        }], active: [{
            type: Input
        }], templateRef: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }], title: [{
            type: Input,
            args: ['tabTitle']
        }], dataContext: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTabActiveItemDirective, [{
        type: Directive,
        args: [{
                selector: 'nm-tabs-active-bar, [nm-tabs-active-bar]',
                host: {
                    class: 'tabs-active-bar'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTabsGroup, [{
        type: Component,
        args: [{
                selector: 'nm-tabs-group',
                template: `
    <div class="tabs__wrapper">
      <ul class="tabs__panel">
        <li #tabElement class="tab__item" *ngFor="let tab of tabs" (click)="selectTab(tab, tabElement)" [class.active]="tab._active">
          <a>
            <ng-container [ngTemplateOutlet]="tab.templateRef"></ng-container>
          </a>
        </li>
        <div #slideTab nm-tabs-active-bar></div>
      </ul>
    </div>
    <ng-content></ng-content>
  `
            }]
    }], function () { return [{ type: TabActiveService }]; }, { tabChange: [{
            type: Output
        }], tabActive: [{
            type: ViewChild,
            args: [NmTabActiveItemDirective]
        }], slideTab: [{
            type: ViewChild,
            args: ['slideTab']
        }], tabElements: [{
            type: ViewChildren,
            args: ['tabElement']
        }], tabs: [{
            type: ContentChildren,
            args: [NmTabItem]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTabsContent, [{
        type: Component,
        args: [{
                selector: 'nm-tabs-content',
                template: `
    <div #swipezone>
      <ng-content></ng-content>
    </div>
  `
            }]
    }], function () { return []; }, { changeSwipe: [{
            type: Output
        }], swipezone: [{
            type: ViewChild,
            args: ['swipezone']
        }], tabGroup: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiTabsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmTabsGroup,
                    NmTabItem,
                    NmTabsContent,
                    NmTabActiveItemDirective
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    NmTabsGroup,
                    NmTabItem,
                    NmTabsContent,
                    NmTabActiveItemDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiTabsModule, { declarations: function () { return [NmTabsGroup, NmTabItem, NmTabsContent, NmTabActiveItemDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NmTabsGroup, NmTabItem, NmTabsContent, NmTabActiveItemDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmBaseInputDirective, [{
        type: Directive,
        args: [{
                selector: 'input[nm-input],textarea[nm-input]',
                host: {
                    '[class.base-input]': 'true',
                    '[class.nm-input-disabled]': 'disabled',
                    '[attr.disabled]': 'disabled || null',
                    '[class.size-lg]': `size === 'large'`,
                    '[class.size-md]': `size === 'medium'`,
                    '[class.size-sm]': `size === 'small'`
                }
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }, { type: ɵngcc0.ElementRef }]; }, { size: [{
            type: Input
        }], autofocus: [{
            type: Input
        }], disabled: [{
            type: Input
        }], keyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmInputDirective, [{
        type: Directive,
        args: [{
                selector: 'input[nm-input],textarea[nm-input]',
                host: {
                    '[class.nm-input]': 'true'
                }
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmFilledInputDirective, [{
        type: Directive,
        args: [{
                selector: 'input[nm-input-filled],textarea[nm-input-filled]',
                host: {
                    '[class.nm-input-filled]': 'true'
                }
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmOptionComponent, [{
        type: Component,
        args: [{
                selector: 'nm-option',
                exportAs: 'posOption',
                host: {
                    '[class.option__panel]': 'true'
                },
                template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { label: [{
            type: Input
        }], value: [{
            type: Input
        }], isNotSelectable: [{
            type: Input
        }], action: [{
            type: Output
        }], template: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmSelectSearchComponent, [{
        type: Component,
        args: [{
                selector: 'nm-select-search',
                template: `
    <input type="text"
           #inputElement
           autocomplete="off"
           [ngModel]="value"
           [attr.autofocus]="autofocus ? 'autofocus' : null"
           [disabled]="disabled"
           [style.opacity]="showInput ? null : 0"
           (ngModelChange)="onValueChange($event)"
           class="search-input"
    >
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { disabled: [{
            type: Input
        }], showInput: [{
            type: Input
        }], focusTrigger: [{
            type: Input
        }], value: [{
            type: Input
        }], autofocus: [{
            type: Input
        }], valueChange: [{
            type: Output
        }], inputElement: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmOptionWrap, [{
        type: Component,
        args: [{
                selector: 'nm-option-wrap',
                template: `
    <ng-template>
      <div class="select__body"
           [class.table-select__option-wrap]="tableSelect">
        <ng-content></ng-content>
      </div>
    </ng-template>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ViewContainerRef }]; }, { tableSelect: [{
            type: Input
        }], templateRef: [{
            type: ViewChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmSelectComponent, [{
        type: Component,
        args: [{
                selector: 'nm-select',
                host: {
                    '[class.select__panel]': 'true',
                    '[class.disabled]': 'disabled || null',
                    '[attr.disabled]': 'disabled || null'
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => NmSelectComponent_1),
                        multi: true
                    }
                ],
                template: `
    <div class="nm-hidden">
      <input type="text" [autofocus]="true" #hiddenInput aria-expanded="true">
    </div>
    <div class="select__header select-width input-group" (click)="setOpenState(!isOpen, $event)"
         [class.dropdown-visible]="isOpen"
         [class.table-select]="tableSelect"
         [class.size-lg]="size === 'large'"
         [class.size-md]="size === 'medium'"
         [class.size-sm]="size === 'small'">
      <div class="select__item" *ngIf="isShowPlaceholder" style="opacity: 0.4">
        {{placeholder}}
      </div>

      <div class="select__item" *ngIf="isShowLabel"
           [style.opacity]="isSearch && isOpen ? 0.4 : 1">
        <div *ngIf="selectedOption?.value">
          {{selectedOption?.label}}
        </div>
      </div>

      <div *ngIf="!isSearch" class="select-width">
      </div>

      <div *ngIf="isSearch" class="select-width">
        <nm-select-search [disabled]="disabled"
                          [value]="selectedOption?.label"
                          [showInput]="isOpen && isSearch"
                          [focusTrigger]="isOpen"
                          (valueChange)="onInputValueChange($event)"></nm-select-search>
      </div>

      <span *ngIf="showArrow" class="affix__panel input-group-suffix dropdown-arrow-item">
       <i>
         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M2.31319 4.98043C2.50846 4.78517 2.82504 4.78517 3.0203 4.98043L8.00008 9.96021L12.9799 4.98043C13.1751 4.78517 13.4917 4.78517 13.687 4.98043C13.8822 5.17569 13.8822 5.49228 13.687 5.68754L8.35363 11.0209C8.15837 11.2161 7.84179 11.2161 7.64653 11.0209L2.31319 5.68754C2.11793 5.49228 2.11793 5.17569 2.31319 4.98043Z"
                fill="#22242C"/>
          </svg>
       </i>
      </span>
    </div>
    <nm-option-wrap [tableSelect]="tableSelect">
      <div class="option__panel-item"
           *ngFor="let item of listOfItems; trackBy: trackValue"
           (click)="onItemClick(item)"
           [class.option__active]="selectedOption?.value === item.value">
        <ng-template [ngTemplateOutlet]="item.template"></ng-template>
      </div>
    </nm-option-wrap>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc2.Overlay }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc3.Platform }]; }, { isOpen: [{
            type: Input
        }], size: [{
            type: Input
        }], disabled: [{
            type: Input
        }], isSearch: [{
            type: Input
        }], tableSelect: [{
            type: Input
        }], onOpenChange: [{
            type: Output
        }], validateStatus: [{
            type: Input
        }], keyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], placeholder: [{
            type: Input
        }], optionWrap: [{
            type: ViewChild,
            args: [NmOptionWrap]
        }], hiddenInput: [{
            type: ViewChild,
            args: ['hiddenInput']
        }], listNmOptionComponent: [{
            type: ContentChildren,
            args: [NmOptionComponent, { descendants: true }]
        }], selectSearchComponent: [{
            type: ViewChild,
            args: [NmSelectSearchComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmFormItemComponent, [{
        type: Component,
        args: [{
                selector: 'nm-form-item',
                changeDetection: ChangeDetectionStrategy.OnPush,
                exportAs: 'nmFormItem',
                host: {
                    '[class.form-item]': 'true',
                    '[class.form-item-success]': 'status === "success"',
                    '[class.form-item-error]': 'status === "error"',
                    '[class.form-item-alert]': 'alertTip',
                    '[attr.disabled]': 'disabled || null',
                    '[class.form-item--small]': 'size === "small"',
                    '[class.form-item--medium]': 'size === "medium"',
                    '[class.form-item--large]': 'size === "large"',
                    '(click)': 'onItemClick($event)'
                },
                template: `
    <div *ngIf="label" class="label__panel">
      <label><span *ngIf="required" class="color__red">*</span> {{label}}</label>
    </div>
    <div class="form-item__control"
         [class.form-item__control-filled]="color === 'filled'"
         [class.form-item__control-disabled]="disabled">
      <span *ngIf="prefix" class="affix__panel input-group-prefix">
        <ng-template [ngTemplateOutlet]="prefix"></ng-template>
      </span>
      <ng-content></ng-content>

      <span class="affix__panel input-group-suffix" *ngIf="suffix && (status !=='error') && !isShowSuccessIcon">
        <ng-template [ngTemplateOutlet]="suffix"></ng-template>
      </span>

      <span class="affix__panel input-group-suffix" *ngIf="isShowSuccessIcon && (makeSuccess || (iconType === 'icon__success'))">
        <svg class="icon__success" width="20" height="20" viewBox="0 0 13 9"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.04102 4.76471L1.96744 5.77677C3.34735 7.28423 4.0373 8.03796 4.91794 8.03796C5.79857 8.03796 6.48853 7.28423 7.86844 5.77677L12.241 1"
          stroke="#40DA9D" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>

      <span class="affix__panel input-group-suffix" *ngIf="iconType === 'icon__false'">
        <svg class="icon__false" width="20" height="20" viewBox="0 0 16 16" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.44211 14.4772C2.00951 15.0957 2.82101 15.3597 3.85463 15.486C4.87938 15.6112 6.22855 15.6112 7.96344 15.6112H8.00022H8.037C9.77188 15.6112 11.1211 15.6112 12.1458 15.486C13.1794 15.3597 13.9909 15.0957 14.5583 14.4772C14.865 14.1428 15.1038 13.752 15.2614 13.3265C15.5528 12.5394 15.4175 11.6968 15.0582 10.7195C14.702 9.75049 14.0863 8.54996 13.2946 7.00623L13.2779 6.97352L13.2606 6.93991C12.3368 5.13838 11.6219 3.74428 10.9609 2.7673C10.2991 1.78909 9.61986 1.11694 8.72296 0.927649C8.24638 0.827068 7.75405 0.827068 7.27747 0.927649C6.38057 1.11694 5.70134 1.78909 5.03954 2.7673C4.37857 3.74428 3.66365 5.13839 2.73979 6.93994L2.72257 6.97352L2.70579 7.00623C1.91413 8.54997 1.29847 9.75049 0.942264 10.7195C0.582976 11.6968 0.447596 12.5394 0.739051 13.3265C0.896604 13.752 1.13539 14.1428 1.44211 14.4772Z"
            stroke="#FF4E4E"/>
          <path
            d="M7.55566 4.85703C7.55566 4.62911 7.75465 4.44434 8.00011 4.44434C8.24557 4.44434 8.44455 4.62911 8.44455 4.85703V9.80942C8.44455 10.0373 8.24557 10.2221 8.00011 10.2221C7.75465 10.2221 7.55566 10.0373 7.55566 9.80942V4.85703Z"
            fill="#FF4E4E"/>
          <path
            d="M8.88911 12.0002C8.88911 12.4911 8.49114 12.8891 8.00022 12.8891C7.5093 12.8891 7.11133 12.4911 7.11133 12.0002C7.11133 11.5093 7.5093 11.1113 8.00022 11.1113C8.49114 11.1113 8.88911 11.5093 8.88911 12.0002Z"
            fill="#FF4E4E"/>
        </svg>
      </span>

    </div>
    <div class="alert__panel" *ngIf="alertTip">{{alertTip}}</div>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, { color: [{
            type: Input
        }], size: [{
            type: Input
        }], disabled: [{
            type: Input
        }], autoFocus: [{
            type: Input
        }], required: [{
            type: Input
        }], isShowSuccessIcon: [{
            type: Input
        }], makeSuccess: [{
            type: Input
        }], validateStatus: [{
            type: Input
        }], suffix: [{
            type: Input
        }], prefix: [{
            type: Input
        }], alertSuccess: [{
            type: Input
        }], alertError: [{
            type: Input
        }], label: [{
            type: Input
        }], defaultValidateControl: [{
            type: ContentChild,
            args: [NgControl]
        }], selectComponent: [{
            type: ContentChild,
            args: [NmSelectComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmInputGroupComponent, [{
        type: Component,
        args: [{
                selector: 'nm-input-group',
                host: {
                    '[class.input-group]': 'true'
                },
                template: `
    <ng-template [ngIf]="prefix || suffix" [ngIfElse]="contentTemplate">
      <ng-template [ngTemplateOutlet]="affixTemplate"></ng-template>
    </ng-template>
    <ng-template #affixTemplate>
      <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
    </ng-template>
    <ng-template #contentTemplate>
      <ng-content></ng-content>
    </ng-template>
  `
            }]
    }], null, { prefix: [{
            type: Input
        }], suffix: [{
            type: Input
        }], formItemComponent: [{
            type: ContentChild,
            args: [NmFormItemComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmCalcInputComponent, [{
        type: Component,
        args: [{
                selector: 'nm-calc',
                host: {
                    '[class.calc__panel]': 'true',
                    '[class.calc__panel-disabled]': 'disabled || null',
                    '[class.calc__panel-filled]': 'color === "filled"',
                    '[attr.disabled]': 'disabled || null'
                },
                template: `

    <div class="counter wrapper">
      <div class="counter-form">
        <input type="text"
               name="counterValue"
               id="counterValue"
               class="counter-value-field"
               (input)="setValue()"
               maxlength="10"
               #counterField
               autofocus>
        <span class="counter__value">
            <span class="quantity_hidden" [attr.data-suffix]="suffix">{{counterField.value}}</span>
        </span>
      </div>
    </div>
  `
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }] }]; }, { suffix: [{
            type: Input
        }], disabled: [{
            type: Input
        }], counterField: [{
            type: ViewChild,
            args: ['counterField', { static: true }]
        }], color: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmCheckBoxComponent, [{
        type: Component,
        args: [{
                selector: 'nm-checkbox',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => NmCheckBoxComponent_1),
                        multi: true
                    }
                ],
                template: `
    <label class="checkbox-item"
           [class.nm-checkbox-inter]="nmIndeterminate">
      <input type="checkbox" [checked]="isChecked">
      <span class="checkmark"></span>
      <span class="checkbox-item-label">
        <ng-content></ng-content>
      </span>
    </label>
  `,
                host: {
                    '(click)': 'onHostClick($event)',
                    '[class.checkbox--disabled]': 'disabled'
                }
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], control: [{
            type: Input
        }], nmIndeterminate: [{
            type: Input
        }], checkedChange: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiFormModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmInputDirective,
                    NmBaseInputDirective,
                    NmFilledInputDirective,
                    NmInputGroupComponent,
                    NmFormItemComponent,
                    NmSelectComponent,
                    NmSelectSearchComponent,
                    NmOptionComponent,
                    NmOptionWrap,
                    NmCalcInputComponent,
                    NmCheckBoxComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule
                ],
                exports: [
                    NmInputDirective,
                    NmBaseInputDirective,
                    NmFilledInputDirective,
                    NmInputGroupComponent,
                    NmFormItemComponent,
                    NmSelectComponent,
                    NmSelectSearchComponent,
                    NmOptionComponent,
                    NmOptionWrap,
                    NmCalcInputComponent,
                    NmCheckBoxComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiFormModule, { declarations: function () { return [NmInputDirective, NmBaseInputDirective, NmFilledInputDirective, NmInputGroupComponent, NmFormItemComponent, NmSelectComponent, NmSelectSearchComponent, NmOptionComponent, NmOptionWrap, NmCalcInputComponent, NmCheckBoxComponent]; }, imports: function () { return [CommonModule,
        FormsModule]; }, exports: function () { return [NmInputDirective, NmBaseInputDirective, NmFilledInputDirective, NmInputGroupComponent, NmFormItemComponent, NmSelectComponent, NmSelectSearchComponent, NmOptionComponent, NmOptionWrap, NmCalcInputComponent, NmCheckBoxComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmPinCodeComponent, [{
        type: Component,
        args: [{
                selector: 'nm-pin-code',
                host: {
                    'class': 'pin-code__panel'
                },
                template: `
    <div class="section section-pinpad" #pinpadSection>
      <div class="d-flex direction-column align-center align-middle">
        <h3 class="h3 pin__title">Введите PIN-код для входа:</h3>
        <div class="d-flex justify-center pin__wrapper">
          <ng-container *ngFor="let pinDot of pin; index as index">
            <span class="pin__dot" [class.pin__dot_filled]="index + 1 <= pinValue.length"></span>
          </ng-container>
        </div>
        <div class="pinpad__wrapper d-flex">
          <ng-container *ngFor="let padValue of padValues">
            <button *ngIf="padValue !== undefined" nm-button [color]='buttonColor' size='large' (click)="editPinValue(padValue)">
              {{padValue}}
            </button>
            <button *ngIf="padValue === undefined" nm-button color='transparent' size='large' (click)="editPinValue(padValue)">
              <nm-svg-loader [iconName]="icons.eraseMiddleDarkGray"></nm-svg-loader>
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  `
            }]
    }], function () { return []; }, { pin: [{
            type: Input
        }], enableBgError: [{
            type: Input
        }], buttonColor: [{
            type: Input
        }], resultChange: [{
            type: Output
        }], pinpadSection: [{
            type: ViewChild,
            args: ['pinpadSection', { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconLoaderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: IconLoaderConfig, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IconLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'nm-svg-loader',
                template: `
    <svg xmlns="http://www.w3.org/2000/svg" class="icon-content">
      <use class="ic" [attr.xlink:href]="src"></use>
    </svg>
  `,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    '[class.icon-item]': 'true'
                }
            }]
    }], function () { return [{ type: IconLoaderService }]; }, { iconName: [{
            type: Input
        }], src: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiIconSpriteModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    IconLoaderComponent
                ],
                exports: [IconLoaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiIconSpriteModule, { declarations: function () { return [IconLoaderComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [IconLoaderComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiPinCodeModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmPinCodeComponent
                ],
                imports: [
                    CommonModule,
                    NomiaUiButtonModule,
                    NomiaUiIconSpriteModule
                ],
                exports: [
                    NmPinCodeComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiPinCodeModule, { declarations: function () { return [NmPinCodeComponent]; }, imports: function () { return [CommonModule, NomiaUiButtonModule, NomiaUiIconSpriteModule]; }, exports: function () { return [NmPinCodeComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTableContentComponent, [{
        type: Component,
        args: [{
                selector: 'table[nm-table-content]',
                template: `
    <thead class="nm-table-thead" *ngIf="theadTemplate">
      <ng-template [ngTemplateOutlet]="theadTemplate"></ng-template>
    </thead>
    <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
    <ng-content></ng-content>
  `,
                host: {
                    '[style.table-layout]': 'tableLayout'
                }
            }]
    }], function () { return []; }, { tableLayout: [{
            type: Input
        }], theadTemplate: [{
            type: Input
        }], contentTemplate: [{
            type: Input
        }], listOfColWidth: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTableInnerComponent, [{
        type: Component,
        args: [{
                selector: 'nm-table-inner',
                template: `
    <div class="nm-table-content">
      <table
        nm-table-content
        [theadTemplate]="theadTemplate"
        [contentTemplate]="contentTemplate"
      ></table>
    </div>
  `,
                host: {
                    '[class.nm-table-container]': 'true'
                }
            }]
    }], function () { return []; }, { theadTemplate: [{
            type: Input
        }], contentTemplate: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTableInnerScrollComponent, [{
        type: Component,
        args: [{
                selector: 'nm-table-inner-scroll',
                template: `
    <div class="nm-table-content">
      <div *ngIf="scrollY" #tableHeaderElement class="nm-table-hide-scrollbar">
        <table
          nm-table-content
          tableLayout="fixed"
          [listOfColWidth]="listOfColWidth"
          [theadTemplate]="theadTemplate"
        ></table>
      </div>
      <div #tableBodyElement *ngIf="!virtualTemplate" class="nm-table-body" >
        <table
          nm-table-content
          tableLayout="fixed"
          [listOfColWidth]="listOfColWidth"
          [theadTemplate]="scrollY ? null : theadTemplate"
          [contentTemplate]="contentTemplate"
        ></table>
      </div>
      <div
        #tableBodyElement
        *ngIf="virtualTemplate"
        [style.height]="scrollY"
        style="overflow-y: auto"
        class="table__scroll-item"
      >
        <table nm-table-content tableLayout="fixed"
               [listOfColWidth]="listOfColWidth"
               [contentTemplate]="contentTemplate">
        </table>
      </div>
    </div>
  `,
                host: {
                    '[class.nm-table-container]': 'true'
                }
            }]
    }], function () { return []; }, { scrollY: [{
            type: Input
        }], contentTemplate: [{
            type: Input
        }], virtualTemplate: [{
            type: Input
        }], theadTemplate: [{
            type: Input
        }], listOfColWidth: [{
            type: Input
        }], tableBodyElement: [{
            type: ViewChild,
            args: ['tableBodyElement', { read: ElementRef }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTableStyleService, [{
        type: Injectable
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTableComponent, [{
        type: Component,
        args: [{
                selector: 'nm-table',
                exportAs: 'nmTable',
                providers: [NmTableStyleService],
                template: `
    <div
      #tableMainElement
      class="nm-table"
    >
      <nm-table-inner-scroll
        *ngIf="scrollY; else defaultTemplate"
        [scrollY]="scrollY"
        [theadTemplate]="theadTemplate"
        [listOfColWidth]="listOfAutoColWidth"
        [contentTemplate]="contentTemplate"
        [virtualTemplate]="true"
      ></nm-table-inner-scroll>
      <ng-template #defaultTemplate>
        <nm-table-inner [theadTemplate]="theadTemplate"
                        [contentTemplate]="contentTemplate">
        </nm-table-inner>
      </ng-template>
    </div>
    <ng-template #contentTemplate>
      <ng-content></ng-content>
    </ng-template>
  `
            }]
    }], function () { return [{ type: NmTableStyleService }]; }, { nmScroll: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmThItemComponent, [{
        type: Component,
        args: [{
                selector: 'th',
                template: `
    <ng-template [ngTemplateOutlet]="showSort ? sortTemplate : contentTemplate"></ng-template>

    <ng-template #sortTemplate>
      <nm-table-sorters [sortOrder]="sortOrder" [sortDirections]="sortDirections" [contentTemplate]="contentTemplate"></nm-table-sorters>
    </ng-template>
    <ng-template #contentTemplate>
      <ng-content></ng-content>
    </ng-template>
  `,
                host: {
                    '[class.nm-table-column-has-sorters]': 'showSort',
                    '[class.nm-table-column-sort]': `sortOrder === 'desc' || sortOrder === 'asc'`,
                    '(click)': 'emitNextSortValue()'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { nmSortOrder: [{
            type: Input
        }], nmSortDirections: [{
            type: Input
        }], showSort: [{
            type: Input
        }], nmSortChange: [{
            type: Output
        }], columnKey: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTheadComponent, [{
        type: Component,
        args: [{
                selector: 'thead:not(.nm-table-thead)',
                template: `
    <ng-template #contentTemplate>
      <ng-content></ng-content>
    </ng-template>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: NmTableStyleService, decorators: [{
                type: Optional
            }] }]; }, { nmSortChange: [{
            type: Output
        }], templateRef: [{
            type: ViewChild,
            args: ['contentTemplate', { static: true }]
        }], listOfThItem: [{
            type: ContentChildren,
            args: [NmThItemComponent, { descendants: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTbodyComponent, [{
        type: Component,
        args: [{
                selector: 'tbody',
                template: `
    <ng-content></ng-content>
  `,
                host: {
                    '[class.nm-table-tbody]': 'true'
                }
            }]
    }], function () { return [{ type: NmTableStyleService, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTrDirective, [{
        type: Directive,
        args: [{
                selector: 'tr:not([nm-table-fixed-row])',
                host: {
                    '[class.nm-table-row]': 'isInsideTable'
                }
            }]
    }], function () { return [{ type: NmTableStyleService, decorators: [{
                type: Optional
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTableSortersComponent, [{
        type: Component,
        args: [{
                selector: 'nm-table-sorters',
                template: `
    <span><ng-template [ngTemplateOutlet]="contentTemplate"></ng-template></span>
    <span class="nm-table-column-sorter" [class.nm-table-column-sorter-full]="isDown && isUp">
      <span class="nm-table-column-sorter-inner">
        <nm-svg-loader [iconName]="icons.arrowDownMiddleDarkGray" *ngIf="isUp" class="nm-table-column-sorter-up"
                       [class.active]="sortOrder == 'asc'"></nm-svg-loader>
        <nm-svg-loader [iconName]="icons.arrowDownMiddleDarkGray" *ngIf="isDown" class="nm-table-column-sorter-down"
                       [class.active]="sortOrder == 'desc'"></nm-svg-loader>
      </span>
    </span>
  `,
                host: {
                    '[class.nm-table-column-sorters]': 'true'
                }
            }]
    }], function () { return []; }, { sortDirections: [{
            type: Input
        }], sortOrder: [{
            type: Input
        }], contentTemplate: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmCellEditorComponent, [{
        type: Component,
        args: [{
                selector: 'nm-cell-editor',
                exportAs: 'nmCellEditor',
                template: `
    <ng-container *ngIf="editing">
      <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
    </ng-container>
    <ng-container *ngIf="!editing">
      <ng-container *ngTemplateOutlet="outPutTemplate"></ng-container>
    </ng-container>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { inputTemplate: [{
            type: Input
        }], outPutTemplate: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTdEditorComponent, [{
        type: Component,
        args: [{
                selector: '[tdEditable]',
                exportAs: 'tdEditable',
                template: `
    <ng-content #contentComponent></ng-content>
  `,
                host: {
                    'class': 'td-editable'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], keyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], contentComponent: [{
            type: ContentChild,
            args: [NmCellEditorComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmCellWidthDirective, [{
        type: Directive,
        args: [{
                selector: '[cellWidth]',
                host: {
                    '[style.width.px]': 'cellWidth',
                    '[style.min-width.px]': 'cellWidth'
                }
            }]
    }], null, { cellWidth: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClickOutsideDirective, [{
        type: Injectable
    }, {
        type: Directive,
        args: [{ selector: '[clickOutside]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { clickOutsideEnabled: [{
            type: Input
        }], attachOutsideOnClick: [{
            type: Input
        }], delayClickOutsideInit: [{
            type: Input
        }], emitOnBlur: [{
            type: Input
        }], exclude: [{
            type: Input
        }], excludeBeforeClick: [{
            type: Input
        }], clickOutsideEvents: [{
            type: Input
        }], clickOutside: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiDirectivesModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ClickOutsideDirective
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    ClickOutsideDirective
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiDirectivesModule, { declarations: function () { return [ClickOutsideDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ClickOutsideDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiTableModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmTableComponent,
                    NmTableInnerComponent,
                    NmTableInnerScrollComponent,
                    NmTableContentComponent,
                    NmTheadComponent,
                    NmTrDirective,
                    NmCellWidthDirective,
                    NmTbodyComponent,
                    NmThItemComponent,
                    NmTableSortersComponent,
                    NmCellEditorComponent,
                    NmTdEditorComponent
                ],
                imports: [
                    CommonModule,
                    NomiaUiIconSpriteModule,
                    NomiaUiDirectivesModule
                ],
                exports: [
                    NmTableComponent,
                    NmTableInnerComponent,
                    NmTableInnerScrollComponent,
                    NmTableContentComponent,
                    NmTheadComponent,
                    NmTrDirective,
                    NmCellWidthDirective,
                    NmTbodyComponent,
                    NmThItemComponent,
                    NmTableSortersComponent,
                    NmCellEditorComponent,
                    NmTdEditorComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiTableModule, { declarations: function () { return [NmTableComponent, NmTableInnerComponent, NmTableInnerScrollComponent, NmTableContentComponent, NmTheadComponent, NmTrDirective, NmCellWidthDirective, NmTbodyComponent, NmThItemComponent, NmTableSortersComponent, NmCellEditorComponent, NmTdEditorComponent]; }, imports: function () { return [CommonModule, NomiaUiIconSpriteModule, NomiaUiDirectivesModule]; }, exports: function () { return [NmTableComponent, NmTableInnerComponent, NmTableInnerScrollComponent, NmTableContentComponent, NmTheadComponent, NmTrDirective, NmCellWidthDirective, NmTbodyComponent, NmThItemComponent, NmTableSortersComponent, NmCellEditorComponent, NmTdEditorComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CustomCurrencyPipe, [{
        type: Pipe,
        args: [{
                name: 'customCurrency'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NoCommasPipe, [{
        type: Pipe,
        args: [{
                name: 'noCommas'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiPipeModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NoCommasPipe,
                    CustomCurrencyPipe
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    NoCommasPipe,
                    CustomCurrencyPipe
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiPipeModule, { declarations: function () { return [NoCommasPipe, CustomCurrencyPipe]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NoCommasPipe, CustomCurrencyPipe]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopularItemComponent, [{
        type: Component,
        args: [{
                selector: 'nm-popular-item',
                template: "<div class=\"popular-item d-flex align-middle\">\n  <span class=\"popular-item__index d-flex align-middle justify-center small-medium\">{{index}}</span>\n  <div class=\"chart-block__wrapper d-flex direction-column\">\n    <div class=\"d-flex align-middle justify-space-between\">\n      <span class=\"small-medium\">{{item.name}}</span>\n      <span class=\"small-medium\">{{item.quantity}}</span>\n    </div>\n    <div class=\"chart__wrapper\">\n            <span class=\"chart__line chart__line_income\" [style.width]=\"incomeWidth\">\n                <span class=\"chart__line chart__line_margin\" [class]=\"stake\" [style.width]=\"marginWidth\"></span>\n            </span>\n    </div>\n    <div class=\"d-flex align-middle justify-space-between\">\n            <span class=\"small-medium chart__complex-data\" [class]=\"stake\">{{percents}} -\n                {{item.profit | noCommas}}\n                {{item.currency | customCurrency}}</span>\n      <span class=\"small-medium\">{{(item.revenue / item.quantity) | noCommas}} {{item.currency | customCurrency}}</span>\n    </div>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }], index: [{
            type: Input
        }], maxValue: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiPopularItemModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    PopularItemComponent
                ],
                imports: [
                    CommonModule,
                    NomiaUiPipeModule
                ],
                exports: [
                    PopularItemComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiPopularItemModule, { declarations: function () { return [PopularItemComponent]; }, imports: function () { return [CommonModule, NomiaUiPipeModule]; }, exports: function () { return [PopularItemComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'nm-wrapper',
                template: "<div class=\"dashboard-card d-flex direction-column\" [class.dashboard-card_mini]=\"miniCard\">\n\n  <div class=\"dashboard-card__header d-flex align-middle justify-space-between\">\n    <div class=\"d-flex direction-column\">\n      <h2 class=\"h2 dashboard-card__title\">{{cardTitle}}</h2>\n      <span class=\"normal-reg\" *ngIf=\"cardSubtitle\">{{cardSubtitle}}</span>\n    </div>\n    <ng-content select=\"[dashboard-card-header]\" *ngIf=\"!miniCard\"></ng-content>\n    <span class=\"calc-small mini-card__optional-value\" *ngIf=\"optionalValue\">{{optionalValue}}</span>\n    <div class=\"mini-card__icon\" *ngIf=\"miniCard\">\n      <ng-content select=\"[dashboard-card-header-icon]\"></ng-content>\n      <!--<img class=\"mini-card__icon\" *ngIf=\"miniCardIcon\" [src]=\"getCardIcon()\" alt=\"Mini dashboard card icon\">-->\n    </div>\n  </div>\n\n  <ng-content select=\"[dashboard-card-body]\" *ngIf=\"empty !== true; else stub\"></ng-content>\n\n  <ng-template #stub>\n    <nm-no-data-stub [media]=\"true\"></nm-no-data-stub>\n  </ng-template>\n\n</div>\n"
            }]
    }], function () { return []; }, { cardTitle: [{
            type: Input
        }], cardSubtitle: [{
            type: Input
        }], miniCard: [{
            type: Input
        }], miniCardIcon: [{
            type: Input
        }], optionalValue: [{
            type: Input
        }], empty: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmNoDataStubComponent, [{
        type: Component,
        args: [{
                selector: 'nm-no-data-stub',
                template: "<div class=\"stub d-flex direction-column align-middle justify-center\" *ngIf=\"media === true; else emptyStub\">\n    <nm-svg-loader [iconName]=\"icons.historyBigGray\" class=\"stub__icon\"></nm-svg-loader>\n    <span class=\"stub__message big-reg secondary-text\">\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F</span>\n</div>\n<ng-template #emptyStub>\n    <div class=\"stub d-flex stub_empty\"></div>\n</ng-template>\n"
            }]
    }], function () { return []; }, { media: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiWrapperModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmWrapperComponent,
                    NmNoDataStubComponent
                ],
                imports: [
                    CommonModule,
                    NomiaUiPipeModule,
                    NomiaUiIconSpriteModule
                ],
                exports: [
                    NmWrapperComponent,
                    NmNoDataStubComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiWrapperModule, { declarations: function () { return [NmWrapperComponent, NmNoDataStubComponent]; }, imports: function () { return [CommonModule, NomiaUiPipeModule, NomiaUiIconSpriteModule]; }, exports: function () { return [NmWrapperComponent, NmNoDataStubComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseModalComponent, [{
        type: Component,
        args: [{
                selector: 'nm-base-modal',
                template: '<div></div>'
            }]
    }], function () { return []; }, { classNameField: [{
            type: HostBinding,
            args: ['class.modal-box__popup']
        }], closeModal: [{
            type: Output
        }], data: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmModalWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'nm-modal-wrap',
                template: "<div class=\"modal-box__header\">\n  <h3 class=\"modal-box__title bold\">{{modalTitle}}</h3>\n  <button class=\"modal-box__close-button button\" type=\"button\" (click)=\"close()\">\n                <span class=\"button__icon icon icon--baseline\">\n                    <svg class=\"icon__svg icon__svg--times\" viewBox=\"0 0 128 128\">\n                        <path\n                          d=\"M76.518,64.002L114.338,26.182L122.137,18.382C123.288,17.232 123.288,15.362 122.137,14.212L113.792,5.867C112.641,4.716 110.772,4.716 109.621,5.867L64.002,51.486L18.382,5.863C17.232,4.712 15.362,4.712 14.212,5.863L5.863,14.208C4.712,15.359 4.712,17.228 5.863,18.379L51.486,64.002L5.863,109.621C4.712,110.772 4.712,112.641 5.863,113.792L14.208,122.137C15.359,123.288 17.228,123.288 18.379,122.137L64.002,76.518L109.621,122.137C110.772,123.288 112.641,123.288 113.792,122.137L122.137,113.792C123.288,112.641 123.288,110.772 122.137,109.621L76.518,64.002Z\"\n                          style=\"fill-rule:nonzero;\"/>\n                    </svg>\n                </span>\n  </button>\n</div>\n<div class=\"modal-box__container modal-box__container--content\">\n  <ng-content select=\"[modal-body]\"></ng-content>\n</div>\n<div class=\"modal-box__control-bar\">\n  <ng-content select=\"[modal-footer]\"></ng-content>\n</div>\n",
                host: {
                    '[class.w-full]': 'true',
                    '[class.d-flex]': 'true',
                    '[class.direction-column]': 'true',
                    '[class.scroll-auto]': 'true'
                }
            }]
    }], function () { return []; }, { closeModal: [{
            type: Output
        }], modalTitle: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalContentDirective, [{
        type: Directive,
        args: [{
                selector: '[appModalContent]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OverlayComponent, [{
        type: Component,
        args: [{ selector: 'nm-overlay', template: "<div class=\"overlay\"></div>\n<ng-template appModalContent></ng-template>\n", styles: [":host{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:center;left:0;position:fixed;top:0;width:100%;z-index:9999;background:rgba(0,0,0,.7)}"] }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc5.Router }]; }, { classModalBoxField: [{
            type: HostBinding,
            args: ['class.modal-box']
        }], onOverlayClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], contentContainer: [{
            type: ViewChild,
            args: [ModalContentDirective, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DomService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ApplicationRef }, { type: ɵngcc0.Injector }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DomService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiModalModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ModalContentDirective,
                    OverlayComponent,
                    BaseModalComponent,
                    NmModalWrapperComponent
                ],
                exports: [
                    ModalContentDirective,
                    OverlayComponent,
                    BaseModalComponent,
                    NmModalWrapperComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiModalModule, { declarations: function () { return [ModalContentDirective, OverlayComponent, BaseModalComponent, NmModalWrapperComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ModalContentDirective, OverlayComponent, BaseModalComponent, NmModalWrapperComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmExtendedCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'nm-extended-calendar',
                template: `
    <div class="nm-calendar">
      <div class="arrow back" (click)="goToPrevMonth()"></div>

      <div class="nm-calendar__wrapper">
        <div class="nm-calendar__month">{{months[currentMonth]}}, {{currentYear}}</div>

        <div class="nm-calendar__week-names">
          <div class="nm-calendar__weekday" *ngFor="let weekday of weekdays">
            {{weekday}}
          </div>
        </div>

        <div class="nm-calendar__days">

          <ng-template [ngIf]="localSelection === 'single'">
            <div class="nm-calendar__day" *ngFor="let item of days">
              <span [class.active]="item && (isSame(item?.fullDate, currentDay))" (click)="selectDay(item.fullDate)">
                {{item.date}}
              </span>
            </div>
          </ng-template>

          <ng-template [ngIf]="localSelection === 'range'">
            <div class="nm-calendar__day" *ngFor="let item of days"
                 [class.selected]="item.selected && state.startDate && state.endDate"
                 [class.day--first]="item && (isSame(item?.fullDate, state.startDate)) && state.endDate"
                 [class.day--last]="item && (isSame(item?.fullDate, state.endDate)) && state.startDate">


            <span (click)="selectDayRange(item.fullDate)"
                  [class.active]="item && (isSame(item?.fullDate, state.startDate) || isSame(item?.fullDate, state.endDate))">
                  {{item.date}}
              </span>
            </div>
          </ng-template>
        </div>
      </div>

      <div *ngIf="extended" class="nm-calendar__wrapper" style="margin-left: 12px">
        <div class="nm-calendar__month">{{months[currentMonthNext]}}, {{currentYearNext}}</div>

        <div class="nm-calendar__week-names">
          <div class="nm-calendar__weekday" *ngFor="let weekday of weekdays">
            {{weekday}}
          </div>
        </div>

        <div class="nm-calendar__days">

          <ng-template [ngIf]="localSelection === 'single'">
            <div class="nm-calendar__day" *ngFor="let item of daysNext">
              <span [class.active]="item && (isSame(item?.fullDate, currentDay))" (click)="selectDay(item.fullDate)">
                {{item.date}}
              </span>
            </div>
          </ng-template>

          <ng-template [ngIf]="localSelection === 'range'">
            <div class="nm-calendar__day" *ngFor="let item of daysNext"
                 [class.selected]="item.selected && state.startDate && state.endDate"
                 [class.day--first]="item && (isSame(item?.fullDate, state.startDate)) && state.endDate"
                 [class.day--last]="item && (isSame(item?.fullDate, state.endDate)) && state.startDate">
              <span (click)="selectDayRange(item.fullDate)"
                    [class.active]="item && (isSame(item?.fullDate, state.startDate) || isSame(item?.fullDate, state.endDate))">
                   {{item.date}}
              </span>
            </div>

          </ng-template>

        </div>
      </div>

      <div class="arrow next" (click)="goToNextMonth()"></div>
    </div>
  `,
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'calendar',
                    '[class.calendar-size__large]': 'size === "large"'
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], extended: [{
            type: Input
        }], size: [{
            type: Input
        }], changeDate: [{
            type: Output
        }], selection: [{
            type: Input
        }], dateValue: [{
            type: Input
        }], startDateValue: [{
            type: Input
        }], endDateValue: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'nm-calendar',
                template: `
    <div class="nm-calendar">
      <nm-extended-calendar *ngIf="extended"
                            [disabled]="disabled"
                            [extended]="extended"
                            [selection]="selection"
                            [dateValue]="currentDay"
                            [startDateValue]="startDate"
                            [endDateValue]="endDate"
                            [size]="size"
                            #singleCalendar
                            (changeDate)="onChangeDate($event)"></nm-extended-calendar>

      <nm-single-calendar *ngIf="!extended"
                            [disabled]="disabled"
                            [selection]="selection"
                            [dateValue]="currentDay"
                            [startDateValue]="startDate"
                            [endDateValue]="endDate"
                            [size]="size"
                            #singleCalendar
                            (changeDate)="onChangeDate($event)"></nm-single-calendar>
    </div>
  `,
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'calendar'
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], extended: [{
            type: Input
        }], selection: [{
            type: Input
        }], showOldCalendar: [{
            type: Input
        }], size: [{
            type: Input
        }], changeDate: [{
            type: Output
        }], dateValue: [{
            type: Input
        }], startDateValue: [{
            type: Input
        }], endDateValue: [{
            type: Input
        }], singleCalendar: [{
            type: ViewChild,
            args: ['singleCalendar']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmSingleCalendarComponent, [{
        type: Component,
        args: [{
                selector: 'nm-single-calendar',
                template: `
    <div class="nm-calendar">
      <div class="arrow back" (click)="goToPrevMonth()"></div>

      <div class="nm-calendar__wrapper">
        <div class="nm-calendar__month">{{months[currentMonth]}}, {{currentYear}}</div>

        <div class="nm-calendar__week-names">
          <div class="nm-calendar__weekday" *ngFor="let weekday of weekdays">
            {{weekday}}
          </div>
        </div>

        <div class="nm-calendar__days">
          <ng-template [ngIf]="localSelection === 'single'">
            <div class="nm-calendar__day" *ngFor="let item of days">
              <span [class.active]="item && (isSame(item?.fullDate, currentDay))" (click)="selectDay(item.fullDate)">
                {{item.date}}
              </span>
            </div>
          </ng-template>

          <ng-template [ngIf]="localSelection === 'range'">
            <div class="nm-calendar__day" *ngFor="let item of days"
                 [class.selected]="item.selected && state.startDate && state.endDate"
                 [class.day--first]="item && (isSame(item?.fullDate, state.startDate)) && state.endDate"
                 [class.day--last]="item && (isSame(item?.fullDate, state.endDate)) && state.startDate">


            <span (click)="selectDayRange(item.fullDate)"
                  [class.active]="item && (isSame(item?.fullDate, state.startDate) || isSame(item?.fullDate, state.endDate))">
                  {{item.date}}
              </span>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="arrow next" (click)="goToNextMonth()"></div>
    </div>
  `,
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'calendar',
                    '[class.calendar-size__large]': 'size === "large"'
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], size: [{
            type: Input
        }], changeDate: [{
            type: Output
        }], selection: [{
            type: Input
        }], dateValue: [{
            type: Input
        }], startDateValue: [{
            type: Input
        }], endDateValue: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmInputCalendar, [{
        type: Component,
        args: [{
                selector: 'nm-input-calendar',
                template: `
    <input type="text"
           class="base-input"
           [class.nm-input-disabled]="disabled"
           [class.size-lg]="size === 'large'"
           [class.size-md]="size === 'medium'"
           [class.size-sm]="size === 'small'"
           [disabled]="disabled"
           nm-dropdown
           [dVisible]="visible"
           triggerEvent="click"
           [placeholder]="placeholder"
           [nmDropdownMenu]="calendarMenu"
           (dropdownOpen)="onDropDownChange($event)"
           [value]="inputValue">
    <nm-dropdown-menu #calendarMenu="nmDropdownMenu">
      <nm-calendar selection="single"
                   #nmCalendar
                   class="input-calendar__panel"
                   [dateValue]="currentValue"
                   (changeDate)="onChangeDate($event)"></nm-calendar>
    </nm-dropdown-menu>
  `,
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => NmInputCalendar_1),
                        multi: true
                    }
                ]
            }]
    }], function () { return []; }, { changeValue: [{
            type: Output
        }], placeholder: [{
            type: Input
        }], size: [{
            type: Input
        }], disabled: [{
            type: Input
        }], nmCalendar: [{
            type: ViewChild,
            args: ['nmCalendar']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiCalendarModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmCalendarComponent,
                    NmExtendedCalendarComponent,
                    NmSingleCalendarComponent,
                    NmInputCalendar
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    NomiaUiDropDownModule
                ],
                exports: [
                    NmCalendarComponent,
                    NmExtendedCalendarComponent,
                    NmSingleCalendarComponent,
                    NmInputCalendar
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiCalendarModule, { declarations: function () { return [NmCalendarComponent, NmExtendedCalendarComponent, NmSingleCalendarComponent, NmInputCalendar]; }, imports: function () { return [CommonModule,
        FormsModule, NomiaUiDropDownModule]; }, exports: function () { return [NmCalendarComponent, NmExtendedCalendarComponent, NmSingleCalendarComponent, NmInputCalendar]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TreeCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'nm-tree-checkbox',
                template: `
    <div class="tree__panel">
      <nm-node-checkbox *ngFor="let node of tree" [node]="node" (checkedNode)="onCheckedNode($event)"></nm-node-checkbox>
    </div>
  `
            }]
    }], function () { return []; }, { checkedNode: [{
            type: Output
        }], tree: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TreeNodeCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'nm-node-checkbox',
                template: `
    <div class="node-item-checkbox__panel"
         [class.node-item-checkbox__panel--active]="node?.isChecked">

      <nm-checkbox [ngModel]="node?.isChecked"
                   [nmIndeterminate]="node?.indeterminate"
                   (checkedChange)="onCheckedChange($event)"></nm-checkbox>

      <div class="node-item-checkbox__content">
        {{node.title}}
      </div>

      <button
        *ngIf="node.children && node.children.length > 0"
        type="button"
        class="node-item-checkbox__button"
        (click)="toggleChild($event)">
        <nm-svg-loader [class.node-item-checkbox__button--active]="node?.isExpanded" [iconName]="icons.arrowRightMediumDarkGray"></nm-svg-loader>
      </button>

    </div>

    <ng-template [ngIf]="node?.isExpanded && node.children && node.children.length > 0">
      <div class="node-item-checkbox-child__panel">
        <nm-tree-checkbox [tree]="node.children" (checkedNode)="onCheckedNode($event)"></nm-tree-checkbox>
      </div>
    </ng-template>
  `
            }]
    }], function () { return []; }, { checkedNode: [{
            type: Output
        }], node: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TreeNodeItemComponent, [{
        type: Component,
        args: [{
                selector: 'nm-node-item',
                template: `
    <div class="node__panel"
         (click)="selectNode()">
      <button
        *ngIf="node.children && node.children.length > 0"
        type="button"
        class="node__button"
        (click)="toggleChild($event)">
        <nm-svg-loader [class.node-item-checkbox__button--active]="node?.isExpanded" [iconName]="icons.arrowRightMediumDarkGray"></nm-svg-loader>
      </button>

      <button (click)="openDropDown($event)" class="button__t" nm-dropdown triggerEvent="click" [nmDropdownMenu]="dropDownMenu">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="7" r="1" transform="rotate(90 12 7)"></circle>
          <circle cx="12" cy="12" r="1" transform="rotate(90 12 12)"></circle>
          <circle cx="12" cy="17" r="1" transform="rotate(90 12 17)"></circle>
        </svg>
      </button>

      <div class="node__content">
        {{node.title}}
      </div>

      <div class="button__arrow">
        <button (click)="openDropDown($event)" class="button__t">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.134 7.5a1 1 0 011.732 0l4.33 7.5a1 1 0 01-.866 1.5H7.67a1 1 0 01-.866-1.5l4.33-7.5z"></path>
          </svg>
          <span>Вверх</span>
        </button>
        <button (click)="openDropDown($event)" class="button__t">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.134 16.5a1 1 0 001.732 0l4.33-7.5a1 1 0 00-.866-1.5H7.67A1 1 0 006.804 9l4.33 7.5z"></path>
          </svg>
          <span>Вниз</span>
        </button>
      </div>

      <div class="node__content-f">
        {{node?.price ? 'RUB ' + node.price : '' }}
      </div>

      <div class="left-border"
           [style.background-color]="node?.color"></div>
    </div>

    <ng-template [ngIf]="node?.isExpanded && node.children && node.children.length > 0">
      <div class="node-child__panel">
        <nm-item-tree [tree]="node.children" [dropDownMenu]="dropDownMenu"></nm-item-tree>
      </div>
    </ng-template>



  `
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { node: [{
            type: Input
        }], dropDownMenu: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TreeNodeComponent, [{
        type: Component,
        args: [{
                selector: 'nm-item-tree',
                template: `
    <div class="tree__panel">
      <nm-node-item *ngFor="let node of tree" [node]="node" [dropDownMenu]="dropDownMenu"></nm-node-item>
    </div>
  `
            }]
    }], null, { tree: [{
            type: Input
        }], dropDownMenu: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiTreeModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TreeCheckboxComponent,
                    TreeNodeCheckboxComponent,
                    TreeNodeItemComponent,
                    TreeNodeComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    NomiaUiIconSpriteModule,
                    NomiaUiFormModule,
                    NomiaUiDropDownModule
                ],
                exports: [
                    TreeCheckboxComponent,
                    TreeNodeCheckboxComponent,
                    TreeNodeItemComponent,
                    TreeNodeComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiTreeModule, { declarations: function () { return [TreeCheckboxComponent, TreeNodeCheckboxComponent, TreeNodeItemComponent, TreeNodeComponent]; }, imports: function () { return [CommonModule,
        FormsModule, NomiaUiIconSpriteModule, NomiaUiFormModule, NomiaUiDropDownModule]; }, exports: function () { return [TreeCheckboxComponent, TreeNodeCheckboxComponent, TreeNodeItemComponent, TreeNodeComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmCardComponent, [{
        type: Component,
        args: [{
                selector: 'nm-card-item',
                template: `
    <div class="card-item__top">
      <div class="d-flex direction-column card-item__top-left"  (click)="cardTopLeftClickEvent($event)">
        <ng-content select="[nm-card-item-top-left]"></ng-content>
      </div>

      <div class="d-flex card-item__top-right"  (click)="cardTopRightClickEvent($event)">
        <ng-content select="[nm-card-item-top-right]"></ng-content>
      </div>
    </div>

    <div class="card-item__bottom" >
      <div class="card-item__bottom-left" (click)="cardBottomLeftClickEvent($event)">
        <ng-content select="[nm-card-item-bottom-left]"></ng-content>
      </div>
      <div class="card-item__bottom-right" (click)="cardBottomRightClickEvent($event)">
        <ng-content select="[nm-card-item-bottom-right]"></ng-content>
      </div>
    </div>
  `,
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'card-item',
                    '[class.simple-card]': `cardType === 'simple'`,
                    '[class.universal-card]': `cardType === 'universal'`,
                    '[class.order-card]': `cardType === 'order'`,
                    '[class.unit-card]': `cardType === 'unit'`
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], cardType: [{
            type: Input
        }], cardTopLeftClick: [{
            type: Output
        }], cardBottomLeftClick: [{
            type: Output
        }], cardTopRightClick: [{
            type: Output
        }], cardBottomRightClick: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiCardModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmCardComponent
                ],
                imports: [],
                exports: [
                    NmCardComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiCardModule, { declarations: [NmCardComponent], exports: [NmCardComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmTagComponent, [{
        type: Component,
        args: [{
                selector: 'nm-tag',
                template: `

    <ng-template [ngIf]="!isCreator">
      <ng-content></ng-content>
      <div *ngIf="!hideDeleteButton" class="d-flex ml-1" (click)="tagDeleteEvent($event)">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0)">
            <path d="M2.9082 13.0911L13.0905 2.90873" stroke="#C3CEE0" stroke-linecap="round"/>
            <path d="M2.9082 2.90894L13.0905 13.0913" stroke="#C3CEE0" stroke-linecap="round"/>
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16" height="16" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </div>
    </ng-template>

    <ng-template [ngIf]="isCreator">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M7.99902 1.6001V14.4001" stroke="#22242C" stroke-linecap="round"/>
          <path d="M1.59961 8.00024L14.3996 8.00024" stroke="#22242C" stroke-linecap="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </ng-template>



  `,
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'tag-item',
                    '[class.tag__selected]': 'selected',
                    '[class.tag__creator]': 'isCreator'
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], selected: [{
            type: Input
        }], isCreator: [{
            type: Input
        }], hideDeleteButton: [{
            type: Input
        }], tagDelete: [{
            type: Output
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiTagsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmTagComponent
                ],
                imports: [
                    CommonModule
                ],
                exports: [
                    NmTagComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiTagsModule, { declarations: function () { return [NmTagComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NmTagComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmSlideBarComponent, [{
        type: Component,
        args: [{
                selector: 'nm-slide-bar',
                template: `
    <div class="sidebar__wrap"
         [ngClass]="className || ''"
         (mousedown)="mouseDown($event)"
         (mouseup)="mouseUp($event)"
         [class.sidebar--active]="state"
         [class.sidebar__wrap--small]="size === 'small'"
         [class.sidebar__wrap--medium]="size === 'medium'"
         [class.sidebar__wrap--large]="size === 'large'">
      <div class="sidebar"
           [class.sidebar__position--left]="position === 'left'"
           [class.sidebar__position--right]="position === 'right'"
           [class.sidebar__position--top]="position === 'top'"
           [class.sidebar__position--bottom]="position === 'bottom'">
        <div #sidebar class="sidebar__container">

          <ng-content></ng-content>

        </div>
      </div>
    </div>
  `,
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'nm__sidebar'
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { state: [{
            type: Input
        }], disabled: [{
            type: Input
        }], size: [{
            type: Input
        }], position: [{
            type: Input
        }], className: [{
            type: Input
        }], closeSideBar: [{
            type: Output
        }], sidebar: [{
            type: ViewChild,
            args: ['sidebar']
        }], title: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiSlideBarModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmSlideBarComponent
                ],
                imports: [
                    NomiaUiButtonModule,
                    CommonModule
                ],
                exports: [
                    NmSlideBarComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiSlideBarModule, { declarations: function () { return [NmSlideBarComponent]; }, imports: function () { return [NomiaUiButtonModule, CommonModule]; }, exports: function () { return [NmSlideBarComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmRangeSlideComponent, [{
        type: Component,
        args: [{
                selector: 'nm-slide-range',
                template: `
    <form [formGroup]="formGroup">
      <div class="range__wrapper">
        <div class="d-flex justify-space-between mb-1">
          <div class="mr-1 full">
            <nm-input-group>
              <nm-form-item label="Себестоимость:  "
                            size="small"
                            class="full"
                            [disabled]="disabledPrimePrice"
                            alertError="This is error message">
                <nm-calc #primePrice
                [formControlName]="'primePrice'" 
                [suffix]="'₽'" 
                (ngModelChange)="calcProfit(primePrice, salePrice)"></nm-calc>
              </nm-form-item>
            </nm-input-group>
          </div>

          <div class="full">
            <nm-input-group>
              <nm-form-item label="Цена:  "
                            size="small"
                            class="full"
                            [disabled]="disabledSalePrice"
                            alertError="This is error message">
                <nm-calc #salePrice
                        [formControlName]="'salePrice'"
                        [suffix]="'₽'"
                        (ngModelChange)="calcProfit(primePrice, salePrice)"></nm-calc>
              </nm-form-item>
            </nm-input-group>
          </div>
        </div>

        <div>
          <div class="margin__panel d-flex direction-column">
            <div><span class="margin-label">Маржа: </span></div>

            <div class="d-flex margin-value">
              <span class="range-value">{{profit}}%</span>
              <span style="margin: 0px .4rem"> = </span>
              <span> {{margin}} </span>
              <span class="currency-value"> ₽ </span>
            </div>

          </div>
        </div>

        <input
          class="range"
          #range
          type="range"
          min="1"
          max="100"
          step="1"
          [(ngModel)]="profit"
          (ngModelChange)="rangeChange(primePrice, range)"
          [ngModelOptions]="{ standalone: true }"
        />

      </div>

    </form>

    <div class="d-flex align-middle justify-space-between m-t">

      <div>
        0 %
      </div>

      <div>
        50 %
      </div>

      <div>
        99.9 %
      </div>

    </div>

  `,
                host: {
                    'class': 'full'
                },
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { disabledSalePrice: [{
            type: Input
        }], disabledPrimePrice: [{
            type: Input
        }], changeValue: [{
            type: Output
        }], formGroup: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiRangeSlideModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmRangeSlideComponent
                ],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    NomiaUiFormModule
                ],
                exports: [
                    NmRangeSlideComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiRangeSlideModule, { declarations: function () { return [NmRangeSlideComponent]; }, imports: function () { return [FormsModule,
        ReactiveFormsModule, NomiaUiFormModule]; }, exports: function () { return [NmRangeSlideComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmGoalsComponent, [{
        type: Component,
        args: [{
                selector: 'nm-goals',
                template: `
   
    <div class="d-flex align-middle justify-space-between">
      <div class="d-flex align-middle">
        <svg class="mr-1" width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 15.5L4 14M4 14V3.39903C4 1.88478 4 1.12765 4.49287 0.837644C4.98574 0.547636 5.64759 0.915329 6.97129 1.65071L14.1246 5.62478C15.6042 6.44677 16.344 6.85777 16.3262 7.46573C16.3085 8.07369 15.546 8.44083 14.0209 9.1751L4 14Z" stroke="#22242C" stroke-linecap="round"/>
          <circle cx="4" cy="20.5" r="3" stroke="#22242C" stroke-linecap="round"/>
        </svg>
        <div class="h2">
          <ng-content select="[nm-goal-title]"></ng-content>
        </div>
      </div>
      
      <div class="d-flex align-middle cursor-pointer" (click)="isExpand = !isExpand">
        <span class="mr-1">
          <ng-content select="[nm-goal-date-title]"></ng-content>
        </span>
        <svg [class.rotate180]="isExpand" width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12.625 0.875L9.82843 3.67157C8.49509 5.00491 7.82843 5.67157 7 5.67157C6.17157 5.67157 5.50491 5.00491 4.17157 3.67157L1.375 0.874999" stroke="#22242C" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
    
    <div class="task__panel--body" *ngIf="isExpand">

      <nm-goal-item  *ngFor="let item of goal.goals; let i = index;" 
                     [goal]="item" 
                     [index]="i+1" 
                     [disabled]="disabledAllGoals"
                     [hideIndex]="goal?.hideIndex"></nm-goal-item>
      
    </div>
    
  `,
                host: {
                    '[attr.disabledAllGoals]': 'disabledAllGoals || null',
                    'class': 'task__panel'
                },
                inputs: ['disabledAllGoals', 'color', 'size']
            }]
    }], function () { return []; }, { disabledAllGoals: [{
            type: Input
        }], goal: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmGoalItemComponent, [{
        type: Component,
        args: [{
                selector: 'nm-goal-item',
                template: `
   
   <div class="d-flex align-top task-item__el"
        [class.nm-task-item--active]="goal?.isComplete">
     <div class="mr-1" style="min-width: 14px">
       <span [hidden]="hideIndex">{{index}}.</span>
     </div>
     
     <div class="task-item__el--body">
       <div class="mb-1">{{goal.name}}</div>
       <!--<div class="d-flex">-->
         <!--<div class="taks-item__img-wr">-->
           <!--<img width="100%" src="assets/default-user-img.jpg" alt="">-->
         <!--</div>-->
         <!--<div class="taks-item__img-wr">-->
           <!--<img width="100%" src="assets/default-user-img.jpg" alt="">-->
         <!--</div>-->
         <!--<div class="taks-item__img-wr">-->
           <!--<img width="100%" src="assets/default-user-img.jpg" alt="">-->
         <!--</div>-->
       <!--</div>-->
     </div>
   </div>
    
    
    <div>
      <nm-checkbox [(ngModel)]="goal.isComplete" [disabled]="disabled || goal.disabled"></nm-checkbox>
    </div>
    
  `,
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'task__item'
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return []; }, { hideIndex: [{
            type: Input
        }], disabled: [{
            type: Input
        }], goal: [{
            type: Input
        }], index: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiGoalsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmGoalsComponent,
                    NmGoalItemComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    NomiaUiFormModule
                ],
                exports: [
                    NmGoalsComponent,
                    NmGoalItemComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiGoalsModule, { declarations: function () { return [NmGoalsComponent, NmGoalItemComponent]; }, imports: function () { return [CommonModule,
        FormsModule, NomiaUiFormModule]; }, exports: function () { return [NmGoalsComponent, NmGoalItemComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmLineGraphComponent, [{
        type: Component,
        args: [{
                selector: 'nm-line-graph',
                template: `
    <canvas #canvas width="{{width}}" height="{{height}}"></canvas>
  `
            }]
    }], function () { return []; }, { width: [{
            type: Input
        }], height: [{
            type: Input
        }], data: [{
            type: Input
        }], canvas: [{
            type: ViewChild,
            args: ['canvas', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiGraphicsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmLineGraphComponent
                ],
                imports: [],
                exports: [
                    NmLineGraphComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiGraphicsModule, { declarations: [NmLineGraphComponent], exports: [NmLineGraphComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmScrollDirective, [{
        type: Directive,
        args: [{
                selector: '[nmScroll]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { scrolled: [{
            type: Output
        }], scrolledUp: [{
            type: Output
        }], scrollDisabled: [{
            type: Input
        }], scrollDownDistance: [{
            type: Input
        }], scrollUpDistance: [{
            type: Input
        }], selectorContainer: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmScrollContentComponent, [{
        type: Component,
        args: [{
                selector: 'nm-scroll-content',
                template: `
    <div class="scroll__panel" #scrollElement>
      <div class="scrollable_inner" #scrollInner>
        <ng-content></ng-content>
      </div>
    </div>
    <div class="scroll-line" #scrollLine>
      <div class="progress" #scrollProgress>
      </div>
      <div class="bar" #scrollStick>
        <div class="bar__panel">
          <svg class="bar__item" width="2" height="12" viewBox="0 0 2 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2" height="12" rx="1" fill="#EDF1F8"/>
          </svg>
          <svg class="bar__item" width="2" height="12" viewBox="0 0 2 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2" height="12" rx="1" fill="#EDF1F8"/>
          </svg>
          <svg class="bar__item" width="2" height="12" viewBox="0 0 2 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="2" height="12" rx="1" fill="#EDF1F8"/>
          </svg>

        </div>
      </div>
    </div>
  `,
                host: {
                    '[class.scroll-line__top]': 'position === "top"'
                }
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }]; }, { position: [{
            type: Input
        }], scrollElement: [{
            type: ViewChild,
            args: ['scrollElement', { static: true }]
        }], scrollInner: [{
            type: ViewChild,
            args: ['scrollInner', { static: true }]
        }], scrollStick: [{
            type: ViewChild,
            args: ['scrollStick', { static: true }]
        }], scrollProgress: [{
            type: ViewChild,
            args: ['scrollProgress', { static: true }]
        }], scrollLine: [{
            type: ViewChild,
            args: ['scrollLine', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiScrollModule, [{
        type: NgModule,
        args: [{
                declarations: [NmScrollDirective, NmScrollContentComponent],
                exports: [NmScrollDirective, NmScrollContentComponent],
                imports: [],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiScrollModule, { declarations: [NmScrollDirective, NmScrollContentComponent], exports: [NmScrollDirective, NmScrollContentComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmAdviceComponent, [{
        type: Component,
        args: [{
                selector: 'nm-advice-item',
                template: `
    <div class="advice-item__body">
      <ng-content select="[nm-advice-body]"></ng-content>
    </div>
    
    <div class="advice-item__bottom">
      <ng-content select="[nm-advice-bottom]"></ng-content>
    </div>

    <div class="advice-arrow">
      <svg width="21" height="32" viewBox="0 0 21 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.40504 24.4874L18.7403 6.09899C20.4043 3.39975 21.2362 2.05012 20.6639 1.02506C20.0917 0 18.5062 0 15.3353 0H4C2.11438 0 1.17157 0 0.585786 0.585786C0 1.17157 0 2.11438 0 4V22.3884C0 28.1002 0 30.9561 1.45458 31.3684C2.90916 31.7807 4.40778 29.3496 7.40504 24.4874Z" fill="#EDF1F8"/>
      </svg>
    </div>

  `,
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'advice-item'
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiAdviceModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmAdviceComponent
                ],
                imports: [],
                exports: [
                    NmAdviceComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiAdviceModule, { declarations: [NmAdviceComponent], exports: [NmAdviceComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NmUploadImageMenuPositionComponent, [{
        type: Component,
        args: [{
                selector: 'nm-upload-position',
                template: `
    <input type="file" #file style="display: none" (change)="onFilesAdded()" [multiple]="multiple"/>

    <ng-template [ngIf]="previewSrc">
      <div class="upload-img__wr">
        <img width="100%" height="100%" [src]="previewSrc" alt="Добавленное фото">
      </div>

      <button class="button__img--delete"
              nm-button
              [color]="buttonColor"
              [shape]="buttonShape"
              size='medium'
              type="button"
              (click)="deleteFileEvent()">
        <div class="icon-item">
          <div class="icon-content">
            <svg width="20" height="20" viewBox="0.5 1 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.8506 3.14348C17.0459 3.33872 17.0459 3.65531 16.8507 3.85059L10.7041 9.99844L16.8507 16.1463C17.0459 16.3416 17.0459 16.6582 16.8506 16.8534C16.6554 17.0486 16.3388 17.0486 16.1435 16.8533L9.99708 10.7056L3.85359 16.8504C3.65835 17.0457 3.34177 17.0457 3.14648 16.8504C2.9512 16.6552 2.95117 16.3386 3.14641 16.1433L9.29005 9.99844L3.14641 3.85354C2.95117 3.65825 2.9512 3.34167 3.14648 3.14643C3.34177 2.95119 3.65835 2.95122 3.85359 3.1465L9.99708 9.29126L16.1435 3.14355C16.3388 2.94827 16.6553 2.94824 16.8506 3.14348Z" fill="#22242C"/>
            </svg>
          </div>
        </div>
      </button>
    </ng-template>

    <div *ngIf="!previewSrc" class="img-upload__panel" (click)="addFiles()">

      <div class="d-flex direction-column align-middle justify-center">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.4995 3C10.4995 2.72386 10.2757 2.5 9.99951 2.5C9.72337 2.5 9.49951 2.72386 9.49951 3V9.5H3C2.72386 9.5 2.5 9.72386 2.5 10C2.5 10.2761 2.72386 10.5 3 10.5H9.49951V17C9.49951 17.2761 9.72337 17.5 9.99951 17.5C10.2757 17.5 10.4995 17.2761 10.4995 17V10.5H17C17.2761 10.5 17.5 10.2761 17.5 10C17.5 9.72386 17.2761 9.5 17 9.5H10.4995V3Z" fill="#22242C"/>
        </svg>
        <span style="margin-bottom: 6px;">{{placeHolder}}</span>
      </div>

    </div>

  `,
                host: {
                    '[attr.disabled]': 'disabled || null',
                    'class': 'upload-position__panel'
                },
                inputs: ['disabled', 'color', 'size']
            }]
    }], function () { return []; }, { previewSrc: [{
            type: Input
        }], disabled: [{
            type: Input
        }], buttonColor: [{
            type: Input
        }], buttonShape: [{
            type: Input
        }], placeHolder: [{
            type: Input
        }], multiple: [{
            type: Input
        }], uploadFileChange: [{
            type: Output
        }], deleteFile: [{
            type: Output
        }], onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], file: [{
            type: ViewChild,
            args: ['file', { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiUploadFileModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NmUploadImageMenuPositionComponent
                ],
                imports: [
                    CommonModule,
                    NomiaUiButtonModule
                ],
                exports: [
                    NmUploadImageMenuPositionComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiUploadFileModule, { declarations: function () { return [NmUploadImageMenuPositionComponent]; }, imports: function () { return [CommonModule, NomiaUiButtonModule]; }, exports: function () { return [NmUploadImageMenuPositionComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NomiaUiLibModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    NomiaUiButtonModule,
                    NomiaUiDropDownModule,
                    NomiaUiSwitchModule,
                    NomiaUiTabsModule,
                    NomiaUiFormModule,
                    NomiaUiPinCodeModule,
                    NomiaUiTableModule,
                    NomiaUiScrollModule,
                    NomiaUiPopularItemModule,
                    NomiaUiPipeModule,
                    NomiaUiWrapperModule,
                    NomiaUiModalModule,
                    NomiaUiDirectivesModule,
                    NomiaUiCalendarModule,
                    NomiaUiTreeModule,
                    NomiaUiTagsModule,
                    NomiaUiCardModule,
                    NomiaUiSlideBarModule,
                    NomiaUiRangeSlideModule,
                    NomiaUiGoalsModule,
                    NomiaUiUploadFileModule,
                    NomiaUiGraphicsModule,
                    NomiaUiAdviceModule
                ],
                exports: [
                    NomiaUiButtonModule,
                    NomiaUiDropDownModule,
                    NomiaUiSwitchModule,
                    NomiaUiTabsModule,
                    NomiaUiFormModule,
                    NomiaUiPinCodeModule,
                    NomiaUiTableModule,
                    NomiaUiScrollModule,
                    NomiaUiPopularItemModule,
                    NomiaUiPipeModule,
                    NomiaUiWrapperModule,
                    NomiaUiModalModule,
                    NomiaUiDirectivesModule,
                    NomiaUiCalendarModule,
                    NomiaUiCardModule,
                    NomiaUiTagsModule,
                    NomiaUiAdviceModule,
                    NomiaUiSlideBarModule,
                    NomiaUiRangeSlideModule,
                    NomiaUiGoalsModule,
                    NomiaUiUploadFileModule,
                    NomiaUiGraphicsModule,
                    NomiaUiTreeModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NomiaUiLibModule, { imports: [NomiaUiButtonModule, NomiaUiDropDownModule, NomiaUiSwitchModule, NomiaUiTabsModule, NomiaUiFormModule, NomiaUiPinCodeModule, NomiaUiTableModule, NomiaUiScrollModule, NomiaUiPopularItemModule, NomiaUiPipeModule, NomiaUiWrapperModule, NomiaUiModalModule, NomiaUiDirectivesModule, NomiaUiCalendarModule, NomiaUiTreeModule, NomiaUiTagsModule, NomiaUiCardModule, NomiaUiSlideBarModule, NomiaUiRangeSlideModule, NomiaUiGoalsModule, NomiaUiUploadFileModule, NomiaUiGraphicsModule, NomiaUiAdviceModule], exports: [NomiaUiButtonModule, NomiaUiDropDownModule, NomiaUiSwitchModule, NomiaUiTabsModule, NomiaUiFormModule, NomiaUiPinCodeModule, NomiaUiTableModule, NomiaUiScrollModule, NomiaUiPopularItemModule, NomiaUiPipeModule, NomiaUiWrapperModule, NomiaUiModalModule, NomiaUiDirectivesModule, NomiaUiCalendarModule, NomiaUiCardModule, NomiaUiTagsModule, NomiaUiAdviceModule, NomiaUiSlideBarModule, NomiaUiRangeSlideModule, NomiaUiGoalsModule, NomiaUiUploadFileModule, NomiaUiGraphicsModule, NomiaUiTreeModule] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BaseModalComponent, ClickOutsideDirective, Currencies, CustomCurrencyPipe, DomService, DropdownService, ICONS, IconLoaderComponent, IconLoaderConfig, IconLoaderService, ModalContentDirective, ModalService, NmAdviceComponent, NmBaseInputDirective, NmButton, NmButtonBack, NmButtonTransparentDirective, NmCalcInputComponent, NmCalendarComponent, NmCardComponent, NmCellEditorComponent, NmCellWidthDirective, NmCheckBoxComponent, NmDropDownDirective, NmDropDownItemDirective, NmDropDownMenu, NmDropDownWrapDirective, NmExtendedCalendarComponent, NmFilledInputDirective, NmFormItemComponent, NmGoalItemComponent, NmGoalsComponent, NmInputCalendar, NmInputDirective, NmInputGroupComponent, NmLineGraphComponent, NmModalWrapperComponent, NmNoDataStubComponent, NmOptionComponent, NmOptionWrap, NmPinCodeComponent, NmRangeSlideComponent, NmScrollContentComponent, NmScrollDirective, NmSelectComponent, NmSelectSearchComponent, NmSingleCalendarComponent, NmSlideBarComponent, NmSwitch, NmTabActiveItemDirective, NmTabItem, NmTableComponent, NmTableContentComponent, NmTableInnerComponent, NmTableInnerScrollComponent, NmTableSortersComponent, NmTableStyleService, NmTabsContent, NmTabsGroup, NmTagComponent, NmTbodyComponent, NmTdEditorComponent, NmThItemComponent, NmTheadComponent, NmTrDirective, NmUploadImageMenuPositionComponent, NmWrapperComponent, NoCommasPipe, NomiaUiAdviceModule, NomiaUiButtonModule, NomiaUiCalendarModule, NomiaUiCardModule, NomiaUiDirectivesModule, NomiaUiDropDownModule, NomiaUiFormModule, NomiaUiGoalsModule, NomiaUiGraphicsModule, NomiaUiIconSpriteModule, NomiaUiLibModule, NomiaUiModalModule, NomiaUiPinCodeModule, NomiaUiPipeModule, NomiaUiPopularItemModule, NomiaUiRangeSlideModule, NomiaUiScrollModule, NomiaUiSlideBarModule, NomiaUiSwitchModule, NomiaUiTableModule, NomiaUiTabsModule, NomiaUiTagsModule, NomiaUiTreeModule, NomiaUiUploadFileModule, NomiaUiWrapperModule, OverlayComponent, PopularItemComponent, STAKE, TreeCheckboxComponent, TreeNode, TreeNodeCheckboxComponent, TreeNodeComponent, TreeNodeItemComponent, TabActiveService as ɵa };

